// Developer Credit
console.log(
    '%c 🚀 Developed by Karan Goyal %c\n' +
    '%c 📧 karangoyal360@gmail.com %c\n' +
    '%c 🌐 karangoyal.cc %c',
    'background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-size: 16px; font-weight: bold; padding: 12px 20px; border-radius: 8px 8px 0 0; text-shadow: 1px 1px 2px rgba(0,0,0,0.3);',
    '',
    'background: #2d3748; color: #68d391; font-size: 12px; padding: 8px 20px; font-family: monospace;',
    '',
    'background: #2d3748; color: #63b3ed; font-size: 12px; padding: 8px 20px; border-radius: 0 0 8px 8px; font-family: monospace; text-decoration: underline;',
    ''
);

// ===========================================
// TOAST NOTIFICATION (replaces native alert())
// ===========================================
function showToast(message, type) {
    type = type || 'error';
    var existing = document.getElementById('citymap-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'citymap-toast';
    toast.style.cssText = 'position:fixed;top:24px;left:50%;transform:translateX(-50%);z-index:99999;padding:14px 28px;border-radius:8px;font-family:Outfit,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;line-height:1.4;max-width:420px;width:max-content;text-align:center;box-shadow:0 8px 32px rgba(0,0,0,0.18);opacity:0;transition:opacity 0.3s,transform 0.3s;pointer-events:none;';
    if (type === 'error') {
        toast.style.background = '#16212c';
        toast.style.color = '#fff';
    } else {
        toast.style.background = '#fff';
        toast.style.color = '#16212c';
        toast.style.border = '1px solid #e0e0e0';
    }
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function() {
        toast.style.opacity = '1';
        toast.style.transform = 'translateX(-50%) translateY(0)';
    });
    setTimeout(function() {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-50%) translateY(-10px)';
        setTimeout(function() { toast.remove(); }, 300);
    }, 3500);
}

// ===========================================
// SERVER CONFIGURATION
// Set to true for local development, false for production
// ===========================================
const USE_LOCAL_SERVER = false;
const LOCAL_SERVER_URL = 'http://127.0.0.1:8000';
const PRODUCTION_SERVER_URL = 'https://tiles.distantlines.de';
const API_BASE_URL = USE_LOCAL_SERVER ? LOCAL_SERVER_URL : PRODUCTION_SERVER_URL;

// Query parameter support for print mode.
// PROJ-44: DLEditorSearch (Inline-Script der Section) liefert Presets bzw. den
// Original-Query VOR dem Geo-Cleanup der Adresszeile (Meta blockte lat/lng).
const urlParams = new URLSearchParams(window.DLEditorSearch || window.location.search);
const isPrintMode = urlParams.get('print') === 'true';
/* PROJ-99: Bearbeiten-Modus. Geprueft wird der PARAMETER, nicht window.DLCartEdit — der Helfer
   schaltet sich bei einer verschwundenen Zeile asynchron wieder ab, und diese Datei liest hier
   schon beim Laden. Ein `?edit=` heisst in JEDEM Fall: der Kunde kommt aus dem Warenkorb, also
   duerfen die Kampagnen-Presets der Section (`preset_params`, in 18 von 20 Stadtkarten-Templates
   gesetzt) NICHT greifen — sie wuerden Stil, Layout, Titel, Ort und (per setTimeout 1500 ms, also
   nach dem Zurueckladen) die Schrift ueberschreiben. */
/* Auch ein `?edit=` OHNE Wert und ein Modus, den cart-edit.js spaeter wieder abschaltet (Zeile
   verschwunden, Konfiguration nicht ladbar), gelten hier als Bearbeiten-Modus: dann startet der
   Editor neutral mit den Standardwerten statt mit der Kampagnen-Optik der Landeseite. Gewollt —
   wer aus dem Warenkorb kommt, soll im Zweifel seinen eigenen Stand sehen, nicht die Kampagne. */
const istBearbeitenModus = urlParams.get('edit') !== null;
const configData = urlParams.get('config');
const printDPI = parseInt(urlParams.get('dpi') || '300');
const printWidth = parseInt(urlParams.get('width') || '3937');  // pixels
const printHeight = parseInt(urlParams.get('height') || '5511'); // pixels

// Parse print config globally so it's accessible everywhere
let printConfig = null;
if (isPrintMode && configData) {
	try {
		printConfig = JSON.parse(atob(configData));
	} catch (e) {
	}
}

setTimeout(()=>{
	if($('div#map').height() > 500){
	$('.mapboxgl-map').css('max-height', ($('div#map').height()+'px'))
	}
}, 1500)

let map;
let map1; // First map for double layout
let map2; // Second map for double layout
let map1Triple; // First map for triple layout
let map2Triple; // Second map for triple layout
let map3Triple; // Third map for triple layout

// Store selected icon and color for each map
// markerSettings[mapId] = Einstellungen für den NÄCHSTEN neu gesetzten Marker (Panel-Zustand).
// Beim Auswählen eines vorhandenen Markers werden diese auf dessen Werte gesetzt.
let markerSettings = {
	'single':   { iconElement: null, color: '#E53422', size: 14 },
	'double-1': { iconElement: null, color: 'rgb(211, 59, 62)', size: 14 },
	'double-2': { iconElement: null, color: 'rgb(211, 59, 62)', size: 14 },
	'triple-1': { iconElement: null, color: 'rgb(211, 59, 62)', size: 14 },
	'triple-2': { iconElement: null, color: 'rgb(211, 59, 62)', size: 14 },
	'triple-3': { iconElement: null, color: 'rgb(211, 59, 62)', size: 14 }
};

// PROJ-25 Multi-Marker: mapMarkers[mapId] = Array platzierter Marker (beliebig viele pro Karte).
// Eintrag: { instance: mapboxgl.Marker, icon: <svg-html>|null, color, size }.
// selectedMarker[mapId] = Index des gerade ausgewählten Markers in mapMarkers[mapId] (oder -1).
let mapMarkers = {
	'single': [], 'double-1': [], 'double-2': [], 'triple-1': [], 'triple-2': [], 'triple-3': []
};
let selectedMarker = {
	'single': -1, 'double-1': -1, 'double-2': -1, 'triple-1': -1, 'triple-2': -1, 'triple-3': -1
};
// markerPlacementArmed[mapId]: Platzierung ist "one-shot" — nur solange true setzt ein Karten-Klick
// einen Marker; nach jedem gesetzten Marker wieder false, erneut scharf via Symbol-Klick/Toggle.
let markerPlacementArmed = {
	'single': false, 'double-1': false, 'double-2': false, 'triple-1': false, 'triple-2': false, 'triple-3': false
};
// lastPlacedMarker[mapId]: Index des zuletzt GESETZTEN Markers. Ein Tipp auf leere Karte (entschärft)
// verschiebt den ausgewählten Marker, sonst diesen — nie entsteht dabei ein neuer Marker (21.08.2026).
let lastPlacedMarker = {
	'single': -1, 'double-1': -1, 'double-2': -1, 'triple-1': -1, 'triple-2': -1, 'triple-3': -1
};
let isDoubleMapLayout = false; // Track if we're in double map mode
let isTripleMapLayout = false; // Track if we're in triple map mode
let currentLayout = 'default'; // Track current layout type (circle, heart, square, etc.)
let isReinitializing = false; // Track if map is currently being reinitialized
let reinitializeTimeout = null; // Debounce timer for reinitialize

let currentStyle = 'mapbox-cartida-white'; // Start with Minimalistic style
let baseStyleForCustom = 'minimal'; // Always use minimal as base for custom colors
let currentFont = 'Playfair Display'; // Start with Playfair Display font
let currentBorder = 'with'; // Default: with white border frame
let uploadedPhotoUrl = null; // Store S3 URL of uploaded photo
let uploadedPhotoData = null; // Legacy: base64 data (deprecated, kept for backward compatibility)
let loadedStyles = {};
let customColors = {
	land: '#F5F5DC',
	roads: '#FFFFFF',
	water: '#87CEEB',
	background: '#FFFFFF',
	buildings: '#D3D3D3',
	text: '#000000',
	box: '#FFFFFF'
};
let customColorsChanged = new Set(); // Track which colors user explicitly changed
// PROJ-25: currentMarkerIcon/Color/Size ersetzt durch markerSettings['single'] (Panel-Zustand),
// currentMarker ersetzt durch mapMarkers['single'] (Array). Deklarationen entfernt.

const MARKER_SIZES = [
	{ label: 'XS', value: 8 },
	{ label: 'S', value: 11 },
	{ label: 'M', value: 14 },
	{ label: 'L', value: 20 },
	{ label: 'XL', value: 26 }
];

function formatCoordsDMS(lat, lng) {
  const latDir = lat >= 0 ? 'N' : 'S';
  const lngDir = lng >= 0 ? 'O' : 'W';
  const absLat = Math.abs(lat);
  const absLng = Math.abs(lng);
  /* 60-Minuten-Uebertrag (Bug via PROJ-77-QA gefunden): Math.round liefert
     bei Bruchteil >= 0.99167° die Minute 60 — z. B. lat 52.9999 wurde als
     "52°60'N" statt "53°00'N" formatiert. Uebertrag ins Grad, exakt dieselbe
     Logik wie koordText() in jewelry-engine.js. */
  let latDeg = Math.floor(absLat);
  let latMin = Math.round((absLat - latDeg) * 60);
  if (latMin === 60) { latDeg += 1; latMin = 0; }
  let lngDeg = Math.floor(absLng);
  let lngMin = Math.round((absLng - lngDeg) * 60);
  if (lngMin === 60) { lngDeg += 1; lngMin = 0; }
  return `${latDeg}°${String(latMin).padStart(2,'0')}'${latDir} / ${lngDeg}°${String(lngMin).padStart(2,'0')}'${lngDir}`;
}

// Get crop modal text settings from data attributes
function getCropTexts() {
	const container = document.querySelector('.citymap-customizer');
	if (!container) {
		return {
			title: 'Foto zuschneiden',
			description: 'Ziehen Sie das Bild, um es zu positionieren, und nutzen Sie die Zoom-Steuerung, um die Größe anzupassen. Der kreisförmige Bereich zeigt an, was sichtbar sein wird.',
			zoomIn: '+ Vergrößern',
			zoomOut: '- Verkleinern',
			reset: 'Zurücksetzen',
			apply: 'Zuschnitt anwenden',
			cancel: 'Abbrechen',
			clickToAdd: 'Klicken, um Foto hinzuzufügen',
			changePhoto: 'Foto ändern',
			cropPhoto: 'Zuschneiden',
			removePhoto: 'Entfernen'
		};
	}
	return {
		title: container.dataset.cropTitle || 'Foto zuschneiden',
		description: container.dataset.cropDescription || 'Ziehen Sie das Bild, um es zu positionieren, und nutzen Sie die Zoom-Steuerung, um die Größe anzupassen. Der kreisförmige Bereich zeigt an, was sichtbar sein wird.',
		zoomIn: container.dataset.cropZoomIn || '+ Vergrößern',
		zoomOut: container.dataset.cropZoomOut || '- Verkleinern',
		reset: container.dataset.cropReset || 'Zurücksetzen',
		apply: container.dataset.cropApply || 'Zuschnitt anwenden',
		cancel: container.dataset.cropCancel || 'Abbrechen',
		clickToAdd: container.dataset.photoClickToAdd || 'Klicken, um Foto hinzuzufügen',
		changePhoto: container.dataset.photoChange || 'Foto ändern',
		cropPhoto: container.dataset.photoCrop || 'Zuschneiden',
		removePhoto: container.dataset.photoRemove || 'Entfernen'
	};
}

// Cropper.js instance
let cropper = null;

// Make cropper control functions globally available (defined early for onclick attributes)
window.zoomCropper = function(delta) {
	if (cropper) {
		cropper.zoom(delta);
	}
};

window.rotateCropper = function(degrees) {
	if (cropper) {
		cropper.rotate(degrees);
	}
};

window.resetCropper = function() {
	if (cropper) {
		cropper.reset();
		// Restore fixed crop box size after reset
		setTimeout(() => {
			if (cropper) {
				const containerData = cropper.getContainerData();
				cropper.setCropBoxData({
					width: 150,
					height: 150,
					left: (containerData.width - 150) / 2,
					top: (containerData.height - 150) / 2
				});
			}
		}, 100);
	}
};

 const container_fix = document.querySelector('.main__switcher');

    // Set initial active tab for CSS-driven Weiter/Cart visibility
    if (container_fix) {
        container_fix.setAttribute('data-active-tab', 'location__wrapper');
    }

// Map old style names to new final- prefixed file names
function getStyleFileName(styleName) {
    const styleMap = {
        'mapbox-cartida-white': 'final-minimalistic',
        'mapbox-charcoal-mono': 'final-charcoal',
        'mapbox-coral-pastel': 'final-coral-pastel',
        'mapbox-desert-sunset': 'final-desert-sunset',
        'mapbox-forest-tint': 'final-forest-tint',
        'mapbox-mediterranean-breeze': 'final-mediterranean-breeze',
        'mapbox-navy-night': 'final-navy-night',
        'mapbox-ocean-breeze': 'final-ocean-breeze',
        'mapbox-sandstone': 'final-sandstone',
        'mapbox-tropical-paradise': 'final-tropical-paradise',
        'mapbox-urban-explorer': 'final-urban-explorer',
        'mapbox-vintage-sepia': 'final-vintage-sepia',
        'minimal': 'final-minimalistic'
    };

    return styleMap[styleName] || styleName;
}

// S3 Upload Helper Functions
async function uploadPhotoToS3(blob, progressCallback) {
    try {
        // Show upload starting
        if (progressCallback) progressCallback(0, 'Upload wird vorbereitet...');

        // Step 1: Get presigned URL from backend
        const presignedResponse = await fetch(`${API_BASE_URL}/api/v1/upload/presigned-url/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                filename: 'photo.jpg',
                contentType: 'image/jpeg'
            })
        });

        if (!presignedResponse.ok) {
            throw new Error('Upload-URL konnte nicht abgerufen werden');
        }

        const presignedData = await presignedResponse.json();

        if (!presignedData.success) {
            throw new Error(presignedData.error || 'Upload-URL konnte nicht abgerufen werden');
        }

        if (progressCallback) progressCallback(20, 'Wird hochgeladen...');

        // Step 2: Upload to S3 using presigned POST
        const formData = new FormData();

        // Add all the fields from presigned response
        Object.keys(presignedData.fields).forEach(key => {
            formData.append(key, presignedData.fields[key]);
        });

        // Add the file itself (must be last)
        formData.append('file', blob, 'photo.jpg');

        // Upload with progress tracking
        const uploadResponse = await new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            // Track upload progress
            xhr.upload.addEventListener('progress', (e) => {
                if (e.lengthComputable && progressCallback) {
                    const percentComplete = 20 + Math.round((e.loaded / e.total) * 70); // 20-90%
                    progressCallback(percentComplete, 'Wird hochgeladen...');
                }
            });

            xhr.addEventListener('load', () => {
                if (xhr.status === 200 || xhr.status === 204) {
                    resolve(xhr);
                } else {
                    reject(new Error(`Upload fehlgeschlagen mit Status ${xhr.status}`));
                }
            });

            xhr.addEventListener('error', () => reject(new Error('Upload fehlgeschlagen')));
            xhr.addEventListener('abort', () => reject(new Error('Upload abgebrochen')));

            xhr.open('POST', presignedData.uploadUrl);
            xhr.send(formData);
        });

        if (progressCallback) progressCallback(95, 'Wird abgeschlossen...');

        // Step 3: Return the public URL
        if (progressCallback) progressCallback(100, 'Upload abgeschlossen!');

        return presignedData.publicUrl;

    } catch (error) {
        console.error('S3 upload error:', error);
        if (progressCallback) progressCallback(0, `Upload fehlgeschlagen: ${error.message}`);
        throw error;
    }
}

// Show upload progress UI
function showUploadProgress(percent, message) {
    let progressContainer = document.getElementById('photo-upload-progress');

    if (!progressContainer) {
        // Create progress container
        progressContainer = document.createElement('div');
        progressContainer.id = 'photo-upload-progress';
        progressContainer.style.cssText = `
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: white;
            padding: 30px;
            border-radius: 12px;
            box-shadow: 0 4px 20px rgba(0,0,0,0.15);
            z-index: 100002;
            min-width: 300px;
            text-align: center;
        `;
        document.body.appendChild(progressContainer);
    }

    progressContainer.innerHTML = `
        <div style="margin-bottom: 15px; font-size: 16px; font-weight: 600; color: #333;">
            ${message}
        </div>
        <div style="width: 100%; height: 8px; background: #e0e0e0; border-radius: 4px; overflow: hidden;">
            <div style="width: ${percent}%; height: 100%; background: linear-gradient(90deg, #4CAF50, #8BC34A); transition: width 0.3s ease;"></div>
        </div>
        <div style="margin-top: 10px; font-size: 14px; color: #666;">
            ${percent}%
        </div>
    `;

    // Auto-hide when complete
    if (percent >= 100) {
        setTimeout(() => {
            if (progressContainer && progressContainer.parentNode) {
                progressContainer.parentNode.removeChild(progressContainer);
            }
        }, 1500);
    }
}

// Function to load map styles from JSON files
async function loadMapStyle(styleName) {
    // Handle 'custom' style - use the saved base style and apply custom colors later
    if (styleName === 'custom') {
        return loadMapStyle(baseStyleForCustom);
    }

    if (loadedStyles[styleName]) {
        return loadedStyles[styleName];
    }

    try {
        const fileName = getStyleFileName(styleName);
        // Add cache-busting parameter to ensure fresh files
        const cacheBuster = Date.now();
        const response = await fetch(`https://cdn.shopify.com/s/files/1/0977/3672/0709/files/${fileName}.json?v=${cacheBuster}`);
        if (!response.ok) {
            throw new Error(`Failed to load ${fileName}.json`);
        }
        let styleText = await response.text();
        // V9.96.21: redirect stale tiles.starsinhands.com → tiles.distantlines.de.
        // Style-JSONs auf Shopify-CDN sind alte Versionen vom 2026-05-05 Security-
        // Commit, lokale assets/final-*.json sind schon korrekt. String-replace
        // bis CDN-Files neu hochgeladen werden.
        styleText = styleText.replace(/tiles\.starsinhands\.com/g, 'tiles.distantlines.de');
        const styleData = JSON.parse(styleText);
        loadedStyles[styleName] = styleData;
        return styleData;
    } catch (error) {
        return null;
    }
}

// Prefetch all map styles on page load for instant style switching
async function prefetchAllStyles() {
    const styleNames = [
        'mapbox-cartida-white',
        'mapbox-charcoal-mono',
        'mapbox-coral-pastel',
        'mapbox-desert-sunset',
        'mapbox-forest-tint',
        'mapbox-mediterranean-breeze',
        'mapbox-navy-night',
        'mapbox-ocean-breeze',
        'mapbox-sandstone',
        'mapbox-tropical-paradise',
        'mapbox-urban-explorer',
        'mapbox-vintage-sepia'
    ];

    const prefetchPromises = styleNames.map(styleName =>
        loadMapStyle(styleName).catch(err => {
        })
    );

    await Promise.all(prefetchPromises);
}

let mapStyles = {
	// New Mapbox styles from Shopify CDN
	'mapbox-cartida-white': 'mapbox-cartida-white', // Minimalistic
	'mapbox-vintage-sepia': 'mapbox-vintage-sepia', // Vintage Sepia
	'mapbox-ocean-breeze': 'mapbox-ocean-breeze', // Ocean Breeze
	'mapbox-desert-sunset': 'mapbox-desert-sunset', // Desert Sunset
	'mapbox-mediterranean-breeze': 'mapbox-mediterranean-breeze', // Mediterranean Breeze
	'mapbox-tropical-paradise': 'mapbox-tropical-paradise', // Tropical Paradise
	'mapbox-urban-explorer': 'mapbox-urban-explorer', // Urban Explorer
	'mapbox-coral-pastel': 'mapbox-coral-pastel', // Coral Pastel
	'mapbox-forest-tint': 'mapbox-forest-tint', // Forest Tint
	'mapbox-navy-night': 'mapbox-navy-night', // Navy Night
	'mapbox-sandstone': 'mapbox-sandstone', // Sandstone
	'mapbox-charcoal-mono': 'mapbox-charcoal-mono' // Charcoal Mono
};

// Mapbox access token - Get yours from https://account.mapbox.com/access-tokens/
mapboxgl.accessToken = 'pk.eyJ1IjoiZG9kbzc5MSIsImEiOiJjbWZianUyejEwNDNsMmpxdzBjZmZnbndtIn0.t5a9KzottI8eUYz396kfbQ';

/*
NOTE: The GlobeTee styles now use custom tile server at tiles.distantlines.de
Tile endpoint: https://tiles.distantlines.de/data/openmaptiles.json
- OpenMapTiles schema with zoom levels 0-14
- 162GB MBTiles database covering worldwide data
- Cached at Cloudflare edge with 30-day retention
- Nginx + TileServer-GL backend on CPX52 server

The styles are loaded dynamically from JSON files in the map-styles/ directory.
All 10 style files (minimal, beachglass, carbon, black, vintage, classic, pink, green, intense, atlas)
have been updated to use the new tile server.
*/

// ZOOM OFFSET FIX: Compensates for tileSize: 512 not working properly
// This makes our zoom 12 show zoom 13 data (where buildings exist)
const ZOOM_OFFSET = 1;

function applyPresetFromURL() {
	const preset = {
		style: urlParams.get('style'),
		layout: urlParams.get('layout'),
		city: urlParams.get('city'),
		lat: urlParams.get('lat'),
		lng: urlParams.get('lng'),
		title: urlParams.get('title'),
		subtitle: urlParams.get('subtitle'),
		zoom: urlParams.get('zoom')
	};

	if (!preset.style && !preset.layout && !preset.city && !preset.lat) return;

	// 1. Style anwenden — nur wenn er nicht ohnehin schon aktiv ist,
	// sonst laedt changeMapStyle() alle Kacheln ein zweites Mal.
	if (preset.style && mapStyles[preset.style] && currentStyle !== preset.style) {
		$('.elem__picker ul li a[data-style="' + preset.style + '"]')
			.closest('ul').find('.current').removeClass('current');
		$('.elem__picker ul li a[data-style="' + preset.style + '"]').addClass('current');
		changeMapStyle(preset.style);
	}

	// 2. Layout anwenden
	if (preset.layout) {
		const layoutReverseMap = {
			'default': 'house', 'square': 'square', 'circle': 'circle',
			'full-heart': 'heart', 'with-photo': 'with photo',
			'heart': 'valentine', 'double-map': 'double map', 'triple-map': 'triple map',
			'verlauf': 'verlauf', 'box': 'box'
		};
		const layoutText = layoutReverseMap[preset.layout];
		if (layoutText) {
			$('.design__info .elem__picker:first ul li a[data-layout="' + layoutText + '"]').click();
		}
	}

	// Helper: Titel/Untertitel setzen
	function applyTitleSubtitle() {
		if (preset.title) {
			$('#map-title-input').val(preset.title);
			$('#preview-title').text(preset.title);
			$('.map-preview-title h3').text(preset.title);
		}
		if (preset.subtitle) {
			$('#map-subtitle-input').val(preset.subtitle);
			$('#preview-subtitle').text(preset.subtitle);
			$('.map-preview-title p').text(preset.subtitle);
		}
		// V9.97.14: Font-size auto-adjust triggern (.val() feuert kein input-Event,
		// sonst würde der Handler bei Z7499 updatePreviewTitle() aufrufen)
		var t = preset.title || '';
		var s = preset.subtitle || '';
		if (typeof updatePosterTitle === 'function') updatePosterTitle(t, s);
		if (typeof updatePreviewTitle === 'function') updatePreviewTitle(t, s);
	}

	// 3. Font anwenden (nach Layout-Switch, mit Delay damit DOM aufgebaut ist)
	var presetFont = urlParams.get('font');
	if (presetFont) {
		setTimeout(function() {
			// Font-Picker-Link in der aktiven Layout-Sektion markieren
			var fontSelector = '.font__picker .font-options li a[data-font="' + presetFont + '"], ' +
				'.font__picker .font-options-grid li a[data-font="' + presetFont + '"], ' +
				'.double-font-picker li a[data-font="' + presetFont + '"], ' +
				'.triple-font-picker li a[data-font="' + presetFont + '"]';
			var fontLink = $(fontSelector);
			if (fontLink.length) {
				fontLink.closest('ul').find('.current').removeClass('current');
				fontLink.addClass('current');
			}
			applyFontToAllLayouts(presetFont);
		}, 1500);
	}

	// 4. Double-Map: beide Maps positionieren + Titel setzen
	if (preset.layout === 'double-map') {
		var lat2 = urlParams.get('lat2');
		var lng2 = urlParams.get('lng2');
		var zoom2 = urlParams.get('zoom2');
		var title2 = urlParams.get('title2');
		var subtitle2 = urlParams.get('subtitle2');
		var maintitle = urlParams.get('maintitle');

		// Beschriftung braucht keine fertige Karte — sofort setzen.
		// Vorher hing sie mit an der loaded()-Bedingung unten und kam deshalb nie an:
		// Schritt 1 ruft changeMapStyle() auf, danach meldet Mapbox dauerhaft
		// loaded() === false, das Intervall lief 10 s ins Leere und brach ab.
		if (preset.title) {
			$('#double-large-text-1').val(preset.title);
			$('.double-map-container .map-wrapper').eq(0).find('.map-label h3').text(preset.title);
		}
		if (preset.subtitle) {
			$('#double-small-text-1').val(preset.subtitle);
			$('.double-map-container .map-wrapper').eq(0).find('.map-label p').text(preset.subtitle);
		}
		if (title2) {
			$('#double-large-text-2').val(title2);
			$('.double-map-container .map-wrapper').eq(1).find('.map-label h3').text(title2);
		}
		if (subtitle2) {
			$('#double-small-text-2').val(subtitle2);
			$('.double-map-container .map-wrapper').eq(1).find('.map-label p').text(subtitle2);
		}
		if (maintitle) {
			$('#double-main-title').val(maintitle);
			$('.double-map-title h2').text(maintitle);
		}

		// Positionierung wartet nur noch darauf, dass die Map-Objekte existieren.
		// jumpTo() puffert Mapbox selbst, wenn der Stil noch lädt.
		var waitForMaps = setInterval(function() {
			if (map1 && map2) {
				clearInterval(waitForMaps);

				// Map 1 positionieren
				if (preset.lat && preset.lng) {
					map1.jumpTo({
						center: [parseFloat(preset.lng), parseFloat(preset.lat)],
						zoom: preset.zoom ? parseFloat(preset.zoom) : 12
					});
				}
				// Map 2 positionieren
				if (lat2 && lng2) {
					map2.jumpTo({
						center: [parseFloat(lng2), parseFloat(lat2)],
						zoom: zoom2 ? parseFloat(zoom2) : 12
					});
				}
			}
		}, 300);
		setTimeout(function() { clearInterval(waitForMaps); }, 10000);
		return; // Skip single-map logic
	}

	// 5. Single-Map: Exakte Koordinaten oder Stadt-Suche
	if (preset.lat && preset.lng) {
		var coords = [parseFloat(preset.lng), parseFloat(preset.lat)];
		var zoomLevel = preset.zoom ? parseFloat(preset.zoom) : 12;
		map.jumpTo({ center: coords, zoom: zoomLevel });
		applyTitleSubtitle();
	} else if (preset.city) {
		searchLocation(preset.city, true).then(function() {
			applyTitleSubtitle();
			if (preset.zoom) {
				map.setZoom(parseFloat(preset.zoom));
			}
		});
	} else {
		applyTitleSubtitle();
	}
}

async function initializeMap() {

	// Check if container exists
	const mapContainer = document.getElementById('map');
	if (!mapContainer) {
		return;
	}

	// Remove loading state
	mapContainer.classList.remove('map-loading');

	// Clear any existing content in map container (fixes Mapbox GL warning)
	mapContainer.innerHTML = '';

	// Load local JSON style instead of Mapbox URL
	// Preset-Stil schon hier uebernehmen (analog zur Doppelkarte): sonst baut die
	// Karte im Standardstil auf und changeMapStyle() laedt gleich danach alle
	// Kacheln erneut — sichtbar als zweiter Ladevorgang beim Sprung von der PDP.
	// Position nutzt die Preset-Werte weiter unten bereits.
	// PROJ-99: im Bearbeiten-Modus KEIN Preset-Stil — er setzt currentStyle, und wenn die
	// Config zufaellig den Stil der schon markierten Kachel traegt, klickt konfigurationAnwenden()
	// nicht nach; currentStyle bliebe auf dem Kampagnenwert stehen.
	const presetStyleSingle = istBearbeitenModus ? null : urlParams.get('style');
	if (presetStyleSingle && mapStyles[presetStyleSingle]) currentStyle = presetStyleSingle;
	const styleName = mapStyles[currentStyle] || currentStyle;
	const styleToUse = await loadMapStyle(styleName);

	// printConfig is now parsed globally at top of file

	// Determine initial center and zoom — use URL params if present to avoid location flash
	const urlLat = urlParams.get('lat');
	const urlLng = urlParams.get('lng');
	const urlZoom = urlParams.get('zoom');
	const initialCenter = (printConfig && printConfig.center) ? printConfig.center
		: (urlLat && urlLng) ? [parseFloat(urlLng), parseFloat(urlLat)]
		: [10.5226, 52.2644];
	const initialZoom = (printConfig && printConfig.zoom) ? printConfig.zoom
		: urlZoom ? parseFloat(urlZoom)
		: 12;
	// Use mapStyles mapping to get actual style file (e.g., 'custom' -> 'minimal')
	const initialStyle = (printConfig && printConfig.style) ? await loadMapStyle(mapStyles[printConfig.style] || 'minimal') : styleToUse;

	try {
		map = new mapboxgl.Map({
			container: 'map',
			style: initialStyle,
			center: initialCenter,
			zoom: initialZoom + ZOOM_OFFSET, // Apply zoom offset to show buildings at lower display zoom
			pixelRatio: 4,
			maxZoom: 22, // Allow maximum zoom for detailed views
			minZoom: 4, // Allow zooming out to see buildings from zoom 5
			antialias: true, // Enable antialiasing for smoother edges
			optimizeForTerrain: false, // Disable terrain optimization for sharper vector tiles
			renderWorldCopies: false, // Optimize performance
			fadeDuration: 0, // Disable fade for immediate tile rendering
			crossSourceCollisions: false, // Improve label clarity
			preserveDrawingBuffer: true, // Better screenshot quality
			dragRotate: false, // Disable rotation by dragging
			touchPitch: false, // Disable tilt on touch devices
			pitchWithRotate: false // Disable pitch when rotating
		});

		// Disable touch rotation (two-finger twist) — rotation not reflected in print file
		map.touchZoomRotate.disableRotation();

		map.on('load', function() {

			// Force map container to be visible
			const mapContainer = document.getElementById('map');
			mapContainer.style.display = 'block';
			mapContainer.style.visibility = 'visible';
			mapContainer.style.opacity = '1';
			// Border: no-border class on #map hides ::before pseudo-element (white frame)
			if (currentBorder === 'without') {
				mapContainer.classList.add('no-border');
			}
			// Don't set width to 100% - let resizeFrame() handle dimensions
			// mapContainer.style.height = '640px';

			// Check if map canvas exists
			const canvas = mapContainer.querySelector('canvas');
			if (canvas) {
				canvas.style.display = 'block';
				canvas.style.visibility = 'visible';
			}

			// Apply custom colors if current style is custom
			if (currentStyle === 'custom' || styleName === 'custom') {
				setTimeout(function() {
					applyCustomMapColorsToInstance(map);
				}, 100);
			}

			// Ensure proper dimensions after map loads
			resizeFrame();

				// Add navigation controls (hidden — custom zoom buttons are outside #map)
				map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');

				// Add geolocation control
				map.addControl(new mapboxgl.GeolocateControl({
					positionOptions: {
						enableHighAccuracy: true
					},
					trackUserLocation: true
				}), 'top-right');

				// Create custom zoom controls outside #map (so they don't cover the map)
				if (!isPrintMode) {
					var $canvasWrapper = $('.canvas__wrapper');
					if ($canvasWrapper.find('.map-zoom-controls').length === 0) {
						var $zoomControls = $('<div class="map-zoom-controls">' +
							'<button type="button" class="map-zoom-in" aria-label="Zoom in">+</button>' +
							'<button type="button" class="map-zoom-out" aria-label="Zoom out">−</button>' +
							'</div>');
						$canvasWrapper.append($zoomControls);
						$zoomControls.find('.map-zoom-in').on('click', function() { map.zoomIn(); });
						$zoomControls.find('.map-zoom-out').on('click', function() { map.zoomOut(); });
					}
				}
	
				// V9.99.9 fix: addPosterTitleOverlay() ZUERST, dann updateTitleFields.
				// Sonst zeigt .poster-title hardcoded "MIAMI" (Z4471) weil updateTitleFields
				// versucht ein noch nicht existierendes .poster-title-Element zu updaten.
				addPosterTitleOverlay();

				// Update title fields (defaults to Braunschweig if no URL preset)
				if (!isPrintMode && !urlParams.get('city') && !urlParams.get('lat')) {
					updateTitleFields('Braunschweig', [10.5226, 52.2644]);
				} else if (printConfig && printConfig.title) {
					updateTitleFields(printConfig.title.text || '', initialCenter);
				}

				// Apply default font to single map poster text on initial load
				// (Don't use applyFontToAllLayouts here — it would override Double/Triple defaults)
				$('.map-preview-title h3, .map-preview-title p, #preview-title, #preview-subtitle').css('font-family', '"Playfair Display", serif');

				// Apply preset from URL parameters (for product links).
				// FOUC-Fix: setTimeout(500) → 0 — URL-Params sind Server-Daten, kein Layout-Wait nötig.
				// PROJ-99: im Bearbeiten-Modus uebersprungen — dort gewinnt der gespeicherte
				// Zustand der Warenkorbzeile, nicht das Kampagnen-Preset der Landeseite.
				if (!isPrintMode && !istBearbeitenModus) {
					applyPresetFromURL();
				}

				// Prefetch all map styles in background for instant style switching
				prefetchAllStyles();
			});

		map.on('error', function(e) {

			// Check if it's a token-related error
			if (e.error && e.error.message && e.error.message.includes('accessToken')) {
				createTokenSetupMessage();
			} else {
				console.warn('Map error:', e.error ? e.error.message : 'Unknown error');
				// The setTimeout check will handle retries
			}
		});

		map.on('styleerror', function(e) {
		});

	} catch (error) {

		// Check if it's a token-related error
		if (error.message && error.message.includes('accessToken')) {
			createTokenSetupMessage();
		} else {
			console.warn('Error initializing map:', error.message);
			// The setTimeout check will handle retries
		}
	}
}

// Function to initialize double map layout
async function initializeDoubleMaps() {
	
	const map1Container = document.getElementById('map1');
	const map2Container = document.getElementById('map2');
	
	if (!map1Container || !map2Container) {
		return;
	}
	
	// Remove loading state
	map1Container.classList.remove('map-loading');
	map2Container.classList.remove('map-loading');

	// Load the current style (or fallback to Minimal)
	// Preset schon beim Aufbau verwenden: sonst startet die Karte im Standardstil
	// auf den Standardorten und springt danach sichtbar um, wobei changeMapStyle()
	// saemtliche Kacheln ein zweites Mal laedt.
	// PROJ-99: dito fuer Doppel-/Dreifachkarte (siehe initializeMap).
	const presetStyleKey = istBearbeitenModus ? null : urlParams.get('style');
	if (presetStyleKey && mapStyles[presetStyleKey]) currentStyle = presetStyleKey;
	const _pf = function (v) { var n = parseFloat(v); return isFinite(n) ? n : null; };
	const pLat = _pf(urlParams.get('lat')),   pLng = _pf(urlParams.get('lng'));
	const pZoom = _pf(urlParams.get('zoom'));
	const pLat2 = _pf(urlParams.get('lat2')), pLng2 = _pf(urlParams.get('lng2'));
	const pZoom2 = _pf(urlParams.get('zoom2'));

	const styleKey = currentStyle || 'minimal';
	const styleConfig = mapStyles[styleKey] || mapStyles['minimal'];
	// Load local JSON style
	const styleToUse = await loadMapStyle(styleConfig) || await loadMapStyle('minimal');

	try {
		// Initialize first map (e.g., Sophia's location)
		map1 = new mapboxgl.Map({
			container: 'map1',
			style: styleToUse,
			center: (pLat !== null && pLng !== null) ? [pLng, pLat] : [10.5226, 52.2644], // sonst Braunschweig
			zoom: pZoom !== null ? pZoom : 12,
			pixelRatio: Math.min(window.devicePixelRatio * 2, 4),
			maxZoom: 22,
			minZoom: 8,
			antialias: true,
			optimizeForTerrain: false,
			renderWorldCopies: false,
			fadeDuration: 0,
			crossSourceCollisions: false,
			dragRotate: false,
			touchPitch: false,
			pitchWithRotate: false
		});
		map1.touchZoomRotate.disableRotation();

		// Initialize second map (e.g., Michael's location)
		map2 = new mapboxgl.Map({
			container: 'map2',
			style: styleToUse,
			center: (pLat2 !== null && pLng2 !== null) ? [pLng2, pLat2] : [-0.1276, 51.5074], // sonst London
			zoom: pZoom2 !== null ? pZoom2 : 12,
			pixelRatio: Math.min(window.devicePixelRatio * 2, 4),
			maxZoom: 22,
			minZoom: 8,
			antialias: true,
			optimizeForTerrain: false,
			renderWorldCopies: false,
			fadeDuration: 0,
			crossSourceCollisions: false,
			dragRotate: false,
			touchPitch: false,
			pitchWithRotate: false
		});
		map2.touchZoomRotate.disableRotation();


		// Set up first map
		map1.on('load', function() {

			// Add navigation controls to map1
			map1.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-left');

			// Apply custom colors if current style is custom
			if (currentStyle === 'custom' || styleKey === 'custom') {
				setTimeout(function() {
					applyCustomMapColorsToInstance(map1);
				}, 100);
			}

			// Apply background color after map loads
			setTimeout(function() {
				applyBackgroundColorToAllElements();
			}, 100);

		});

		// Set up second map
		map2.on('load', function() {

			// Add navigation controls to map2
			map2.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-left');

			// Apply custom colors if current style is custom
			if (currentStyle === 'custom' || styleKey === 'custom') {
				setTimeout(function() {
					applyCustomMapColorsToInstance(map2);
				}, 100);
			}

			// Apply background color after map loads
			setTimeout(function() {
				applyBackgroundColorToAllElements();
			}, 100);


			// Prefetch all map styles in background for instant style switching
			prefetchAllStyles();
		});
		
		// Error handlers
		map1.on('error', function(e) {
		});
		
		map2.on('error', function(e) {
		});
		
	} catch (error) {
	}
}

// Function to initialize triple map layout
async function initializeTripleMaps() {

	const map1Container = document.getElementById('map1-triple');
	const map2Container = document.getElementById('map2-triple');
	const map3Container = document.getElementById('map3-triple');

	if (!map1Container || !map2Container || !map3Container) {
		return;
	}

	// Remove loading state
	map1Container.classList.remove('map-loading');
	map2Container.classList.remove('map-loading');
	map3Container.classList.remove('map-loading');

	// Load the current style (or fallback to Minimal)
	const styleKey = currentStyle || 'minimal';
	const styleConfig = mapStyles[styleKey] || mapStyles['minimal'];
	// Load local JSON style
	const styleToUse = await loadMapStyle(styleConfig) || await loadMapStyle('minimal');

	try {
		// Initialize first map
		map1Triple = new mapboxgl.Map({
			container: 'map1-triple',
			style: styleToUse,
			center: [10.5226, 52.2644], // Default: Braunschweig
			zoom: 12,
			pixelRatio: Math.min(window.devicePixelRatio * 2, 4),
			maxZoom: 22,
			minZoom: 8,
			antialias: true,
			optimizeForTerrain: false,
			renderWorldCopies: false,
			fadeDuration: 0,
			crossSourceCollisions: false,
			dragRotate: false,
			touchPitch: false,
			pitchWithRotate: false
		});
		map1Triple.touchZoomRotate.disableRotation();

		// Initialize second map
		map2Triple = new mapboxgl.Map({
			container: 'map2-triple',
			style: styleToUse,
			center: [-0.1276, 51.5074], // Default: London
			zoom: 12,
			pixelRatio: Math.min(window.devicePixelRatio * 2, 4),
			maxZoom: 22,
			minZoom: 8,
			antialias: true,
			optimizeForTerrain: false,
			renderWorldCopies: false,
			fadeDuration: 0,
			crossSourceCollisions: false,
			dragRotate: false,
			touchPitch: false,
			pitchWithRotate: false
		});
		map2Triple.touchZoomRotate.disableRotation();

		// Initialize third map
		map3Triple = new mapboxgl.Map({
			container: 'map3-triple',
			style: styleToUse,
			center: [139.6917, 35.6895], // Default: Tokyo
			zoom: 12,
			pixelRatio: Math.min(window.devicePixelRatio * 2, 4),
			maxZoom: 22,
			minZoom: 8,
			antialias: true,
			optimizeForTerrain: false,
			renderWorldCopies: false,
			fadeDuration: 0,
			crossSourceCollisions: false,
			dragRotate: false,
			touchPitch: false,
			pitchWithRotate: false
		});
		map3Triple.touchZoomRotate.disableRotation();


		// Set up first map
		map1Triple.on('load', function() {
			map1Triple.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-left');

			// Apply custom colors if current style is custom
			if (currentStyle === 'custom' || styleKey === 'custom') {
				setTimeout(function() {
					applyCustomMapColorsToInstance(map1Triple);
				}, 100);
			}

			// Apply background color after map loads
			setTimeout(function() {
				applyBackgroundColorToAllElements();
			}, 100);
		});

		// Set up second map
		map2Triple.on('load', function() {
			map2Triple.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-left');

			// Apply custom colors if current style is custom
			if (currentStyle === 'custom' || styleKey === 'custom') {
				setTimeout(function() {
					applyCustomMapColorsToInstance(map2Triple);
				}, 100);
			}

			// Apply background color after map loads
			setTimeout(function() {
				applyBackgroundColorToAllElements();
			}, 100);
		});

		// Set up third map
		map3Triple.on('load', function() {
			map3Triple.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-left');

			// Apply custom colors if current style is custom
			if (currentStyle === 'custom' || styleKey === 'custom') {
				setTimeout(function() {
					applyCustomMapColorsToInstance(map3Triple);
				}, 100);
			}

			// Apply background color after map loads
			setTimeout(function() {
				applyBackgroundColorToAllElements();
			}, 100);

			// Prefetch all map styles in background for instant style switching
			prefetchAllStyles();
		});

		// Error handlers
		map1Triple.on('error', function(e) {
		});

		map2Triple.on('error', function(e) {
		});

		map3Triple.on('error', function(e) {
		});

	} catch (error) {
	}
}

$('#triple-map-main-title').on('input', function() {
	const tripleMapTitle = document.querySelector('.triple-map-title h2');
	if (tripleMapTitle) {
		tripleMapTitle.textContent = this.value;
	}
});

// Function to switch between single, double, and triple map layouts
function switchMapLayout(isDouble, isTriple = false) {
	const singleView = document.querySelector('.single-map-view');
	const doubleView = document.querySelector('.double-map-view');
	const tripleView = document.querySelector('.triple-map-view');
	const singleDetails = document.querySelector('.details__wrapper');
	const doubleDetails = document.querySelector('.details__wrapper--double');
	const tripleDetails = document.querySelector('.details__wrapper--triple');
	
	if (!singleView || !doubleView) {
		return;
	}
	
	if (isDouble) {
		isDoubleMapLayout = true;
		isTripleMapLayout = false;

		// Hide other views
		if (singleView) singleView.style.display = 'none';
		if (doubleView) doubleView.style.display = 'flex';
		if (tripleView) tripleView.style.display = 'none';
		$('.map-zoom-controls').hide();

		// Custom double zoom controls (outside the poster)
		if (!isPrintMode) {
			var $cw = $('.canvas__wrapper');
			$cw.find('.double-map-zoom-left, .double-map-zoom-right').remove();
			var $zoomLeft = $('<div class="double-map-zoom-left">' +
				'<button type="button" aria-label="Zoom in">+</button>' +
				'<button type="button" aria-label="Zoom out">−</button>' +
				'</div>');
			var $zoomRight = $('<div class="double-map-zoom-right">' +
				'<button type="button" aria-label="Zoom in">+</button>' +
				'<button type="button" aria-label="Zoom out">−</button>' +
				'</div>');
			$cw.append($zoomLeft);
			$cw.append($zoomRight);
			setTimeout(function() {
				$zoomLeft.find('button:first').on('click', function() { if(map1) map1.zoomIn(); });
				$zoomLeft.find('button:last').on('click', function() { if(map1) map1.zoomOut(); });
				$zoomRight.find('button:first').on('click', function() { if(map2) map2.zoomIn(); });
				$zoomRight.find('button:last').on('click', function() { if(map2) map2.zoomOut(); });
			}, 200);
		}

		// Switch details panels - ensure complete hide/show
		if (singleDetails) {
			singleDetails.style.display = 'none';
			// Also hide any marker info sections in single layout
			$(singleDetails).find('.marker__info').hide();
			// Uncheck single layout marker checkbox to prevent conflicts
			$(singleDetails).find('.map__marker input[type="checkbox"]').prop('checked', false);
			// Remove any existing single map markers
			clearSingleMarkers();
		}
		if (doubleDetails) {
			// Keep it hidden initially - will show when user clicks Details tab
			doubleDetails.style.display = 'none';
			// Hide marker info sections in double layout by default
			$(doubleDetails).find('.marker__info').hide();
		}
		if (tripleDetails) {
			tripleDetails.style.display = 'none';
		}

		// Update main title in double map view
		const mainTitleInput = document.getElementById('double-main-title');
		const doubleMapTitle = document.querySelector('.double-map-title h2');
		if (mainTitleInput && doubleMapTitle) {
			doubleMapTitle.textContent = mainTitleInput.value;
		}

		// Destroy other maps if they exist
		if (map) {
			map.remove();
			map = null;
			mapMarkers['single'] = [];
		}
		if (map1Triple) {
			map1Triple.remove();
			map1Triple = null;
		}
		if (map2Triple) {
			map2Triple.remove();
			map2Triple = null;
		}
		if (map3Triple) {
			map3Triple.remove();
			map3Triple = null;
		}

		// Initialize double maps if not already initialized
		if (!map1 || !map2) {
			setTimeout(() => {
				initializeDoubleMaps();
				// Apply current style and font after maps are initialized
				setTimeout(() => {
					applyCurrentStyleAndFont();
				}, 500);
			}, 100);
		} else {
			// Resize existing maps
			setTimeout(() => {
				if (map1) map1.resize();
				if (map2) map2.resize();
				// Apply current style and font
				applyCurrentStyleAndFont();
			}, 150);
		}

		// Force landscape orientation for double map
		resizeType = "landscape";

	} else if (isTriple) {
		isTripleMapLayout = true;
		isDoubleMapLayout = false;

		// Hide other views
		if (singleView) singleView.style.display = 'none';
		if (doubleView) doubleView.style.display = 'none';
		if (tripleView) tripleView.style.display = 'flex';
		$('.map-zoom-controls').hide();

		// Switch details panels
		if (singleDetails) {
			singleDetails.style.display = 'none';
			$(singleDetails).find('.marker__info').hide();
			$(singleDetails).find('.map__marker input[type="checkbox"]').prop('checked', false);
			clearSingleMarkers();
		}
		if (doubleDetails) {
			doubleDetails.style.display = 'none';
			$(doubleDetails).find('.marker__info').hide();
		}
		if (tripleDetails) {
			// Keep it hidden initially - will show when user clicks Details tab
			tripleDetails.style.display = 'none';
			$(tripleDetails).find('.marker__info').hide();
		}

		// Update main title in triple map view
		const mainTitleInput = document.getElementById('triple-map-main-title');
		const tripleMapTitle = document.querySelector('.triple-map-title h2');
		if (mainTitleInput && tripleMapTitle) {
			tripleMapTitle.textContent = mainTitleInput.value;
		}

		// Destroy other maps
		if (map) {
			map.remove();
			map = null;
			mapMarkers['single'] = [];
		}
		if (map1) {
			map1.remove();
			map1 = null;
		}
		if (map2) {
			map2.remove();
			map2 = null;
		}

		// Initialize triple maps if not already initialized
		if (!map1Triple || !map2Triple || !map3Triple) {
			setTimeout(() => {
				initializeTripleMaps();
				// Apply current style and font after maps are initialized
				setTimeout(() => {
					applyCurrentStyleAndFont();
				}, 500);
			}, 100);
		} else {
			// Resize existing maps
			setTimeout(() => {
				if (map1Triple) map1Triple.resize();
				if (map2Triple) map2Triple.resize();
				if (map3Triple) map3Triple.resize();
				// Apply current style and font
				applyCurrentStyleAndFont();
			}, 150);
		}

		// Force landscape orientation for triple map
		resizeType = "landscape";

	} else {
		isDoubleMapLayout = false;
		isTripleMapLayout = false;

		// Show single map view
		if (singleView) singleView.style.display = 'block';
		$('.map-zoom-controls').show();

		// Hide other views
		if (doubleView) doubleView.style.display = 'none';
		if (tripleView) tripleView.style.display = 'none';

		// Switch details panels - only show if NOT on Design tab
		const currentTab = $('.main__switcher ul li a.current').attr('data-tab');
		if (singleDetails) {
			// Only show details__wrapper if on location or markers tab
			if (currentTab === 'location__wrapper' || currentTab === 'markers__wrapper') {
				singleDetails.style.display = 'block';
			} else {
				singleDetails.style.display = 'none';
			}
			// Hide marker info sections in single layout by default
			$(singleDetails).find('.marker__info').hide();
		}
		if (doubleDetails) {
			doubleDetails.style.display = 'none';
			// Also hide marker info in double layout and uncheck checkboxes
			$(doubleDetails).find('.marker__info').hide();
			$(doubleDetails).find('.map__marker input[type="checkbox"]').prop('checked', false);
			$(doubleDetails).find('.map__title input[type="checkbox"]').prop('checked', false);
			$(doubleDetails).find('.content').hide();
		}
		if (tripleDetails) {
			tripleDetails.style.display = 'none';
			$(tripleDetails).find('.marker__info').hide();
			$(tripleDetails).find('.map__marker input[type="checkbox"]').prop('checked', false);
			$(tripleDetails).find('.map__title input[type="checkbox"]').prop('checked', false);
			$(tripleDetails).find('.content').hide();
		}

		// Destroy double maps if they exist
		if (map1) {
			map1.remove();
			map1 = null;
		}
		if (map2) {
			map2.remove();
			map2 = null;
		}

		// Destroy triple maps if they exist
		if (map1Triple) {
			map1Triple.remove();
			map1Triple = null;
		}
		if (map2Triple) {
			map2Triple.remove();
			map2Triple = null;
		}
		if (map3Triple) {
			map3Triple.remove();
			map3Triple = null;
		}

		// Reinitialize single map if not exists
		if (!map) {
			setTimeout(() => {
				initializeMap();
			}, 100);
		}
	}

	// Apply current background color to all elements after switching layouts
	setTimeout(function() {
		applyBackgroundColorToAllElements();
	}, 300);
}



function fixCanvasSize() {
	// Legacy function replaced by SVG shape system.
	// Now just syncs overlay size when a shape is active.
	updateShapeOverlaySize();
}

// Function to reinitialize map with current state preserved
async function reinitializeMap() {
	// TEMP-DIAGNOSE 2026-04-30
	try {
		window.__cmdiag = window.__cmdiag || {};
		window.__cmdiag.events = (window.__cmdiag.events || []).slice(-9);
		window.__cmdiag.events.push('REINIT_ENTER map=' + !!map + ' isReinit=' + isReinitializing);
	} catch(e) {}

	if (!map) {
		try { window.__cmdiag.events.push('REINIT_NOMAP_PATH'); } catch(e) {}
		resizeFrame();
		return;
	}

	// If already reinitializing, return early
	if (isReinitializing) {
		try { window.__cmdiag.events.push('REINIT_BLOCKED_BY_FLAG'); } catch(e) {}
		return;
	}

	// Set flag to prevent concurrent reinitializations
	isReinitializing = true;

	// Hide map container and show loading spinner
	const mapContainer = document.getElementById('map');
	const previewTitle = document.querySelector('.map-preview-title');
	const innContainer = mapContainer.parentElement;

	// Remove any existing spinners first
	const existingSpinners = innContainer.querySelectorAll('.map-loading-spinner');
	existingSpinners.forEach(spinner => spinner.remove());

	// Create loading spinner
	const loadingSpinner = document.createElement('div');
	loadingSpinner.className = 'map-loading-spinner';
	loadingSpinner.innerHTML = `
		<div class="spinner-container">
			<div class="spinner"></div>
			<p>Updating preview...</p>
		</div>
	`;
	loadingSpinner.style.cssText = `
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(255, 255, 255, 0.95);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1000;
	`;

	// Add spinner to map container's parent
	innContainer.style.position = 'relative';
	innContainer.appendChild(loadingSpinner);
	
	mapContainer.style.opacity = '0';
	if (previewTitle) {
		previewTitle.style.opacity = '0';
	}
	
	
	// Save current map state including title text and custom colors
	const titleInput = document.getElementById('map-title-input');
	const subtitleInput = document.getElementById('map-subtitle-input');

	// Save current background color from preview title
	const currentBgColor = $('.map-preview-title').css('background-color') || '#ffffff';
	const currentTextColor = $('.map-preview-title h3').css('color') || '#16212c';

	const savedState = {
		center: map.getCenter(),
		zoom: map.getZoom(),
		styleKey: currentStyle, // Save the style key/name
		customColors: { ...customColors }, // Deep copy of custom colors
		backgroundColor: currentBgColor,
		textColor: currentTextColor,
		border: currentBorder, // Save current border state
		markers: mapMarkers['single'].map(function(en) {
			return { position: en.instance.getLngLat(), icon: en.icon, color: en.color, size: en.size };
		}),
		title: titleInput ? titleInput.value : 'MIAMI, UNITED STATES',
		subtitle: subtitleInput ? subtitleInput.value : "25°46'N / 80°12'W"
	};
	
	
	// Remove current map
	map.remove();
	map = null;
	mapMarkers['single'] = [];
	
	// Clear the map container
	mapContainer.innerHTML = '';
	
	// Resize container first and get the exact dimensions
	resizeFrame();
	
	// Wait for resizeFrame dimensions to apply, then initialize map
	setTimeout(async function() {
		// Load the style properly - use mapStyles mapping and loadMapStyle
		let styleName = savedState.styleKey;
		let isCustomStyle = false;

		// Get the style name from mapStyles
		if (styleName && mapStyles[styleName]) {
			styleName = mapStyles[styleName];
			isCustomStyle = (savedState.styleKey === 'custom');
		} else if (typeof styleName === 'string') {
			// Use the style name as-is or fall back to minimal
			styleName = mapStyles[styleName] || 'minimal';
			isCustomStyle = (savedState.styleKey === 'custom');
		}

		// Load the actual style JSON
		let styleToUse = await loadMapStyle(styleName);
		if (!styleToUse) {
			styleToUse = await loadMapStyle('minimal');
			if (!styleToUse) {
				// Failed to load any style - cleanup and restore visibility
				isReinitializing = false;
				if (loadingSpinner && loadingSpinner.parentNode) {
					loadingSpinner.remove();
				}
				mapContainer.style.opacity = '1';
				if (previewTitle) {
					previewTitle.style.opacity = '1';
				}
				console.error('Failed to load map style');
				return;
			}
		}

		
		// Wait for DOM to settle, then initialize map
		setTimeout(function() {
			// Reinitialize map with saved state and ULTRA-HIGH QUALITY rendering
			map = new mapboxgl.Map({
				container: 'map',
				style: styleToUse,
				center: savedState.center,
				zoom: savedState.zoom,
				pixelRatio: 4,
				maxZoom: 22,
				minZoom: 4,
				antialias: true,
				optimizeForTerrain: false,
				renderWorldCopies: false,
				fadeDuration: 0,
				crossSourceCollisions: false,
				preserveDrawingBuffer: true, // Required for canvas toDataURL() export
				dragRotate: false,
				touchPitch: false,
				pitchWithRotate: false
			});
			map.touchZoomRotate.disableRotation();

			map.on('load', function() {
				
				// Reapply custom colors if it was custom style
				if (isCustomStyle) {
					customColors = savedState.customColors;
					applyCustomMapColors();
				}
				
				// Restore background color to both elements
				$('.map-preview-title').css('background-color', savedState.backgroundColor);
				$('.main__wrapper .outer__main .canvas__wrapper canvas').css('background-color', savedState.backgroundColor);
				$('.map-preview-title h3, .map-preview-title p').css('color', savedState.textColor);
				
				// Canvas sizing — let Mapbox control dimensions via map.resize()
				const canvas = mapContainer.querySelector('canvas');
				if (canvas) {
					// REMOVED: manual canvas sizing breaks Mapbox marker coordinate sync
					// canvas.style.width = containerWidth + 'px';
					// canvas.style.height = containerHeight + 'px';

					// Restore border state on #map (controls ::before white frame)
					mapContainer.style.removeProperty('border');
					if (savedState.border === 'without') {
						mapContainer.classList.add('no-border');
					} else {
						mapContainer.classList.remove('no-border');
					}
				}

				// Single resize after DOM settles (replaces multiple setTimeout chain)
				setTimeout(function() {
					map.resize();
					fixCanvasSize();

					const canvas = mapContainer.querySelector('canvas');
					if (canvas) {
						canvas.style.backgroundColor = savedState.backgroundColor;
					}
					// Restore border state on #map (controls ::before white frame)
					mapContainer.style.removeProperty('border');
					if (savedState.border === 'without') {
						mapContainer.classList.add('no-border');
					} else {
						mapContainer.classList.remove('no-border');
					}
				}, 300);
				
				// Restore all single markers (inkl. Icon/Farbe/Größe je Marker)
				if (savedState.markers && savedState.markers.length) {
					setTimeout(function() {
						savedState.markers.forEach(function(mk) {
							markerSettings['single'].iconElement = mk.icon;
							markerSettings['single'].color = mk.color;
							markerSettings['single'].size = mk.size;
							addMarker([mk.position.lng, mk.position.lat]);
						});
					}, 600);
				}
				
				// Restore poster title overlay with saved text
				addPosterTitleOverlay();
				updatePosterTitle(savedState.title, savedState.subtitle);
				updatePreviewTitle(savedState.title, savedState.subtitle);
				
				// Show map after everything is applied
				setTimeout(function() {
					// Fade out spinner
					if (loadingSpinner) {
						loadingSpinner.style.opacity = '0';
						setTimeout(function() {
							loadingSpinner.remove();
							// Reset the reinitializing flag
							isReinitializing = false;
						}, 300);
					} else {
						// Reset flag even if no spinner
						isReinitializing = false;
					}

					// Fade in map
					mapContainer.style.opacity = '1';
					mapContainer.style.visibility = 'visible';
					if (previewTitle) {
						previewTitle.style.opacity = '1';
					}
				}, 650); // Show after all resizes complete
			});
			
			map.on('error', function(e) {
				// Reset flag on error
				isReinitializing = false;
				// Remove spinner on error
				if (loadingSpinner && loadingSpinner.parentNode) {
					loadingSpinner.remove();
				}
			});
		}, 100);
	}, 100);
}

// Function to show token setup message
function createTokenSetupMessage() {
	const mapContainer = document.getElementById('map');
	if (!mapContainer) return;

	mapContainer.innerHTML = `
		<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; color: #666; font-size: 16px; padding: 20px; text-align: center; background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);">
			<div style="width: 100px; height: 100px; background: #000000; border-radius: 50%; margin-bottom: 20px; display: flex; align-items: center; justify-content: center; color: white; font-size: 24px; font-weight: bold;">🔑</div>
			<h3 style="margin: 0 0 10px 0; color: #333;">Mapbox Token Required</h3>
			<p style="margin: 0 0 20px 0; font-size: 14px;">To enable the interactive map, you need to set up your Mapbox token:</p>
			<ol style="text-align: left; font-size: 12px; color: #555; margin-bottom: 20px;">
				<li>Go to <a href="https://account.mapbox.com/access-tokens/" target="_blank" style="color: #000000;">Mapbox Account</a></li>
				<li>Create a free account (if you don't have one)</li>
				<li>Generate a new access token</li>
				<li>Copy the token and replace 'pk.eyJ1IjoiZG9kbzc5MSIsImEiOiJjbWZianUyejEwNDNsMmpxdzBjZmZnbndtIn0.t5a9KzottI8eUYz396kfbQ' in the JavaScript file</li>
				<li>Refresh the page</li>
			</ol>
			<div style="background: #f8f9fa; padding: 15px; border-radius: 8px; margin-bottom: 20px; font-family: monospace; font-size: 11px; word-break: break-all; border-left: 4px solid #000000;">
				<strong>Current token:</strong><br>
				${mapboxgl.accessToken}
			</div>
			<button onclick="location.reload()" style="padding: 8px 16px; background: #000000; color: white; border: none; border-radius: 4px; cursor: pointer; margin-right: 10px;">Reload Page</button>
			<button onclick="window.open('https://account.mapbox.com/access-tokens/', '_blank')" style="padding: 8px 16px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer;">Get Token</button>
		</div>
	`;
}

// Automatic retry logic for map loading
let mapRetryCount = 0;
const MAX_RETRY_ATTEMPTS = 3;
let mapLoadCheckCompleted = false;

function retryMapInitialization() {
	if (mapRetryCount >= MAX_RETRY_ATTEMPTS) {
		console.warn('Map failed to load after ' + MAX_RETRY_ATTEMPTS + ' attempts. Please check your Mapbox token and internet connection.');
		return;
	}

	mapRetryCount++;

	// Clear any existing map instance
	if (map) {
		try {
			map.remove();
		} catch (e) {
			console.warn('Error removing map:', e);
		}
		map = null;
	}

	// Retry after 2 seconds
	setTimeout(function() {
		if (currentLayout === 'single') {
			initializeMap();
		} else if (currentLayout === 'double') {
			initializeDoubleMaps();
		} else if (currentLayout === 'triple') {
			initializeTripleMaps();
		}
	}, 2000);
}

// Handle window resize
$(window).on('resize', function() {
	if (map) {
		setTimeout(function() {
			map.resize();
		}, 100);
	}
});

// Check map status after a delay and retry if needed (skip in print mode)
setTimeout(function() {
	// Don't retry in print mode or if already checked
	if (isPrintMode || mapLoadCheckCompleted) {
		return;
	}

	mapLoadCheckCompleted = true;

	if (!map || !map.loaded()) {
		// Check if token is missing or is the placeholder/demo token
		if (!mapboxgl.accessToken || mapboxgl.accessToken === 'YOUR_MAPBOX_TOKEN_HERE' || mapboxgl.accessToken === 'pk.demo123') {
			createTokenSetupMessage();
		} else {
			// Automatically retry map initialization
			retryMapInitialization();
		}
	} else {
		// Map loaded successfully, reset retry count
		mapRetryCount = 0;
	}
}, 5000);

// Add keyboard shortcuts
$(document).on('keydown', function(e) {
	if (e.ctrlKey || e.metaKey) {
		switch(e.key) {
			case 's':
				e.preventDefault();
				saveMapConfiguration();
				break;
			case 'e':
				e.preventDefault();
				exportMap('png');
				break;
		}
	}
});

function searchLocation(query, selectFirst = true) {
	if (query.length < 3) return;

	const lang = window.searchLanguage || 'de';
	return fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${mapboxgl.accessToken}&limit=5&language=${lang}`)
		.then(response => response.json())
		.then(data => {
			if (data.features && data.features.length > 0) {
				if (selectFirst) {
					const place = data.features[0];
					const coordinates = place.center;

					// Update map center without animation
					map.jumpTo({
						center: coordinates,
						zoom: 14
					});

					// Add or update marker
					addMarker(coordinates);

					// Update title fields
					maybeTitleFromFirstMarker(place.text || place.place_name, coordinates);
				}
				return data.features;
			}
			return [];
		})
		.catch(error => {
			return [];
		});
}

// Function to create custom marker with icon and color
// Baut ein Marker-DOM-Element aus Icon-HTML + Farbe + Größe (setAttribute UND style.fill —
// sonst überschreibt ein im Icon gespeichertes inline style="fill:…" die Farbe, siehe Reset-Bug).
// Gibt null zurück, wenn kein Icon gewählt ist (dann Default-Farbmarker verwenden).
function buildMarkerElement(iconHtml, color, size) {
	if (!iconHtml) return null;
	const el = document.createElement('div');
	el.className = 'custom-marker';
	el.innerHTML = iconHtml;
	el.style.width = (size || 14) + 'px';
	el.style.height = (size || 14) + 'px';
	el.style.cursor = 'move';
	// Mapbox startet den Marker-Drag auf touchstart am Element; ohne touch-action:none
	// beansprucht der Browser die Geste als Pan/Scroll und der Drag startet mobil nie.
	el.style.touchAction = 'none';
	el.style.display = 'flex';
	el.style.alignItems = 'center';
	el.style.justifyContent = 'center';
	const svg = el.querySelector('svg');
	if (svg) {
		svg.style.width = '100%';
		svg.style.height = '100%';
		const fills = svg.querySelectorAll('.marker-fill');
		fills.forEach(path => { path.setAttribute('fill', color); path.style.fill = color; });
		const strokes = svg.querySelectorAll('.marker-stroke');
		strokes.forEach(path => { path.setAttribute('stroke', color); path.style.stroke = color; });
		const st0Elements = svg.querySelectorAll('.st0');
		st0Elements.forEach(e => { e.setAttribute('fill', color); e.style.fill = color; });
		if (fills.length === 0 && strokes.length === 0 && st0Elements.length === 0) {
			svg.querySelectorAll('path').forEach(path => {
				path.setAttribute('fill', color); path.style.fill = color;
				path.setAttribute('stroke', color); path.style.stroke = color;
			});
		}
	}
	return el;
}

// PROJ-25: Fügt einen neuen Single-Marker hinzu (Klick/Adresse/GPS). Wrapper auf die
// generalisierte addMarkerTo (Commit 3). Aufrufer im Single-Kontext bleiben unverändert.
function addMarker(coordinates) {
	return addMarkerTo('single', coordinates);
}

function showLocationSuggestions(suggestions, inputElement) {
	// Remove existing suggestions
	const existingSuggestions = document.querySelector('.location-suggestions');
	if (existingSuggestions) {
		existingSuggestions.remove();
	}

	if (!suggestions || suggestions.length === 0) return;

	// Create suggestions dropdown
	const suggestionsDiv = document.createElement('div');
	suggestionsDiv.className = 'location-suggestions';
	suggestionsDiv.style.cssText = `
		position: absolute;
		top: 100%;
		left: 0;
		right: 0;
		background: white;
		border: 1px solid #dedede;
		border-top: none;
		border-radius: 0 0 4px 4px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		z-index: 1000;
		max-height: 200px;
		overflow-y: auto;
	`;

	suggestions.forEach((place, index) => {
		const suggestionItem = document.createElement('div');
		suggestionItem.className = 'suggestion-item';
		suggestionItem.style.cssText = `
			padding: 12px 16px;
			cursor: pointer;
			border-bottom: 1px solid #f0f0f0;
			transition: background-color 0.2s ease;
		`;
		
		suggestionItem.innerHTML = `
			<div style="font-weight: 500; color: #16212c; margin-bottom: 2px;">${place.text}</div>
			<div style="font-size: 12px; color: #666;">${place.place_name}</div>
		`;

		suggestionItem.addEventListener('mouseenter', () => {
			suggestionItem.style.backgroundColor = '#f8f9fa';
		});

		suggestionItem.addEventListener('mouseleave', () => {
			suggestionItem.style.backgroundColor = 'white';
		});

		suggestionItem.addEventListener('click', () => {
			const coordinates = place.center;

			// Update input value
			inputElement.value = place.place_name;

			// Check if this is a double map input
			const isDoubleMap1 = inputElement.id === 'double-map-place-1';
			const isDoubleMap2 = inputElement.id === 'double-map-place-2';
			const isDoubleMarker1 = inputElement.id === 'double-marker-address-1';
			const isDoubleMarker2 = inputElement.id === 'double-marker-address-2';

			// Check if this is a triple map input
			const isTripleMap1 = inputElement.id === 'triple-map-place-1';
			const isTripleMap2 = inputElement.id === 'triple-map-place-2';
			const isTripleMap3 = inputElement.id === 'triple-map-place-3';
			const isTripleMarker1 = inputElement.id === 'triple-marker-address-1';
			const isTripleMarker2 = inputElement.id === 'triple-marker-address-2';
			const isTripleMarker3 = inputElement.id === 'triple-marker-address-3';

			if (isDoubleMap1 && map1) {
				// Update first map
				map1.jumpTo({
					center: coordinates,
					zoom: 14
				});

				// Update title fields for first map
				const titleInput = document.getElementById('double-large-text-1');
				const subtitleInput = document.getElementById('double-small-text-1');
				if (titleInput) titleInput.value = place.text || place.place_name;
				if (subtitleInput) subtitleInput.value = formatCoordsDMS(coordinates[1], coordinates[0]);

				// Update display titles
				$('.double-map-container .map-wrapper:nth-child(1) .map-label h3').text(place.text || place.place_name);
				$('.double-map-container .map-wrapper:nth-child(1) .map-label p').text(formatCoordsDMS(coordinates[1], coordinates[0]));

			} else if (isDoubleMarker1 && map1) {
				// Update first map for marker
				map1.jumpTo({
					center: coordinates,
					zoom: 14
				});

				// Add marker only if checkbox is checked
				const markerCheckbox = document.getElementById('double-marker-1');
				if (markerCheckbox && markerCheckbox.checked) {
					addMarkerTo('double-1', coordinates);
				}

				// Update title fields for first map
				const titleInput = document.getElementById('double-large-text-1');
				const subtitleInput = document.getElementById('double-small-text-1');
				if (titleInput) titleInput.value = place.text || place.place_name;
				if (subtitleInput) subtitleInput.value = formatCoordsDMS(coordinates[1], coordinates[0]);

				// Update display titles
				$('.double-map-container .map-wrapper:nth-child(1) .map-label h3').text(place.text || place.place_name);
				$('.double-map-container .map-wrapper:nth-child(1) .map-label p').text(formatCoordsDMS(coordinates[1], coordinates[0]));

			} else if (isDoubleMarker2 && map2) {
				// Update second map for marker
				map2.jumpTo({
					center: coordinates,
					zoom: 14
				});

				// Add marker only if checkbox is checked
				const markerCheckbox = document.getElementById('double-marker-2');
				if (markerCheckbox && markerCheckbox.checked) {
					addMarkerTo('double-2', coordinates);
				}

				// Update title fields for second map
				const titleInput = document.getElementById('double-large-text-2');
				const subtitleInput = document.getElementById('double-small-text-2');
				if (titleInput) titleInput.value = place.text || place.place_name;
				if (subtitleInput) subtitleInput.value = formatCoordsDMS(coordinates[1], coordinates[0]);

				// Update display titles
				$('.double-map-container .map-wrapper:nth-child(2) .map-label h3').text(place.text || place.place_name);
				$('.double-map-container .map-wrapper:nth-child(2) .map-label p').text(formatCoordsDMS(coordinates[1], coordinates[0]));

			} else if (isDoubleMap2 && map2) {
				// Update second map
				map2.jumpTo({
					center: coordinates,
					zoom: 14
				});

				// Update title fields for second map
				const titleInput = document.getElementById('double-large-text-2');
				const subtitleInput = document.getElementById('double-small-text-2');
				if (titleInput) titleInput.value = place.text || place.place_name;
				if (subtitleInput) subtitleInput.value = formatCoordsDMS(coordinates[1], coordinates[0]);

				// Update display titles
				$('.double-map-container .map-wrapper:nth-child(2) .map-label h3').text(place.text || place.place_name);
				$('.double-map-container .map-wrapper:nth-child(2) .map-label p').text(formatCoordsDMS(coordinates[1], coordinates[0]));

			} else if (isTripleMap1 && map1Triple) {
				// Update first triple map
				map1Triple.jumpTo({
					center: coordinates,
					zoom: 14
				});

				// Update title fields for first map
				const titleInput = document.getElementById('triple-large-text-1');
				const subtitleInput = document.getElementById('triple-small-text-1');
				if (titleInput) titleInput.value = place.text || place.place_name;
				if (subtitleInput) subtitleInput.value = formatCoordsDMS(coordinates[1], coordinates[0]);

				// Update display titles
				$('.triple-map-container .map-wrapper:nth-child(1) .map-label h3').text(place.text || place.place_name);
				$('.triple-map-container .map-wrapper:nth-child(1) .map-label p').text(formatCoordsDMS(coordinates[1], coordinates[0]));

			} else if (isTripleMap2 && map2Triple) {
				// Update second triple map
				map2Triple.jumpTo({
					center: coordinates,
					zoom: 14
				});

				// Update title fields for second map
				const titleInput = document.getElementById('triple-large-text-2');
				const subtitleInput = document.getElementById('triple-small-text-2');
				if (titleInput) titleInput.value = place.text || place.place_name;
				if (subtitleInput) subtitleInput.value = formatCoordsDMS(coordinates[1], coordinates[0]);

				// Update display titles
				$('.triple-map-container .map-wrapper:nth-child(2) .map-label h3').text(place.text || place.place_name);
				$('.triple-map-container .map-wrapper:nth-child(2) .map-label p').text(formatCoordsDMS(coordinates[1], coordinates[0]));

			} else if (isTripleMap3 && map3Triple) {
				// Update third triple map
				map3Triple.jumpTo({
					center: coordinates,
					zoom: 14
				});

				// Update title fields for third map
				const titleInput = document.getElementById('triple-large-text-3');
				const subtitleInput = document.getElementById('triple-small-text-3');
				if (titleInput) titleInput.value = place.text || place.place_name;
				if (subtitleInput) subtitleInput.value = formatCoordsDMS(coordinates[1], coordinates[0]);

				// Update display titles
				$('.triple-map-container .map-wrapper:nth-child(3) .map-label h3').text(place.text || place.place_name);
				$('.triple-map-container .map-wrapper:nth-child(3) .map-label p').text(formatCoordsDMS(coordinates[1], coordinates[0]));

			} else if (isTripleMarker1 && map1Triple) {
				// Update first triple map for marker
				map1Triple.jumpTo({
					center: coordinates,
					zoom: 14
				});

				// Add marker only if checkbox is checked
				const markerCheckbox = document.getElementById('triple-marker-1');
				if (markerCheckbox && markerCheckbox.checked) {
					addMarkerTo('triple-1', coordinates);
				}

				// Update display titles
				$('.triple-map-container .map-wrapper:nth-child(1) .map-label h3').text(place.text || place.place_name);
				$('.triple-map-container .map-wrapper:nth-child(1) .map-label p').text(formatCoordsDMS(coordinates[1], coordinates[0]));

			} else if (isTripleMarker2 && map2Triple) {
				// Update second triple map for marker
				map2Triple.jumpTo({
					center: coordinates,
					zoom: 14
				});

				// Add marker only if checkbox is checked
				const markerCheckbox = document.getElementById('triple-marker-2');
				if (markerCheckbox && markerCheckbox.checked) {
					addMarkerTo('triple-2', coordinates);
				}

				// Update display titles
				$('.triple-map-container .map-wrapper:nth-child(2) .map-label h3').text(place.text || place.place_name);
				$('.triple-map-container .map-wrapper:nth-child(2) .map-label p').text(formatCoordsDMS(coordinates[1], coordinates[0]));

			} else if (isTripleMarker3 && map3Triple) {
				// Update third triple map for marker
				map3Triple.jumpTo({
					center: coordinates,
					zoom: 14
				});

				// Add marker only if checkbox is checked
				const markerCheckbox = document.getElementById('triple-marker-3');
				if (markerCheckbox && markerCheckbox.checked) {
					addMarkerTo('triple-3', coordinates);
				}

				// Update display titles
				$('.triple-map-container .map-wrapper:nth-child(3) .map-label h3').text(place.text || place.place_name);
				$('.triple-map-container .map-wrapper:nth-child(3) .map-label p').text(formatCoordsDMS(coordinates[1], coordinates[0]));

			} else if (map) {
				// Update single map (existing functionality)
				map.jumpTo({
					center: coordinates,
					zoom: 14
				});

				// Add or update marker only if checkbox is checked
				const markerCheckbox = document.querySelector('.map__marker input[type="checkbox"]');
				if (markerCheckbox && markerCheckbox.checked) {
					addMarker(coordinates);
				}

				// Update title fields
				maybeTitleFromFirstMarker(place.text || place.place_name, coordinates);
			}

			// Remove suggestions
			suggestionsDiv.remove();
		});

		if (index === suggestions.length - 1) {
			suggestionItem.style.borderBottom = 'none';
		}

		suggestionsDiv.appendChild(suggestionItem);
	});

	// Position relative to input
	const inputContainer = inputElement.parentElement;
	inputContainer.style.position = 'relative';
	inputContainer.appendChild(suggestionsDiv);

	// Close suggestions when clicking outside
	const closeHandler = (e) => {
		if (!suggestionsDiv.contains(e.target) && e.target !== inputElement) {
			suggestionsDiv.remove();
			document.removeEventListener('click', closeHandler);
		}
	};
	
	setTimeout(() => {
		document.addEventListener('click', closeHandler);
	}, 100);
}

function showMarkerSuggestions(suggestions, inputElement) {
	// Remove existing suggestions
	const existingSuggestions = document.querySelector('.location-suggestions');
	if (existingSuggestions) {
		existingSuggestions.remove();
	}

	if (!suggestions || suggestions.length === 0) return;

	// Create suggestions dropdown
	const suggestionsDiv = document.createElement('div');
	suggestionsDiv.className = 'location-suggestions';
	suggestionsDiv.style.cssText = `
		position: absolute;
		top: 100%;
		left: 0;
		right: 0;
		background: white;
		border: 1px solid #dedede;
		border-top: none;
		border-radius: 0 0 4px 4px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		z-index: 1000;
		max-height: 200px;
		overflow-y: auto;
	`;

	suggestions.forEach((place, index) => {
		const suggestionItem = document.createElement('div');
		suggestionItem.className = 'suggestion-item';
		suggestionItem.style.cssText = `
			padding: 12px 16px;
			cursor: pointer;
			border-bottom: 1px solid #f0f0f0;
			transition: background-color 0.2s ease;
		`;
		
		suggestionItem.innerHTML = `
			<div style="font-weight: 500; color: #16212c; margin-bottom: 2px;">${place.text}</div>
			<div style="font-size: 12px; color: #666;">${place.place_name}</div>
		`;

		suggestionItem.addEventListener('mouseenter', () => {
			suggestionItem.style.backgroundColor = '#f8f9fa';
		});

		suggestionItem.addEventListener('mouseleave', () => {
			suggestionItem.style.backgroundColor = 'white';
		});

		suggestionItem.addEventListener('click', () => {
			const coordinates = place.center;
			
			// Update input value
			inputElement.value = place.place_name;
			
			// Update map
			if (map) {
				map.jumpTo({
					center: coordinates,
					zoom: 14
				});

				// Add marker
				addMarker(coordinates);

				// Update title fields
				maybeTitleFromFirstMarker(place.text || place.place_name, coordinates);
			}

			// Remove suggestions
			suggestionsDiv.remove();
		});

		if (index === suggestions.length - 1) {
			suggestionItem.style.borderBottom = 'none';
		}

		suggestionsDiv.appendChild(suggestionItem);
	});

	// Position relative to input
	const inputContainer = inputElement.parentElement;
	inputContainer.style.position = 'relative';
	inputContainer.appendChild(suggestionsDiv);

	// Close suggestions when clicking outside
	const closeHandler = (e) => {
		if (!suggestionsDiv.contains(e.target) && e.target !== inputElement) {
			suggestionsDiv.remove();
			document.removeEventListener('click', closeHandler);
		}
	};
	
	setTimeout(() => {
		document.addEventListener('click', closeHandler);
	}, 100);
}

// PROJ-25: Titel-Autofill nur vom ERSTEN Single-Marker (AK5). Nach addMarker ist der
// gerade gesetzte im Array; length===1 => es war der erste.
function maybeTitleFromFirstMarker(placeName, coordinates) {
	if ((mapMarkers['single'] || []).length <= 1) updateTitleFields(placeName, coordinates);
}

function updateTitleFields(placeName, coordinates) {
	const titleInput = document.getElementById('map-title-input');
	const subtitleInput = document.getElementById('map-subtitle-input');

	if (titleInput) {
		titleInput.value = placeName || 'MIAMI, UNITED STATES';
	}

	if (subtitleInput && coordinates && coordinates.length >= 2) {
		subtitleInput.value = formatCoordsDMS(coordinates[1], coordinates[0]);
	}
	
	// Update poster title overlay
	updatePosterTitle(placeName, formatCoordsDMS(coordinates[1], coordinates[0]));
	
	// Update preview title below map
	updatePreviewTitle(placeName, formatCoordsDMS(coordinates[1], coordinates[0]));
}

// Dynamically adjust font size to keep title on single line
// V9.98.7: adjustPreviewTitleFontSize akzeptiert optional baseFontSize + minFontSize.
// Default 24/1 — minFontSize 1 statt 12 damit Text immer inbound shrinkt (User-Wunsch).
function adjustPreviewTitleFontSize(element, baseFontSize, minFontSize) {
	if (!element) return;

	const container = element.parentElement;
	if (!container) return;

	if (typeof baseFontSize !== 'number') baseFontSize = 24;
	if (typeof minFontSize !== 'number') minFontSize = 1; // war 12 — User-Wunsch: keine Untergrenze

	// Vorschau waechst auf grossen Bildschirmen mit (resizeFrame setzt --dl-poster-scale).
	// Ohne Mitskalieren bliebe der Titel bei 24px stehen und wirkte im grossen Poster verloren.
	const _poster = element.closest('.inn.single-map-view');
	const _posterScale = _poster ? parseFloat(getComputedStyle(_poster).getPropertyValue('--dl-poster-scale')) : 1;
	if (_posterScale > 1) baseFontSize = Math.round(baseFontSize * _posterScale);

	// V9.99.9: beim Initial Load ist container.offsetWidth oft noch 0 (DOM-Layout nicht
	// fertig). while-loop läuft dann nicht → Font behält baseFontSize → "Schrift zu groß"-Bug.
	// Fix: wenn Container 0 width, kurz warten + retry.
	if (container.offsetWidth === 0) {
		setTimeout(() => adjustPreviewTitleFontSize(element, baseFontSize, minFontSize), 100);
		return;
	}

	const maxWidth = container.offsetWidth - 20; // Account for padding

	// Reset to base font size first
	element.style.fontSize = baseFontSize + 'px';
	element.style.whiteSpace = 'nowrap';

	// Reduce font size until text fits on one line
	let currentSize = baseFontSize;
	while (element.scrollWidth > maxWidth && currentSize > minFontSize) {
		currentSize -= 1;
		element.style.fontSize = currentSize + 'px';
	}
}

// Update preview title below map
function updatePreviewTitle(title, subtitle) {
	const previewTitle = document.getElementById('preview-title');
	const previewSubtitle = document.getElementById('preview-subtitle');

	if (previewTitle) {
		// Set title text (no line breaks)
		const titleHtml = (title || '').replace(/[\r\n]/g, '');
		previewTitle.innerHTML = titleHtml;

		// Dynamically adjust font size to prevent wrapping
		adjustPreviewTitleFontSize(previewTitle); // base 24, min 1
	}

	if (previewSubtitle) {
		// Set subtitle text (no line breaks)
		const subtitleHtml = (subtitle || '').replace(/[\r\n]/g, '');
		previewSubtitle.innerHTML = subtitleHtml;
		// V9.98.7: Subtitle auch shrinken bei langem Text (base 14 = CSS-Default, min 1)
		adjustPreviewTitleFontSize(previewSubtitle, 14, 1);
	}
}

function darkenColor(hex, amount) {
	if (!hex || !hex.startsWith('#')) return hex;
	const h = hex.replace('#', '');
	const r = Math.max(0, parseInt(h.substr(0, 2), 16) - amount);
	const g = Math.max(0, parseInt(h.substr(2, 2), 16) - amount);
	const b = Math.max(0, parseInt(h.substr(4, 2), 16) - amount);
	return '#' + [r, g, b].map(v => v.toString(16).padStart(2, '0')).join('');
}

function lightenColor(hex, amount) {
	if (!hex || !hex.startsWith('#')) return hex;
	const h = hex.replace('#', '');
	const r = Math.min(255, parseInt(h.substr(0, 2), 16) + amount);
	const g = Math.min(255, parseInt(h.substr(2, 2), 16) + amount);
	const b = Math.min(255, parseInt(h.substr(4, 2), 16) + amount);
	return '#' + [r, g, b].map(v => v.toString(16).padStart(2, '0')).join('');
}

// Generate height-dependent building fill expression with tonal gradation
// Matches original styles: render_height-based interpolation (low=light, tall=dark)
function buildingFillExpression(baseHex) {
	return [
		'interpolate', ['linear'],
		['coalesce', ['get', 'render_height'], 5],
		0, lightenColor(baseHex, 20),
		10, baseHex,
		30, darkenColor(baseHex, 20)
	];
}

function readCurrentColorsFromMap(mapInstance) {
	if (!mapInstance) return null;
	try {
		const colors = {};
		if (mapInstance.getLayer('bg')) {
			const c = mapInstance.getPaintProperty('bg', 'background-color');
			if (typeof c === 'string') colors.land = rgbToHex(c);
		}
		if (mapInstance.getLayer('streets')) {
			const c = mapInstance.getPaintProperty('streets', 'line-color');
			if (typeof c === 'string') colors.roads = rgbToHex(c);
		}
		if (mapInstance.getLayer('water')) {
			const c = mapInstance.getPaintProperty('water', 'fill-color');
			if (typeof c === 'string') colors.water = rgbToHex(c);
		}
		if (mapInstance.getLayer('buildings fill')) {
			const bColor = mapInstance.getPaintProperty('buildings fill', 'fill-color');
			if (typeof bColor === 'string') {
				colors.buildings = rgbToHex(bColor);
			} else if (Array.isArray(bColor)) {
				const midVal = bColor[bColor.length - 3];
				if (typeof midVal === 'string') colors.buildings = rgbToHex(midVal);
			}
		}
		const titleTextEl = document.querySelector('.map-preview-title h3');
		if (titleTextEl) colors.text = rgbToHex(getComputedStyle(titleTextEl).color);
		const titleEl = document.querySelector('.map-preview-title');
		if (titleEl) colors.background = rgbToHex(getComputedStyle(titleEl).backgroundColor);
		return colors;
	} catch (e) { return null; }
}

function updateColorPickerUI() {
	for (const [type, color] of Object.entries(customColors)) {
		const picker = document.querySelector('.custom__style [data-type="' + type + '"] .custom-color-picker');
		if (picker && color) picker.value = color.startsWith('#') ? color : rgbToHex(color);
	}
	document.querySelectorAll('.custom__style .box a').forEach(el => el.classList.remove('current'));
	document.querySelectorAll('.custom__style a.custom').forEach(el => el.classList.add('current'));
}

async function changeMapStyle(styleKey) {
	// For custom style, use the saved base style instead of looking up in mapStyles
	const styleConfig = styleKey === 'custom' ? baseStyleForCustom : (mapStyles[styleKey] || mapStyles['minimal']);
	currentStyle = styleKey; // Save the style key, not the config

	// Reset background to white when switching from custom to other styles
	if (styleKey !== 'custom') {
		customColors.background = '#FFFFFF';
		applyBackgroundColorToAllElements();
	}

	// Helper function to apply style to a single map instance
	const applyStyleToMap = async (mapInstance) => {
		if (!mapInstance) return;

		// Load style from local JSON file
		const styleData = await loadMapStyle(styleConfig);
		if (styleData) {
			mapInstance.setStyle(styleData);
		} else {
			// Fallback to minimal style
			const fallbackStyle = await loadMapStyle('minimal');
			if (fallbackStyle) {
				mapInstance.setStyle(fallbackStyle);
			}
		}

		// Wait for style to load before trying to modify layers
		mapInstance.once('styledata', () => {
			try {
				// Add custom styling for specific themes only if layers exist
				if (styleKey === 'pink') {
					if (mapInstance.getLayer('water')) {
						mapInstance.setPaintProperty('water', 'fill-color', '#e8b4d6');
					}
					if (mapInstance.getLayer('landuse')) {
						mapInstance.setPaintProperty('landuse', 'fill-color', '#f7e8f1');
					}
				} else if (styleKey === 'green') {
					if (mapInstance.getLayer('water')) {
						mapInstance.setPaintProperty('water', 'fill-color', '#a8d8a8');
					}
					if (mapInstance.getLayer('landuse')) {
						mapInstance.setPaintProperty('landuse', 'fill-color', '#e8f5e8');
					}
				} else if (styleKey === 'custom') {
					// Apply custom colors for custom style
					applyCustomMapColorsToInstance(mapInstance);
				}
			} catch (error) {
			}
		});
	};

	// Apply to single map
	if (map) {
		await applyStyleToMap(map);
	}

	// Apply to double map layout
	if (map1) {
		await applyStyleToMap(map1);
	}
	if (map2) {
		await applyStyleToMap(map2);
	}

	// Apply to triple map layout
	if (map1Triple) {
		await applyStyleToMap(map1Triple);
	}
	if (map2Triple) {
		await applyStyleToMap(map2Triple);
	}
	if (map3Triple) {
		await applyStyleToMap(map3Triple);
	}
}

// Helper function to apply custom colors to a specific map instance
function applyCustomMapColorsToInstance(mapInstance) {
	if (!mapInstance) return;

	// Function to apply colors
	const applyColors = () => {
		try {
			// Only apply colors that the user has explicitly changed
			// This preserves complex style expressions (e.g. zoom-dependent building colors)

			if (customColorsChanged.has('land')) {
				// Urban Explorer: preserve forest + park/cemetery/pitch green
				const isUrbanExplorer = baseStyleForCustom === 'mapbox-urban-explorer';

				if (isUrbanExplorer) {
					// urban-areas-11-13: keep park/cemetery/pitch green, override the rest
					if (mapInstance.getLayer('urban-areas-11-13')) {
						try {
							mapInstance.setPaintProperty('urban-areas-11-13', 'fill-color', [
								'match', ['get', 'class'],
								['cemetery', 'park', 'pitch'], 'rgba(200, 230, 195, 1)',
								customColors.land
							]);
						} catch (e) {
						}
					}
					// building-density-8-10 has no parks, safe to override
					if (mapInstance.getLayer('building-density-8-10')) {
						try {
							mapInstance.setPaintProperty('building-density-8-10', 'fill-color', customColors.land);
						} catch (e) {
						}
					}
					// Forest/forest-fill NOT touched — stay green
				} else {
					const landFillLayers = [
						'urban-areas-11-13',       // All styles
						'building-density-8-10',   // All styles
						'Forest',
						'forest-fill'
					];
					landFillLayers.forEach(layerId => {
						if (mapInstance.getLayer(layerId)) {
							try {
								mapInstance.setPaintProperty(layerId, 'fill-color', customColors.land);
							} catch (e) {
							}
						}
					});
				}

				const landOutlineLayers = [
					'urban-areas-outline-11-13'      // All styles
				];
				if (!isUrbanExplorer) {
					landOutlineLayers.push('Forest-outline', 'forest-outline');
				}
				landOutlineLayers.forEach(layerId => {
					if (mapInstance.getLayer(layerId)) {
						try {
							mapInstance.setPaintProperty(layerId, 'line-color', customColors.land);
						} catch (e) {
						}
					}
				});

				if (mapInstance.getLayer('bg')) {
					try {
						mapInstance.setPaintProperty('bg', 'background-color', customColors.land);
					} catch (e) {
					}
				}
			}

			if (customColorsChanged.has('roads')) {
				const roadLayers = [
					'streets',           // Local/residential streets
					'Primary-Motorway',  // Primary roads and motorways
					'Trunks',            // Trunk roads
					'secondary roads',   // Secondary roads
					'teritary roads',    // Tertiary roads (note: typo in style but keeping it)
					'service',           // Service roads
					'path',              // Paths/footways
					'track',             // Tracks
					'rails'              // Railway lines
				];

				roadLayers.forEach(layerId => {
					if (mapInstance.getLayer(layerId)) {
						try {
							mapInstance.setPaintProperty(layerId, 'line-color', customColors.roads);
						} catch (e) {
						}
					}
				});
			}

			if (customColorsChanged.has('water')) {
				const waterLayers = ['water', 'water-rivers'];
				waterLayers.forEach(layerId => {
					if (mapInstance.getLayer(layerId)) {
						try {
							mapInstance.setPaintProperty(layerId, 'fill-color', customColors.water);
						} catch (e) {
						}
					}
				});

				if (mapInstance.getLayer('water-stroke')) {
					try {
						mapInstance.setPaintProperty('water-stroke', 'line-color', customColors.water);
					} catch (e) {
					}
				}
			}

			if (customColorsChanged.has('buildings')) {
				if (customColors.buildings) {
					if (mapInstance.getLayer('buildings fill')) {
						try {
							mapInstance.setPaintProperty('buildings fill', 'fill-color', buildingFillExpression(customColors.buildings));
						} catch (e) {
						}
					}
					// PROJ-95: Low-Zoom-Gebäude (z9–11, eigene Quelle) folgen derselben Kundenfarbe
					if (mapInstance.getLayer('buildings lowzoom fill')) {
						try {
							mapInstance.setPaintProperty('buildings lowzoom fill', 'fill-color', buildingFillExpression(customColors.buildings));
						} catch (e) {
						}
					}
					if (mapInstance.getLayer('buildings')) {
						try {
							mapInstance.setPaintProperty('buildings', 'line-color', darkenColor(customColors.buildings, 30));
						} catch (e) {
						}
					}
					if (mapInstance.getLayer('buildings lowzoom')) {
						try {
							mapInstance.setPaintProperty('buildings lowzoom', 'line-color', darkenColor(customColors.buildings, 30));
						} catch (e) {
						}
					}
				}
			}

			if (customColorsChanged.has('text')) {
				if (customColors.text) {
					document.querySelectorAll('.map-preview-title h3, .map-preview-title p').forEach(el => {
						el.style.color = customColors.text;
					});
				}
			}

		} catch (error) {
		}
	};

	// If map is loaded, apply immediately
	if (mapInstance.loaded()) {
		applyColors();
	} else {
		// Otherwise wait for load
		mapInstance.once('load', applyColors);
	}
}

// Apply custom colors to all active map layers
function applyCustomMapColors() {
	// Apply to single map
	if (map) {
		applyCustomMapColorsToInstance(map);
	}

	// Apply to double map layout
	if (map1) {
		applyCustomMapColorsToInstance(map1);
	}
	if (map2) {
		applyCustomMapColorsToInstance(map2);
	}

	// Apply to triple map layout
	if (map1Triple) {
		applyCustomMapColorsToInstance(map1Triple);
	}
	if (map2Triple) {
		applyCustomMapColorsToInstance(map2Triple);
	}
	if (map3Triple) {
		applyCustomMapColorsToInstance(map3Triple);
	}
}

// Helper function to convert RGB to Hex
function rgbToHex(rgb) {
	const result = rgb.match(/\d+/g);
	if (!result || result.length < 3) return rgb;

	const r = parseInt(result[0]);
	const g = parseInt(result[1]);
	const b = parseInt(result[2]);

	return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
}

// Helper function to determine if text should be white or black based on background color
function getContrastTextColor(backgroundColor) {
	// Convert hex to RGB if needed
	let r, g, b;

	if (backgroundColor.startsWith('#')) {
		const hex = backgroundColor.replace('#', '');
		r = parseInt(hex.substr(0, 2), 16);
		g = parseInt(hex.substr(2, 2), 16);
		b = parseInt(hex.substr(4, 2), 16);
	} else if (backgroundColor.startsWith('rgb')) {
		const result = backgroundColor.match(/\d+/g);
		if (result && result.length >= 3) {
			r = parseInt(result[0]);
			g = parseInt(result[1]);
			b = parseInt(result[2]);
		} else {
			return '#000'; // Default to black
		}
	} else {
		return '#000'; // Default to black
	}

	// Calculate relative luminance (perceived brightness)
	const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

	// Return white for dark backgrounds, black for light backgrounds
	return luminance > 0.5 ? '#000000' : '#FFFFFF';
}

// Helper function to apply current background color to all relevant elements
function applyBackgroundColorToAllElements() {
	// Always use a background color, default to white if not set
	const backgroundColor = customColors.background || '#FFFFFF';

	// Update CSS variable for ::before pseudo-element border color
	document.documentElement.style.setProperty('--paper-color', backgroundColor);
	// V9.99.10: --box-color CSS-var für Box-Layout-Background (separater Wert von Papier)
	document.documentElement.style.setProperty('--box-color', customColors.box || '#FFFFFF');

	// Apply background color to all canvas and preview elements
	$('.map-preview-title').css('background-color', backgroundColor);
	$('.main__wrapper .outer__main .canvas__wrapper canvas').css('background-color', backgroundColor);
	$('.main__wrapper .outer__main .canvas__wrapper .inn').css('background-color', backgroundColor);
	$('canvas.mapboxgl-canvas').css('background-color', backgroundColor);
	$('.photo-preview').css('background-color', backgroundColor);
	$('div#map').css('background-color', backgroundColor);
	$('div#map.layout-circle').css('background-color', backgroundColor);
	$('div#map.layout-full-heart').css('background-color', backgroundColor);

	// Update SVG shape frame overlay color
	updateShapeFrameColor(backgroundColor);

	// Apply background color to double and triple map layouts
	$('.double-map-view').css('background-color', backgroundColor);
	$('.triple-map-view').css('background-color', backgroundColor);
	$('.double-map-container').css('background-color', backgroundColor);
	$('.triple-map-container').css('background-color', backgroundColor);
	$('.double-map').css('background-color', backgroundColor);
	$('.triple-map').css('background-color', backgroundColor);
	$('#map1, #map2').css('background-color', backgroundColor);
	$('#map1-triple, #map2-triple, #map3-triple').css('background-color', backgroundColor);

	// Apply background color to photo preview areas
	$('.with-photo .photo-preview').css('background-color', backgroundColor);
	$('.photo-preview.with-valentine path.outline').css('fill', backgroundColor);

	// V9.98.5: Auto-Text-Color-Flip entfernt — Text bleibt immer auf User-Wahl
	// (default #000 wenn nie geändert). Bei dunklem Papier muss User manuell
	// Text-Farbe wechseln via Text-Color-Picker. Voller User-Control.
	const textColor = customColors.text || '#000000';
	$('.map-preview-title h3, .map-preview-title p').css('color', textColor);

	// Apply text color to double and triple map labels
	$('.double-map-title h2').css('color', textColor);
	$('.triple-map-title h2').css('color', textColor);
	$('.map-label h3, .map-label p').css('color', textColor);

}

function resetMapStyle() {
	if (map) {
		// Reset to original style
		map.setStyle(currentStyle);
	}
}

// Function to apply font to all layouts (global scope so it's accessible from initializeMap and document.ready)
function applyFontToAllLayouts(fontFamily) {
	const isSerif = fontFamily === 'Playfair Display';
	const isCursive = fontFamily === 'Dancing Script' || fontFamily === 'Pacifico' ||
	                  fontFamily === 'Great Vibes' || fontFamily === 'Sacramento' ||
	                  fontFamily === 'Allura' || fontFamily === 'Satisfy' ||
	                  fontFamily === 'Amatic SC' || fontFamily === 'Permanent Marker' ||
	                  fontFamily === 'Caveat' || fontFamily === 'Indie Flower';
	const isDisplay = fontFamily === 'Bebas Neue' || fontFamily === 'Lobster' ||
	                  fontFamily === 'Righteous';

	let fontStyle;
	if (isSerif) {
		fontStyle = `"${fontFamily}", serif`;
	} else if (isCursive) {
		fontStyle = `"${fontFamily}", cursive`;
	} else if (isDisplay) {
		fontStyle = `"${fontFamily}", cursive`;
	} else {
		fontStyle = `"${fontFamily}", sans-serif`;
	}

	$('.map-preview-title h3, .map-preview-title p, #preview-title, #preview-subtitle').each(function() {
		$(this).css('font-family', fontStyle);
	});
	$('.double-map-title h2').css('font-family', fontStyle);
	$('.double-map-container .map-label h3, .double-map-container .map-label p').css('font-family', fontStyle);
	$('.triple-map-title h2').css('font-family', fontStyle);
	$('.triple-map-container .map-label h3, .triple-map-container .map-label p').css('font-family', fontStyle);
}

// Function to apply current style and font to all active maps
function applyCurrentStyleAndFont() {

	// Apply current map style to all active maps
	if (currentStyle) {
		changeMapStyle(currentStyle);
	}

	// Read font from active layout's picker instead of global currentFont
	let activeFont;
	if (isDoubleMapLayout) {
		activeFont = $('.double-font-picker li a.current').attr('data-font') || 'Playfair Display';
	} else if (isTripleMapLayout) {
		activeFont = $('.triple-font-picker li a.current').attr('data-font') || 'Playfair Display';
	} else {
		activeFont = currentFont || 'Playfair Display';
	}

	if (activeFont && typeof applyFontToAllLayouts === 'function') {
		applyFontToAllLayouts(activeFont);
	}
}

function exportMap(format = 'png') {
	if (!map) {
		showToast('Die Karte wird noch geladen. Bitte warte einen Moment und versuche es erneut.');
		return;
	}

	// Create a canvas element to capture the map
	const canvas = map.getCanvas();

	// Add timestamp to filename
	const timestamp = new Date().toISOString().split('T')[0];
	const filename = `map-export-${timestamp}.${format}`;

	try {
		if (format === 'png') {
			// For PNG, use the canvas directly
			const dataURL = canvas.toDataURL('image/png');

			// Create download link
			const link = document.createElement('a');
			link.download = filename;
			link.href = dataURL;
			link.click();
		} else if (format === 'jpg') {
			// For JPG, convert canvas to blob
			canvas.toBlob(function(blob) {
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.download = filename;
				link.href = url;
				link.click();
				URL.revokeObjectURL(url);
			}, 'image/jpeg', 0.9);
		}

		// Show success message
		showExportMessage('Karte erfolgreich exportiert!');
	} catch (error) {
		showExportMessage('Fehler beim Export. Bitte versuche es erneut.', 'error');
	}
}

function showExportMessage(message, type = 'success') {
	// Create or update export message
	let messageEl = document.getElementById('export-message');

	if (!messageEl) {
		messageEl = document.createElement('div');
		messageEl.id = 'export-message';
		messageEl.style.cssText = `
			position: fixed;
			top: 20px;
			right: 20px;
			padding: 12px 20px;
			border-radius: 8px;
			color: white;
			font-weight: 500;
			z-index: 1000;
			transition: all 0.3s ease;
			background-color: ${type === 'error' ? '#000000' : '#4CAF50'};
		`;
		document.body.appendChild(messageEl);
	} else {
		messageEl.style.backgroundColor = type === 'error' ? '#000000' : '#4CAF50';
	}

	messageEl.textContent = message;
	messageEl.style.display = 'block';

	// Hide after 3 seconds
	setTimeout(() => {
		messageEl.style.display = 'none';
	}, 3000);
}

function saveMapConfiguration() {
	const config = {
		center: map.getCenter(),
		zoom: map.getZoom(),
		style: currentStyle,
		markers: collectMarkers('single'),
		title: document.querySelector('.map__title .content textarea:nth-child(2)')?.value || '',
		subtitle: document.querySelector('.map__title .content textarea:nth-child(4)')?.value || '',
		timestamp: new Date().toISOString()
	};

	// Save to localStorage
	localStorage.setItem('mapConfiguration', JSON.stringify(config));

	showExportMessage('Konfiguration gespeichert!');
}

function loadMapConfiguration() {
	const saved = localStorage.getItem('mapConfiguration');

	if (saved) {
		try {
			const config = JSON.parse(saved);

			// Restore map state
			if (config.center) {
				map.flyTo({
					center: config.center,
					zoom: config.zoom || 12
				});
			}

			// Restore markers (Array; Backward-Kompat für altes Skalar-`marker`)
			clearSingleMarkers();
			if (config.markers && config.markers.length) {
				config.markers.forEach(function(mk) {
					markerSettings['single'].iconElement = mk.icon || null;
					markerSettings['single'].color = mk.color;
					markerSettings['single'].size = mk.size;
					addMarker(mk.coordinates);
				});
			} else if (config.marker) {
				addMarker(config.marker);
			}

			// Restore title fields
			const titleInput = document.querySelector('.map__title .content textarea:nth-child(2)');
			const subtitleInput = document.querySelector('.map__title .content textarea:nth-child(4)');

			if (titleInput && config.title) {
				titleInput.value = config.title;
			}

			if (subtitleInput && config.subtitle) {
				subtitleInput.value = config.subtitle;
			}

			showExportMessage('Konfiguration geladen!');
		} catch (error) {
			showExportMessage('Fehler beim Laden der Konfiguration.', 'error');
		}
	} else {
		showExportMessage('Keine gespeicherte Konfiguration gefunden.', 'error');
	}
}

// PROJ-25 Commit 3: Marker-Verwaltung generalisiert auf mapId ('single' | 'double-1/2' | 'triple-1/2/3').

// Liefert die Mapbox-Karteninstanz zu einer mapId.
function getMapForId(mapId) {
	switch (mapId) {
		case 'single': return map;
		case 'double-1': return map1;
		case 'double-2': return map2;
		case 'triple-1': return map1Triple;
		case 'triple-2': return map2Triple;
		case 'triple-3': return map3Triple;
	}
	return null;
}

// Erstellt eine Marker-Instanz aus markerSettings[mapId], hängt dragend (Position→Liste,
// bei Single zusätzlich updateMarkerAddress) und Klick-zum-Auswählen an. Kein State-Push.
function makeMarkerInstance(mapId, coordinates) {
	const targetMap = getMapForId(mapId);
	if (!targetMap) return null;
	const s = markerSettings[mapId];
	const el = buildMarkerElement(s.iconElement, s.color, s.size);
	const marker = el
		? new mapboxgl.Marker({ element: el, draggable: true, anchor: 'center', offset: [0, 0] })
		: new mapboxgl.Marker({ color: s.color, draggable: true, anchor: 'center', offset: [0, 0] });
	marker.setLngLat(coordinates).addTo(targetMap);
	marker.on('dragend', function() {
		if (mapId === 'single') updateMarkerAddress(marker.getLngLat());
		renderMarkerList(mapId);
	});
	marker.getElement().addEventListener('click', function(ev) {
		ev.stopPropagation();
		const i = mapMarkers[mapId].findIndex(function(en) { return en.instance === marker; });
		if (i < 0) return;
		// Erneutes Antippen des ausgewählten Markers wählt ab (ersetzt „Tipp auf leere Karte wählt ab")
		if (i === selectedMarker[mapId]) { selectedMarker[mapId] = -1; renderMarkerList(mapId); }
		else selectMarker(mapId, i);
	});
	return marker;
}

// Fügt einen neuen Marker zu einer Karte hinzu (Klick/Adresse/GPS) und wählt ihn aus.
function addMarkerTo(mapId, coordinates) {
	const marker = makeMarkerInstance(mapId, coordinates);
	if (!marker) return null;
	const s = markerSettings[mapId];
	const entry = { instance: marker, icon: s.iconElement, color: s.color, size: s.size };
	mapMarkers[mapId].push(entry);
	selectedMarker[mapId] = mapMarkers[mapId].length - 1;
	lastPlacedMarker[mapId] = mapMarkers[mapId].length - 1;
	// One-Shot: jeder gesetzte Marker (Klick, Adresse, Koordinaten, GPS) entschärft die Platzierung
	disarmMarkerPlacement(mapId);
	renderMarkerList(mapId);
	return entry;
}

// Entfernt alle Marker einer Karte und leert das Array.
function clearMarkers(mapId) {
	(mapMarkers[mapId] || []).forEach(function(en) { if (en.instance) en.instance.remove(); });
	mapMarkers[mapId] = [];
	selectedMarker[mapId] = -1;
	lastPlacedMarker[mapId] = -1;
	renderMarkerList(mapId);
}
function clearSingleMarkers() { clearMarkers('single'); }

// Verschiebt einen bestehenden Marker (Tipp auf leere Karte) — gleicher Folgezustand wie der dragend-Handler.
function moveMarkerTo(mapId, idx, lngLat) {
	const en = (mapMarkers[mapId] || [])[idx];
	if (!en || !en.instance) return false;
	en.instance.setLngLat(lngLat);
	if (mapId === 'single') updateMarkerAddress(en.instance.getLngLat());
	renderMarkerList(mapId);
	return true;
}

// Baut den AUSGEWÄHLTEN Marker einer Karte neu — nach Icon-/Farb-/Größenwechsel.
function rebuildSelectedMarker(mapId) {
	mapId = mapId || 'single';
	const idx = selectedMarker[mapId];
	const en = mapMarkers[mapId][idx];
	if (!en || !en.instance) return;
	const ll = en.instance.getLngLat();
	en.instance.remove();
	const s = markerSettings[mapId];
	en.instance = makeMarkerInstance(mapId, [ll.lng, ll.lat]);
	en.icon = s.iconElement; en.color = s.color; en.size = s.size;
	renderMarkerList(mapId);
}

// Wählt einen Marker aus: Panel-Werte auf dessen Werte setzen + Liste hervorheben.
// Entschärft die Platzierung: Auswahl = Bearbeiten-Modus, kein versehentlicher neuer Marker.
function selectMarker(mapId, idx) {
	if (idx < 0 || idx >= mapMarkers[mapId].length) return;
	disarmMarkerPlacement(mapId);
	selectedMarker[mapId] = idx;
	const en = mapMarkers[mapId][idx];
	markerSettings[mapId].iconElement = en.icon;
	markerSettings[mapId].color = en.color;
	markerSettings[mapId].size = en.size;
	syncMarkerPanel(mapId);
	renderMarkerList(mapId);
}

// Entfernt einen einzelnen Marker und zieht die Auswahl nach.
function removeMarker(mapId, idx) {
	const en = mapMarkers[mapId][idx];
	if (!en) return;
	if (en.instance) en.instance.remove();
	mapMarkers[mapId].splice(idx, 1);
	if (mapMarkers[mapId].length === 0) selectedMarker[mapId] = -1;
	else if (selectedMarker[mapId] >= mapMarkers[mapId].length) selectedMarker[mapId] = mapMarkers[mapId].length - 1;
	// Zielmarker nachziehen: Index davor bleibt, Index dahinter rückt auf, leer → -1
	if (mapMarkers[mapId].length === 0) lastPlacedMarker[mapId] = -1;
	else if (lastPlacedMarker[mapId] > idx) lastPlacedMarker[mapId] -= 1;
	else if (lastPlacedMarker[mapId] >= mapMarkers[mapId].length) lastPlacedMarker[mapId] = mapMarkers[mapId].length - 1;
	// Alle weg, Toggle noch an → wieder scharf, damit der nächste Tipp setzt statt ins Leere zu gehen
	if (mapMarkers[mapId].length === 0) {
		const m = getMapForId(mapId);
		if (m && m._markerClickHandler) armMarkerPlacement(mapId);
	}
	renderMarkerList(mapId);
}

// Rendert die Marker-Liste einer Karte (Container `.marker-list[data-map="<mapId>"]`).
function renderMarkerList(mapId) {
	mapId = mapId || 'single';
	const container = document.querySelector('.marker-list[data-map="' + mapId + '"]');
	if (!container) return;
	const tpl = document.getElementById('marker-list-item');
	container.innerHTML = '';
	const list = mapMarkers[mapId] || [];
	container.style.display = list.length ? 'block' : 'none';
	list.forEach(function(en, i) {
		let row;
		if (tpl && tpl.content && tpl.content.firstElementChild) {
			row = tpl.content.firstElementChild.cloneNode(true);
		} else {
			row = document.createElement('div');
			row.className = 'marker-list__item';
			row.innerHTML = '<span class="marker-list__num"></span><span class="marker-list__dot"></span><span class="marker-list__label"></span><a href="#" class="marker-list__remove" aria-label="Marker entfernen">&times;</a>';
		}
		row.classList.toggle('is-selected', i === selectedMarker[mapId]);
		row.setAttribute('data-index', i);
		const ll = en.instance.getLngLat();
		const numEl = row.querySelector('.marker-list__num');
		const dotEl = row.querySelector('.marker-list__dot');
		const labelEl = row.querySelector('.marker-list__label');
		if (numEl) numEl.textContent = (i + 1);
		if (dotEl) dotEl.style.background = en.color;
		if (labelEl) labelEl.textContent = formatCoordsDMS(ll.lat, ll.lng);
		container.appendChild(row);
	});
}

// Setzt die Picker-UI (aktiver Größen-Button) im Panel der Karte auf die Panel-Werte.
function syncMarkerPanel(mapId) {
	mapId = mapId || 'single';
	const s = markerSettings[mapId];
	const $info = mapId === 'single'
		? $('.markers__wrapper .marker__info')
		: $('[data-map="' + mapId + '"]').closest('.marker__info');
	if (!$info.length) return;
	// Größe: aktiven Button setzen
	$info.find('.marker__size-btn').removeClass('active');
	$info.find('.marker__size-btn[data-size="' + s.size + '"]').addClass('active');
	// Farbe: passenden Preset markieren (hex-Vergleich), sonst Custom
	const $links = $info.find('.marker__color .wrap a');
	$links.removeClass('current');
	let matched = false;
	$links.each(function() {
		if ($(this).hasClass('custom')) return;
		let c = $(this).find('.color').css('background-color');
		if (c && c.indexOf('rgb') === 0) c = rgbToHex(c);
		if (c && s.color && c.toUpperCase() === s.color.toUpperCase()) {
			$(this).addClass('current'); matched = true; return false;
		}
	});
	if (!matched) $info.find('.marker__color a.custom').addClass('current');
}

// Serialisiert alle Marker einer Karte für den Cart-/Print-Payload (Struktur server-kompatibel:
// {coordinates:[lng,lat], icon:<svg-outerHTML>, color, size, enabled}). Icon DOM-first wie zuvor.
function collectMarkers(mapId) {
	return (mapMarkers[mapId] || []).map(function(en) {
		const ll = en.instance.getLngLat();
		const el = en.instance.getElement();
		const svg = el ? el.querySelector('svg') : null;
		return {
			coordinates: [ll.lng, ll.lat],
			icon: svg ? svg.outerHTML : ((el && el.innerHTML) || en.icon || ''),
			color: en.color,
			size: en.size,
			enabled: true
		};
	});
}

function toggleMapMarker() {
	const markerCheckbox = document.querySelector('.details__wrapper .map__marker input[type="checkbox"], .markers__wrapper .map__marker input[type="checkbox"]');

	if (markerCheckbox && markerCheckbox.checked) {
		// Enable click-to-place marker mode (scharf für den ersten Marker; Toast kommt aus armMarkerPlacement)
		enableMarkerPlacement();
		// Show marker info section for single layout
		$('.details__wrapper .marker__info, .markers__wrapper .marker__info').slideDown(300);
	} else {
		// Sicherheitsabfrage ab 2 Markern: erst beim zweiten Antippen wirklich alle entfernen
		if (mapMarkers['single'].length >= 2 && markerCheckbox && !markerCheckbox._confirmClear) {
			markerCheckbox.checked = true;
			markerCheckbox._confirmClear = true;
			showMarkerInstruction('Nochmal antippen, um alle ' + mapMarkers['single'].length + ' Marker zu entfernen');
			setTimeout(function() { if (markerCheckbox) markerCheckbox._confirmClear = false; }, 4000);
			return;
		}
		if (markerCheckbox) markerCheckbox._confirmClear = false;
		// Disable marker placement mode
		disableMarkerPlacement();
		clearSingleMarkers();
		// Hide marker info section for single layout
		$('.details__wrapper .marker__info, .markers__wrapper .marker__info').slideUp(300);
	}
}

// Schaltet die One-Shot-Platzierung einer Karte scharf (Crosshair + Hinweis-Toast).
function armMarkerPlacement(mapId) {
	const m = getMapForId(mapId);
	if (!m) return;
	markerPlacementArmed[mapId] = true;
	m.getCanvas().style.cursor = 'crosshair';
	showMarkerInstruction('Klicke oder tippe auf die Karte, um einen Marker zu setzen');
}

// Entschärft die Platzierung (Karten-Klicks setzen nichts mehr, Cursor normal).
function disarmMarkerPlacement(mapId) {
	markerPlacementArmed[mapId] = false;
	const m = getMapForId(mapId);
	if (m) m.getCanvas().style.cursor = '';
}

// Enable click/tap to place marker on map
function enableMarkerPlacement() {
	if (!map) return;

	// Scharf für den ersten Marker (Toggle-an ist eine bewusste Nutzer-Aktion)
	armMarkerPlacement('single');

	// Remove existing click handler if any
	if (map._markerClickHandler) {
		map.off('click', map._markerClickHandler);
	}

	// One-Shot: nur scharf gestellt setzt ein Klick einen Marker, danach wird entschärft.
	map._markerClickHandler = function(e) {
		// Klick auf einen bestehenden Marker → nicht neu setzen; dessen Element-Listener wählt ihn aus.
		const tgt = e.originalEvent && e.originalEvent.target;
		if (tgt && tgt.closest && tgt.closest('.mapboxgl-marker')) return;
		if (!markerPlacementArmed['single']) {
			// Entschärft: Tipp auf leere Karte verschiebt den Zielmarker (ausgewählt, sonst zuletzt gesetzt).
			// Kein neuer Marker, kein Abwählen — Abwahl geht per erneutem Antippen des Markers/der Listenzeile.
			const target = selectedMarker['single'] >= 0 ? selectedMarker['single'] : lastPlacedMarker['single'];
			if (!moveMarkerTo('single', target, [e.lngLat.lng, e.lngLat.lat]) && mapMarkers['single'].length === 0) {
				armMarkerPlacement('single');
			}
			return;
		}
		addMarker([e.lngLat.lng, e.lngLat.lat]);
		// Abwählen, damit der nächste Symbol-Klick einen NEUEN Marker scharfschaltet statt diesen zu ändern
		selectedMarker['single'] = -1;
		renderMarkerList('single');
		showMarkerInstruction('Marker gesetzt. Tippe oder ziehe, um ihn zu verschieben. Für einen weiteren Marker ein Symbol antippen');
	};

	map.on('click', map._markerClickHandler);
}

// Disable marker placement mode
function disableMarkerPlacement() {
	if (!map) return;

	disarmMarkerPlacement('single');

	// Remove click handler
	if (map._markerClickHandler) {
		map.off('click', map._markerClickHandler);
		map._markerClickHandler = null;
	}
}

// Show instruction message
let markerInstructionTimeout = null; // Store timeout ID for auto-hide
function showMarkerInstruction(message) {
	let instructionDiv = document.querySelector('.marker-instruction');
	if (!instructionDiv) {
		instructionDiv = document.createElement('div');
		instructionDiv.className = 'marker-instruction';
		instructionDiv.style.cssText = `
			position: fixed;
			top: 20px;
			left: 50%;
			transform: translateX(-50%);
			background: rgba(0, 0, 0, 0.8);
			color: white;
			padding: 12px 24px;
			border-radius: 8px;
			z-index: 10000;
			font-size: 14px;
			font-weight: 500;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
			pointer-events: none;
		`;
		document.body.appendChild(instructionDiv);
	}
	instructionDiv.textContent = message;
	instructionDiv.style.display = 'block';

	// Clear any existing timeout
	if (markerInstructionTimeout) {
		clearTimeout(markerInstructionTimeout);
	}

	// Auto-hide after 5 seconds
	markerInstructionTimeout = setTimeout(function() {
		hideMarkerInstruction();
	}, 5000);
}

// Hide instruction message
function hideMarkerInstruction() {
	const instructionDiv = document.querySelector('.marker-instruction');
	if (instructionDiv) {
		instructionDiv.style.display = 'none';
	}
}

// Update marker address via reverse geocoding
function updateMarkerAddress(lngLat) {
	const lang = window.searchLanguage || 'de';
	fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${lngLat.lng},${lngLat.lat}.json?access_token=${mapboxgl.accessToken}&language=${lang}`)
		.then(response => response.json())
		.then(data => {
			if (data.features && data.features.length > 0) {
				const place = data.features[0];
				const addressInput = document.querySelector('.details__wrapper .marker__info .address__info input[type="text"], .markers__wrapper .marker__info .address__info input[type="text"]');
				if (addressInput) {
					addressInput.value = place.place_name;
				}
			}
		})
}

function updateMapTitle() {
	const titleCheckbox = document.querySelector('.details__wrapper .map__title .title input[type="checkbox"], .markers__wrapper .map__title .title input[type="checkbox"]');
	const posterTitle = document.querySelector('.poster-title');

	if (titleCheckbox && titleCheckbox.checked) {
		$('.details__wrapper .map__title .content, .markers__wrapper .map__title .content').slideDown(300);
		if (posterTitle) {
			posterTitle.style.display = 'block';
		}
	} else {
		$('.details__wrapper .map__title .content, .markers__wrapper .map__title .content').slideUp(300);
		if (posterTitle) {
			posterTitle.style.display = 'none';
		}
	}
}

function changeMapLayout(layoutType) {
	// Update current layout tracker
	currentLayout = layoutType;

	// Check if switching to double or triple map layout
	if (layoutType === 'double-map') {
		switchMapLayout(true, false);
		return;
	} else if (layoutType === 'triple-map') {
		switchMapLayout(false, true);
		return;
	} else if (isDoubleMapLayout || isTripleMapLayout) {
		// If we were in double or triple map mode, switch back to single
		switchMapLayout(false, false);
	}

	// Handle different layout shapes (circle, heart, square, puzzle, story)
	const mapContainer = document.getElementById('map');
	const photoUploadContainer = document.querySelector('.photo-upload-container');


	// Remove existing layout classes and SVG shape clip/overlay
	mapContainer.className = mapContainer.className.replace(/layout-\w+/g, '');
	removeShapeClip(mapContainer);

	$("#map canvas, #map").css({
		"max-height": document.querySelector('#map canvas')?.clientWidth*100 + "px",
	});
	
	
	setTimeout(()=>{
		mapCanvas = document.querySelector('#map canvas');
	titleContainer = document.querySelector('.map-preview-title')
		// $("#map").css({
		// 	"max-height": 'calc(85vh - '+titleContainer.clientHeight+'px)',
		// });
}, 400)


	// Add new layout class
	if (layoutType !== 'default') {
		mapContainer.classList.add(`layout-${layoutType}`);
	}

	// Ensure proper dimensions for the new layout
	resizeFrame();

	// Ensure map container is always visible
	mapContainer.style.display = 'block';
	mapContainer.style.visibility = 'visible';
	mapContainer.style.opacity = '1';

	if (map && map.loaded()) {
		setTimeout(function() {
			map.resize();
		}, 450);
	}

	// Handle photo upload interface for "With Photo" and "Valentine" layouts
	if (layoutType === 'with-photo') {
			showPhotoInTitleArea();
			// Remove with-valentine class if switching from valentine to photo
			const previewTitle = document.querySelector('.map-preview-title');
			if (previewTitle) {
				previewTitle.classList.remove('with-valentine');
			}
			mapContainer.style.clipPath = 'none';
			mapContainer.style.borderRadius = '0';

			const mapCanvas = document.querySelector('#map canvas');
			const photoPreviewImg = document.querySelector('.photo-preview img');
			if (mapCanvas && photoPreviewImg) {
				// $("#map canvas, #map").css({
				// 	"max-height": mapCanvas.clientHeight - photoPreviewImg.clientHeight + 50 + "px",
				// });
			}

			if (map && map.loaded()) {
				setTimeout(function() {
					map.resize();
				}, 150);
			}
		} else if (layoutType === 'heart') {
			// Check if there's already an uploaded photo and update SVG if needed
			const existingPhoto = uploadedPhotoUrl || uploadedPhotoData || (isPrintMode ? (printConfig.uploadedPhotoUrl || printConfig.uploadedPhoto) : null);
			if (existingPhoto) {
				// Ensure SVG is updated with current photo before showing
				updateValentineSvgHref(existingPhoto);
			}

		// Apply current background color to valentine SVG outline
		const currentBgColor = $('.map-preview-title').css('background-color') || '#ffffff';
		if (currentBgColor !== 'rgba(0, 0, 0, 0)' && currentBgColor !== 'transparent') {
			updateValentineSvgOutlineColor(currentBgColor);
		}

			showValentinePhotoInTitleArea();
			// Remove with-photo class if it exists
			const previewTitle = document.querySelector('.map-preview-title');
			if (previewTitle) {
				previewTitle.classList.remove('with-photo');
			}
			// Keep map layout the same as with-photo (no clip-path changes)
			mapContainer.style.clipPath = 'none';
			mapContainer.style.borderRadius = '0';
		} else if (layoutType === 'circle' || layoutType === 'full-heart') {
		// Hide photo preview for shape layouts
		const photoPreview = document.querySelector('.photo-preview');
		if (photoPreview) {
			photoPreview.remove();
		}
		// Remove with-photo and with-valentine classes from title
		const previewTitle = document.querySelector('.map-preview-title');
		if (previewTitle) {
			previewTitle.classList.remove('with-photo', 'with-valentine');
		}

		// Apply SVG clip-path and frame overlay
		applyShapeClip(layoutType);
		updateShapeOverlaySize();

		// Resize map after shape is applied
		if (map && map.loaded()) {
			setTimeout(function() {
				map.resize();
				updateShapeOverlaySize();
			}, 200);
		}
	} else {
		// Hide photo preview for other layouts
		const photoPreview = document.querySelector('.photo-preview');
		if (photoPreview) {
			photoPreview.remove();
		}
		// Remove with-photo and with-valentine classes from title
		const previewTitle = document.querySelector('.map-preview-title');
		if (previewTitle) {
			previewTitle.classList.remove('with-photo', 'with-valentine');
		}

		// Square/default — no clip-path
		mapContainer.style.clipPath = 'none';
		mapContainer.style.borderRadius = layoutType === 'square' ? '0' : '8px';
	}

	// Apply current background color to all elements after layout change
	setTimeout(function() {
		applyBackgroundColorToAllElements();
	}, 200);
}

// Liest die Mockup-URL aus dem data-photo-mockup-url Attribut auf
// .citymap-customizer (Liquid asset_url-resolved). Fallback leer.
// Wird im no-photo-Fall der Show-Funktionen genutzt, damit das
// Vorschaubild aussieht wie nach einem realen Upload + Crop.
function getPhotoMockupUrl() {
	const c = document.querySelector('.citymap-customizer');
	return (c && c.dataset.photoMockupUrl) || '';
}

// Toggelt die Foto-Upload-Section zwischen Layout und Ausrichtung
// basierend auf currentLayout. Sichtbar nur wenn ein Foto-Layout
// aktiv ist (with-photo / heart). Wird im Layout-Click-Handler nach
// jedem Wechsel + initial im DOM-ready aufgerufen.
function syncPhotoUploadSectionVisibility() {
	const section = document.getElementById('citymap-photo-upload');
	if (!section) return;
	section.style.display = (currentLayout === 'with-photo' || currentLayout === 'heart') ? '' : 'none';
	syncPhotoChangeRowVisibility();
}

// V9.96.26b: Mama-Pattern — Upload-Button vs Change-Row Toggle.
// Wenn ein Foto hochgeladen ist (uploadedPhotoUrl/Data oder printConfig) →
// Upload-Button + Hint ausblenden, .photo-change-row.visible einblenden.
// Sonst andersrum.
function syncPhotoChangeRowVisibility() {
	const button = document.getElementById('citymap-photo-upload-zone');
	const hint = document.querySelector('.citymap-customizer .photo-upload-hint');
	const row = document.getElementById('citymap-photo-change-row');
	if (!button || !row) return;
	const hasPhoto = !!(uploadedPhotoUrl || uploadedPhotoData);
	if (hasPhoto) {
		button.style.display = 'none';
		if (hint) hint.style.display = 'none';
		row.classList.add('visible');
	} else {
		button.style.display = '';
		if (hint) hint.style.display = '';
		row.classList.remove('visible');
	}
}

// Liefert den passenden Upload-Handler je nach aktivem Foto-Layout.
// Genutzt von der neuen Upload-Section (Click + Drag-Drop). Beide
// Handler (handlePhotoUpload, handleValentinePhotoUpload) erwarten
// ein Event mit event.target.files.
function getActivePhotoUploadHandler() {
	return (currentLayout === 'heart') ? handleValentinePhotoUpload : handlePhotoUpload;
}

// Function to show photo in title area
function showPhotoInTitleArea() {

	// Add with-photo class to title area
	const previewTitle = document.querySelector('.map-preview-title');
	if (previewTitle) {
		previewTitle.classList.add('with-photo');
	}

	// Remove existing photo preview
	const existingPreview = document.querySelector('.photo-preview');
	if (existingPreview) {
		existingPreview.remove();
	}

	// Create photo preview container
	const photoPreview = document.createElement('div');
	photoPreview.className = 'photo-preview';

	// Check if photo is already uploaded (prioritize S3 URL over base64)
	const uploadedPhoto = uploadedPhotoUrl || uploadedPhotoData || (isPrintMode ? (printConfig.uploadedPhotoUrl || printConfig.uploadedPhoto) : null);
	if (uploadedPhoto) {
		// Show uploaded photo preview - use regular img tag for "With Photo" layout
		photoPreview.innerHTML = `
			<img src="${uploadedPhoto}" alt="Uploaded photo" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">
		`;

		// Add click handler to open photo management popup
		photoPreview.addEventListener('click', function() {
			openPhotoManagementPopup(uploadedPhoto);
		});
	} else {
		// Show default mockup photo so the customer sees the end-product
		// look directly. Same markup as uploaded-Fall (Z. above), nur mit
		// mockupUrl. Click-Handler unten bleibt unveraendert — er triggert
		// den File-Picker.
		const mockupUrl = getPhotoMockupUrl();
		photoPreview.innerHTML = `
			<img src="${mockupUrl}" alt="" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">
		`;

		// Add click handler for upload
		photoPreview.addEventListener('click', function() {
			const input = document.createElement('input');
			input.type = 'file';
			input.accept = 'image/jpeg,image/jpg,image/png';
			input.style.display = 'none';
			input.addEventListener('change', handlePhotoUpload);
			document.body.appendChild(input);
			input.click();
			document.body.removeChild(input);
		});
	}

	// Add to title area
	if (previewTitle) {
		previewTitle.appendChild(photoPreview);
	}

	// Apply current background color immediately after creation
	const backgroundColor = customColors.background || '#FFFFFF';
	$(photoPreview).css('background-color', backgroundColor);
}

// Function to show valentine photo in title area
function showValentinePhotoInTitleArea() {

	// Add with-valentine class to title area
	const previewTitle = document.querySelector('.map-preview-title');
	if (previewTitle) {
		previewTitle.classList.add('with-valentine');
	}

	// Remove existing photo preview
	const existingPreview = document.querySelector('.photo-preview');
	if (existingPreview) {
		existingPreview.remove();
	}

	// Create photo preview container with valentine styling
	const photoPreview = document.createElement('div');
	photoPreview.className = 'photo-preview with-valentine';

	// Check if photo is already uploaded (prioritize S3 URL over base64)
	const uploadedPhoto = uploadedPhotoUrl || uploadedPhotoData || (isPrintMode ? (printConfig.uploadedPhotoUrl || printConfig.uploadedPhoto) : null);
	if (uploadedPhoto) {
		// For valentine layout, always use SVG approach
		const valentineSvgTextarea = document.getElementById('valentine-svg');
		if (valentineSvgTextarea) {
			// Get current SVG content
			let svgContent = valentineSvgTextarea.value;


			// FORCE update the SVG href to ensure it has the current photo
			svgContent = svgContent.replace(
				/href="[^"]*"/,
				`href="${uploadedPhoto}"`
			);
			// Update the textarea as well
			valentineSvgTextarea.value = svgContent;

			// Use the SVG content directly
			photoPreview.innerHTML = svgContent;
		} else {
			// Fallback to img if textarea not found
			photoPreview.innerHTML = `
				<img src="${uploadedPhoto}" alt="Uploaded photo" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">
			`;
		}

		// Add click handler to open valentine photo management popup
		photoPreview.addEventListener('click', function() {
			openValentinePhotoManagementPopup(uploadedPhoto);
		});
	} else {
		// Show default mockup photo in heart-form (SVG clip-path same as
		// uploaded case). Server-Print bleibt unberuehrt, weil der
		// Mockup-Upload-State nie gesetzt wird — uploadedPhotoUrl/Data
		// sind weiterhin null bis User echtes Foto hochlaedt. Click-
		// Handler unten bleibt unveraendert.
		const mockupUrl = getPhotoMockupUrl();
		const valentineSvgTextarea = document.getElementById('valentine-svg');
		if (valentineSvgTextarea && mockupUrl) {
			let svgContent = valentineSvgTextarea.value;
			svgContent = svgContent.replace(/href="[^"]*"/, `href="${mockupUrl}"`);
			photoPreview.innerHTML = svgContent;
		} else {
			photoPreview.innerHTML = `<img src="${mockupUrl}" alt="" style="width:100%;height:100%;object-fit:cover;">`;
		}

		// Add click handler for upload
		photoPreview.addEventListener('click', function() {
			const input = document.createElement('input');
			input.type = 'file';
			input.accept = 'image/jpeg,image/jpg,image/png';
			input.style.display = 'none';
			input.addEventListener('change', handleValentinePhotoUpload);
			document.body.appendChild(input);
			input.click();
			document.body.removeChild(input);
		});

	}

	// Add to title area
	if (previewTitle) {
		previewTitle.appendChild(photoPreview);
	}

	// Apply current background color to valentine outline immediately after creation
	const backgroundColor = customColors.background || '#FFFFFF';
	$(photoPreview).find('path.outline').css('fill', backgroundColor);
}


// Function to handle photo upload
function handlePhotoUpload(event) {
 	const file = event.target.files[0];
 	if (!file) return;

 	// Validate file type - only allow JPG, JPEG, and PNG
 	const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
 	if (!validTypes.includes(file.type.toLowerCase())) {
 		showToast('Ungültiges Dateiformat. Bitte wähle ein JPG, JPEG oder PNG Bild.');
 		return;
 	}

 	// Validate file size (100MB limit)
 	if (file.size > 100 * 1024 * 1024) {
 		showToast('Bitte wähle ein Bild unter 100MB.');
 		return;
 	}

 	const reader = new FileReader();
 	reader.onload = function(e) {
 		const photoData = e.target.result;

 		// V9.96.26b: cache base64 für "Neu zuschneiden"
 		window.__cmLastUploadedPhotoData = photoData;

 		// Open crop popup immediately after upload
 		openCropPopupAfterUpload(photoData);

 	};

 	reader.onerror = function() {
 		showToast('Fehler beim Lesen der Datei. Bitte versuche es erneut.');
 	};

 	reader.readAsDataURL(file);
}

// Function to handle valentine photo upload
function handleValentinePhotoUpload(event) {
 	const file = event.target.files[0];
 	if (!file) return;

 	// Validate file type - only allow JPG, JPEG, and PNG
 	const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
 	if (!validTypes.includes(file.type.toLowerCase())) {
 		showToast('Ungültiges Dateiformat. Bitte wähle ein JPG, JPEG oder PNG Bild.');
 		return;
 	}

 	// Validate file size (100MB limit)
 	if (file.size > 100 * 1024 * 1024) {
 		showToast('Bitte wähle ein Bild unter 100MB.');
 		return;
 	}

 	const reader = new FileReader();
 	reader.onload = function(e) {
 		const photoData = e.target.result;

 		// V9.96.26b: cache base64 für "Neu zuschneiden"
 		window.__cmLastUploadedPhotoData = photoData;

 		// Open crop popup for valentine
 		openValentineCropPopupAfterUpload(photoData);

 	};

 	reader.onerror = function() {
 		showToast('Fehler beim Lesen der Datei. Bitte versuche es erneut.');
 	};

 	reader.readAsDataURL(file);
}

// Function to change photo
function changePhoto() {
	document.getElementById('photo-input').click();
}

// Function to remove photo
function removePhoto() {
	uploadedPhotoUrl = null; // Clear S3 URL
	uploadedPhotoData = null; // Clear global variable
	showPhotoInTitleArea();
}

// Function to open photo management popup
function openPhotoManagementPopup(currentPhoto) {
	// Remove existing popup
	const existingPopup = document.querySelector('.photo-management-popup');
	if (existingPopup) {
		existingPopup.remove();
	}

	// Create popup overlay
	const popupOverlay = document.createElement('div');
	popupOverlay.className = 'photo-management-popup';
	popupOverlay.style.cssText = `
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.8);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 10000;
	`;

	// Create popup content
	const popupContent = document.createElement('div');
	popupContent.style.cssText = `
		background: white;
		border-radius: 12px;
		padding: 30px;
		max-width: 500px;
		width: 90%;
		text-align: center;
		position: relative;
	`;

	const cropTexts = getCropTexts();
	popupContent.innerHTML = `
		<div style="margin-bottom: 25px;">
			<img src="${currentPhoto}" alt="Current photo" style="border-radius: 50%;margin: auto;max-width: 100%; max-height: 200px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
		</div>
		<div style="margin-bottom: 20px;">
			<button onclick="changePhotoFromPopup()" style="padding: 12px 24px; margin-right: 10px; background: #000000; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px;">${cropTexts.changePhoto}</button>
			<button onclick="cropPhotoFromPopup()" style="display: none;padding: 12px 24px; margin-right: 10px; background: #4CAF50; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px;">${cropTexts.cropPhoto}</button>
			<button onclick="removePhotoFromPopup()" style="padding: 12px 24px; background: #6c757d; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px;">${cropTexts.removePhoto}</button>
		</div>
		<button onclick="closePhotoManagementPopup()" style="position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 24px; cursor: pointer; color: #666;">×</button>
	`;

	popupOverlay.appendChild(popupContent);
	document.body.appendChild(popupOverlay);

	// Close popup when clicking outside
	popupOverlay.addEventListener('click', function(e) {
		if (e.target === popupOverlay) {
			closePhotoManagementPopup();
		}
	});
}

// Function to open valentine photo management popup
function openValentinePhotoManagementPopup(currentPhoto) {
	// Remove existing popup
	const existingPopup = document.querySelector('.photo-management-popup, .valentine-photo-management-popup');
	if (existingPopup) {
		existingPopup.remove();
	}

	// Create popup overlay with valentine styling
	const popupOverlay = document.createElement('div');
	popupOverlay.className = 'valentine-photo-management-popup';
	popupOverlay.style.cssText = `
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.8);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 10000;
	`;

	// Create popup content with valentine styling
	const popupContent = document.createElement('div');
	popupContent.style.cssText = `
		background: linear-gradient(135deg, #fff 0%, #fde3da 100%);
		border-radius: 16px;
		padding: 30px;
		max-width: 500px;
		width: 90%;
		text-align: center;
		position: relative;
		border: 2px solid #000000;
		box-shadow: 0 8px 32px rgba(247, 113, 71, 0.3);
	`;

	// Get the SVG content for valentine display
	const valentineSvgTextarea = document.getElementById('valentine-svg');
	let photoDisplay = '';
	if (valentineSvgTextarea) {
		const svgContent = valentineSvgTextarea.value;
		// Use SVG content if available, otherwise fallback to img
		if (svgContent.includes(currentPhoto)) {
			photoDisplay = svgContent;
		} else {
			photoDisplay = `<img src="${currentPhoto}" alt="Current photo" style="max-width: 100%; max-height: 200px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">`;
		}
	} else {
		photoDisplay = `<img src="${currentPhoto}" alt="Current photo" style="max-width: 100%; max-height: 200px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">`;
	}

	const cropTexts = getCropTexts();
	popupContent.innerHTML = `
		<div style="margin-bottom: 25px; font-family: 'Poppins', sans-serif;">
			<div style="background: white; border-radius: 12px; padding: 15px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
				${photoDisplay}
			</div>
		</div>
		<div style="margin-bottom: 20px; display: flex; justify-content: center; gap: 10px; flex-wrap: wrap;">
			<button onclick="changeValentinePhotoFromPopup()" style="padding: 12px 24px; background: #000000; color: white; border: none; border-radius: 25px; cursor: pointer; font-size: 16px; font-weight: 600; min-width: 120px; transition: all 0.3s ease;" onmouseover="this.style.background='#e53422'" onmouseout="this.style.background='#000000'">${cropTexts.changePhoto}</button>
			<button onclick="cropValentinePhotoFromPopup()" style="display: none;padding: 12px 24px; background: #4CAF50; color: white; border: none; border-radius: 25px; cursor: pointer; font-size: 16px; font-weight: 600; min-width: 120px; transition: all 0.3s ease;" onmouseover="this.style.background='#45a049'" onmouseout="this.style.background='#4CAF50'">${cropTexts.cropPhoto}</button>
			<button onclick="removeValentinePhotoFromPopup()" style="padding: 12px 24px; background: #6c757d; color: white; border: none; border-radius: 25px; cursor: pointer; font-size: 16px; font-weight: 600; min-width: 120px; transition: all 0.3s ease;" onmouseover="this.style.background='#5a6268'" onmouseout="this.style.background='#6c757d'">${cropTexts.removePhoto}</button>
		</div>
		<button onclick="closeValentinePhotoManagementPopup()" style="position: absolute; top: 15px; right: 15px; background: #000000; color: white; border: none; font-size: 20px; cursor: pointer; width: 35px; height: 35px; border-radius: 50%; display: flex; align-items: center; justify-content: center; transition: all 0.3s ease;" onmouseover="this.style.background='#e53422'" onmouseout="this.style.background='#000000'">×</button>
	`;

	popupOverlay.appendChild(popupContent);
	document.body.appendChild(popupOverlay);

	// Close popup when clicking outside
	popupOverlay.addEventListener('click', function(e) {
		if (e.target === popupOverlay) {
			closeValentinePhotoManagementPopup();
		}
	});

}

// Function to close photo management popup
function closePhotoManagementPopup() {
	const popup = document.querySelector('.photo-management-popup');
	if (popup) {
		popup.remove();
	}
}

// Function to close valentine photo management popup
function closeValentinePhotoManagementPopup() {
	const popup = document.querySelector('.valentine-photo-management-popup');
	if (popup) {
		popup.remove();
	}
}

// Function to change photo from popup
function changePhotoFromPopup() {
	closePhotoManagementPopup();
	const input = document.createElement('input');
	input.type = 'file';
	input.accept = 'image/jpeg,image/jpg,image/png';
	input.style.display = 'none';
	input.addEventListener('change', handlePhotoUpload);
	document.body.appendChild(input);
	input.click();
	document.body.removeChild(input);
}

// Function to crop photo from popup
function cropPhotoFromPopup() {
	closePhotoManagementPopup();
	openCropPopup();
}

// Function to remove photo from popup
function removePhotoFromPopup() {
	uploadedPhotoUrl = null; // Clear S3 URL
	uploadedPhotoData = null; // Clear global variable
	closePhotoManagementPopup();
	showPhotoInTitleArea();
}

// Function to change valentine photo from popup
function changeValentinePhotoFromPopup() {
	closeValentinePhotoManagementPopup();
	const input = document.createElement('input');
	input.type = 'file';
	input.accept = 'image/jpeg,image/jpg,image/png';
	input.style.display = 'none';
	input.addEventListener('change', handleValentinePhotoUpload);
	document.body.appendChild(input);
	input.click();
	document.body.removeChild(input);
}

// Function to crop valentine photo from popup
function cropValentinePhotoFromPopup() {
	closeValentinePhotoManagementPopup();
	// Open the valentine crop popup with current photo
	const currentPhoto = uploadedPhotoUrl || uploadedPhotoData;
	if (currentPhoto) {
		openValentineCropPopupAfterUpload(currentPhoto);
	} else {
		openCropPopup();
	}
}

// Function to remove valentine photo from popup
function removeValentinePhotoFromPopup() {
	uploadedPhotoUrl = null; // Clear S3 URL
	uploadedPhotoData = null; // Clear global variable
	closeValentinePhotoManagementPopup();
	showValentinePhotoInTitleArea();
}

// Function to open crop popup
function openCropPopup() {
	const currentPhoto = uploadedPhotoUrl || uploadedPhotoData;
	if (!currentPhoto) return;

	// Remove existing crop popup
	const existingCropPopup = document.querySelector('.crop-popup');
	if (existingCropPopup) {
		existingCropPopup.remove();
	}

	// Create crop popup overlay
	const cropOverlay = document.createElement('div');
	cropOverlay.className = 'crop-popup';
	cropOverlay.style.cssText = `
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.8);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 10001;
	`;

	// Create crop content
	const cropContent = document.createElement('div');
	cropContent.style.cssText = `
		background: white;
		border-radius: 12px;
		padding: 30px;
		max-width: 600px;
		width: 90%;
		max-height: 80vh;
		overflow-y: auto;
	`;

	const cropTexts = getCropTexts();
	cropContent.innerHTML = `
		<div style="margin-bottom: 20px; text-align: center;">
			<h3 style="margin: 0 0 20px 0; color: #16212c;">${cropTexts.title}</h3>
			<div style="position: relative; margin-bottom: 20px;">
				<img id="crop-image" src="${currentPhoto}" alt="Crop photo" style="max-width: 100%; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
			</div>
			<div style="margin-bottom: 20px;">
				<label style="display: block; margin-bottom: 10px; font-weight: 500;">Crop Shape:</label>
				<select id="crop-shape" style="padding: 8px 12px; border: 1px solid #ddd; border-radius: 4px; margin-right: 10px;">
					<option value="square">Square</option>
					<option value="circle">Circle</option>
					<option value="rectangle">Rectangle</option>
				</select>
				<button onclick="applyCrop()" style="padding: 10px 20px; background: #000000; color: white; border: none; border-radius: 6px; cursor: pointer;">${cropTexts.apply}</button>
			</div>
		</div>
		<div style="text-align: center;">
			<button onclick="closeCropPopup()" style="padding: 12px 24px; background: #6c757d; color: white; border: none; border-radius: 6px; cursor: pointer;">${cropTexts.cancel}</button>
		</div>
	`;

	cropOverlay.appendChild(cropContent);
	document.body.appendChild(cropOverlay);

	// Close crop popup when clicking outside
	cropOverlay.addEventListener('click', function(e) {
		if (e.target === cropOverlay) {
			closeCropPopup();
		}
	});
}

// Function to close crop popup (destroys the Cropper instance — prevents memory leak)
function closeCropPopup() {
	if (cropper) {
		cropper.destroy();
		cropper = null;
	}
	const popup = document.querySelector('.crop-popup');
	if (popup) {
		popup.remove();
	}
}

// Function to open crop popup after upload
function openCropPopupAfterUpload(photoData) {
 	// Remove existing crop popup
 	const existingCropPopup = document.querySelector('.crop-popup');
 	if (existingCropPopup) {
 		existingCropPopup.remove();
 	}

 	// Create crop popup overlay
 	const cropOverlay = document.createElement('div');
 	cropOverlay.className = 'crop-popup';
 	cropOverlay.style.cssText = `
 		position: fixed;
 		top: 0;
 		left: 0;
 		width: 100%;
 		height: 100%;
 		background: rgba(0, 0, 0, 0.8);
 		display: flex;
 		align-items: center;
 		justify-content: center;
 		z-index: 10001;
 	`;

 	// Create crop content
 	const cropContent = document.createElement('div');
 	cropContent.style.cssText = `
 		background: white;
 		border-radius: 12px;
 		padding: 30px;
 		max-width: 700px;
 		width: 90%;
 		max-height: 90vh;
 		overflow-y: auto;
 	`;

 	const cropTexts = getCropTexts();
 	const isMobileCrop = window.innerWidth <= 768;
 	const cropImgMaxH = isMobileCrop ? '250px' : '400px';
 	cropContent.innerHTML = `
 	<div style="margin-bottom: 20px; text-align: center;">
 		<h3 style="margin: 0 0 15px 0; color: #16212c;">${cropTexts.title}</h3>
 		<p style="margin: 0 0 15px 0; color: #666; font-size: 14px;">${cropTexts.description}</p>

 		<div style="margin-bottom: 15px; display: inline-block; position: relative; max-width: 100%;">
 			<img id="cropper-image" src="${photoData}" alt="Crop photo" style="max-width: 400px; max-height: ${cropImgMaxH}; height: auto; border-radius: 8px; display: block; margin: 0 auto;">
 		</div>

 		<div style="margin-bottom: 10px; display: flex; justify-content: center; gap: 10px; flex-wrap: wrap;">
 			<button onclick="zoomCropper(0.2)" style="padding: 10px 20px; background: #000000; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 500;">+ ${cropTexts.zoomIn}</button>
 			<button onclick="zoomCropper(-0.2)" style="padding: 10px 20px; background: #000000; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 500;">- ${cropTexts.zoomOut}</button>
 			<button onclick="rotateCropper(-90)" style="padding: 10px 20px; background: #000000; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 500;">↶</button>
 			<button onclick="rotateCropper(90)" style="padding: 10px 20px; background: #000000; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 500;">↷</button>
 			<button onclick="resetCropper()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 500;">↺ ${cropTexts.reset}</button>
 		</div>

 		<div style="margin-bottom: 10px;">
 			<button onclick="applyCropAfterUpload()" style="padding: 12px 30px; margin-right: 10px; background: #000000; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 500;">${cropTexts.apply}</button>
 			<button onclick="cancelCropAfterUpload()" style="padding: 12px 30px; background: #6c757d; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 500;">${cropTexts.cancel}</button>
 		</div>
 	</div>
 `;

 	cropOverlay.appendChild(cropContent);
 	document.body.appendChild(cropOverlay);

 	// Initialize Cropper.js
 	setTimeout(() => {
 		const cropperImage = document.getElementById('cropper-image');
 		if (cropperImage && window.Cropper) {
 			try {
 				// Destroy existing cropper if it exists
 				if (cropper) {
 					cropper.destroy();
 				}


 				// Mobile-friendly sizing
 				var isMobile = window.innerWidth <= 768;
 				var minCropSize = isMobile ? 100 : 150;

 				// Create new cropper instance - professional Instagram/Facebook style
 				cropper = new window.Cropper(cropperImage, {
 					aspectRatio: 1, // Square aspect ratio for circular crop
 					viewMode: 1,   // Restrict crop box to not exceed canvas boundaries
 					dragMode: 'move', // Move the image, not the crop box
 					modal: true,   // Show dark overlay outside crop area
 					background: true, // Show grid background
 					guides: false,  // Hide grid guides for cleaner UI
 					autoCropArea: 0.5, // Fixed crop area size
 					center: true,  // Center the crop area
 					highlight: false, // No highlight for cleaner UI
 					cropBoxMovable: true, // Allow moving the crop box
 					cropBoxResizable: true, // Allow resizing the crop box
 					toggleDragModeOnDblclick: false, // No mode toggling
 					movable: true, // Allow moving the image underneath
 					zoomable: true, // Enable zoom
 					zoomOnTouch: true, // Enable pinch-to-zoom on mobile
 					zoomOnWheel: true, // Enable mouse wheel zoom
 					wheelZoomRatio: 0.1, // Zoom ratio for mouse wheel
 					scalable: true, // Allow image scaling
 					rotatable: true, // Enable rotation
 					minCropBoxWidth: minCropSize,  // Responsive crop box size
 					minCropBoxHeight: minCropSize,
 					ready() {
 						// Set fixed crop box in center - responsive sizing
 						setTimeout(() => {
 							const containerData = cropper.getContainerData();
 							const maxSize = Math.min(containerData.width, containerData.height) * 0.7;
 							const cropBoxSize = Math.min(isMobile ? 120 : 150, maxSize);
 							cropper.setCropBoxData({
 								width: cropBoxSize,
 								height: cropBoxSize,
 								left: (containerData.width - cropBoxSize) / 2,
 								top: (containerData.height - cropBoxSize) / 2
 							});
 						}, 100);
 					}
 				});
 			} catch (error) {
 				showSimpleCropInterface(cropperImage, photoData);
 			}
 		} else {
 			if (cropperImage) {
 				showSimpleCropInterface(cropperImage, photoData);
 			}
 		}
 	}, 300); // Wait for Cropper.js to load from CDN

 	// Close crop popup when clicking outside
 	cropOverlay.addEventListener('click', function(e) {
 		if (e.target === cropOverlay) {
 			cancelCropAfterUpload();
 		}
 	});
}

// Function to open valentine crop popup after upload
function openValentineCropPopupAfterUpload(photoData) {
 	// Remove existing crop popup
 	const existingCropPopup = document.querySelector('.crop-popup');
 	if (existingCropPopup) {
 		existingCropPopup.remove();
 	}

 	// Create crop popup overlay
 	const cropOverlay = document.createElement('div');
 	cropOverlay.className = 'crop-popup';
 	cropOverlay.style.cssText = `
 		position: fixed;
 		top: 0;
 		left: 0;
 		width: 100%;
 		height: 100%;
 		background: rgba(0, 0, 0, 0.8);
 		display: flex;
 		align-items: center;
 		justify-content: center;
 		z-index: 10001;
 	`;

 	// Create crop content
 	const cropContent = document.createElement('div');
 	cropContent.style.cssText = `
 		background: white;
 		border-radius: 12px;
 		padding: 30px;
 		max-width: 700px;
 		width: 90%;
 		max-height: 90vh;
 		overflow-y: auto;
 	`;

 	const cropTexts = getCropTexts();
 	const isMobileValCrop = window.innerWidth <= 768;
 	const valCropImgMaxH = isMobileValCrop ? '250px' : '400px';
 	cropContent.innerHTML = `
 	<div style="margin-bottom: 20px; text-align: center;">
 		<h3 style="margin: 0 0 15px 0; color: #16212c;">${cropTexts.title}</h3>
 		<p style="margin: 0 0 15px 0; color: #666; font-size: 14px;">${cropTexts.description}</p>

 		<div style="margin-bottom: 15px; display: inline-block; position: relative; max-width: 100%;">
 			<img id="valentine-cropper-image" src="${photoData}" alt="Crop valentine photo" style="max-width: 400px; max-height: ${valCropImgMaxH}; height: auto; border-radius: 8px; display: block; margin: 0 auto;">
 		</div>

 		<div style="margin-bottom: 10px; display: flex; justify-content: center; gap: 10px; flex-wrap: wrap;">
 			<button onclick="zoomValentineCropper(0.2)" style="padding: 10px 20px; background: #000000; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 500;">+ ${cropTexts.zoomIn}</button>
 			<button onclick="zoomValentineCropper(-0.2)" style="padding: 10px 20px; background: #000000; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 500;">- ${cropTexts.zoomOut}</button>
 			<button onclick="resetValentineCropper()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 500;">↺ ${cropTexts.reset}</button>
 		</div>

 		<div style="margin-bottom: 10px;">
 			<button onclick="applyValentineCropAfterUpload()" style="padding: 12px 30px; margin-right: 10px; background: #000000; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 500;">${cropTexts.apply}</button>
 			<button onclick="cancelValentineCropAfterUpload()" style="padding: 12px 30px; background: #6c757d; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 500;">${cropTexts.cancel}</button>
 		</div>
 	</div>
 `;

 	cropOverlay.appendChild(cropContent);
 	document.body.appendChild(cropOverlay);

 	// Initialize Valentine Cropper.js
 	setTimeout(() => {
 		const cropperImage = document.getElementById('valentine-cropper-image');
 		if (cropperImage && window.Cropper) {
 			try {
 				// Destroy existing cropper if it exists
 				if (cropper) {
 					cropper.destroy();
 				}


 				// Mobile-friendly sizing
 				var isMobileVal = window.innerWidth <= 768;
 				var minCropSizeVal = isMobileVal ? 100 : 150;

 				// Create new cropper instance for valentine
 				cropper = new window.Cropper(cropperImage, {
 					aspectRatio: 1, // Square aspect ratio for heart-shaped crop
 					viewMode: 1,   // Restrict crop box to not exceed canvas boundaries
 					dragMode: 'move', // Move the image, not the crop box
 					modal: true,   // Show dark overlay outside crop area
 					background: true, // Show grid background
 					guides: false,  // Hide grid guides for cleaner UI
 					autoCropArea: 0.5, // Fixed crop area size
 					center: true,  // Center the crop area
 					highlight: false, // No highlight for cleaner UI
 					cropBoxMovable: true, // Allow moving the crop box
 					cropBoxResizable: true, // Allow resizing the crop box
 					toggleDragModeOnDblclick: false, // No mode toggling
 					movable: true, // Allow moving the image underneath
 					zoomable: true, // Enable zoom
 					zoomOnTouch: true, // Enable pinch-to-zoom on mobile
 					zoomOnWheel: true, // Enable mouse wheel zoom
 					wheelZoomRatio: 0.1, // Zoom ratio for mouse wheel
 					scalable: true, // Allow image scaling
 					rotatable: true, // Enable rotation
 					minCropBoxWidth: minCropSizeVal,  // Responsive crop box size
 					minCropBoxHeight: minCropSizeVal,
 					ready() {
 						// Set fixed crop box in center - responsive sizing
 						setTimeout(() => {
 							const containerData = cropper.getContainerData();
 							const maxSize = Math.min(containerData.width, containerData.height) * 0.7;
 							const cropBoxSize = Math.min(isMobileVal ? 120 : 150, maxSize);
 							cropper.setCropBoxData({
 								width: cropBoxSize,
 								height: cropBoxSize,
 								left: (containerData.width - cropBoxSize) / 2,
 								top: (containerData.height - cropBoxSize) / 2
 							});
 						}, 100);
 					}
 				});
 			} catch (error) {
 				showSimpleValentineCropInterface(cropperImage, photoData);
 			}
 		} else {
 			if (cropperImage) {
 				showSimpleValentineCropInterface(cropperImage, photoData);
 			}
 		}
 	}, 300); // Wait for Cropper.js to load from CDN

 	// Close crop popup when clicking outside
 	cropOverlay.addEventListener('click', function(e) {
 		if (e.target === cropOverlay) {
 			cancelValentineCropAfterUpload();
 		}
 	});
}

// Function to apply crop after upload
async function applyCropAfterUpload() {
 	if (cropper) {
 		// Get the actual crop box dimensions
 		const cropBoxData = cropper.getCropBoxData();
 		const imageData = cropper.getImageData();

 		// Calculate the actual dimensions of the cropped area in the original image
 		const scaleX = imageData.naturalWidth / imageData.width;
 		const scaleY = imageData.naturalHeight / imageData.height;

 		const croppedWidth = cropBoxData.width * scaleX;
 		const croppedHeight = cropBoxData.height * scaleY;

 		// Use minimum to ensure square without upscaling
 		const actualSquareSize = Math.min(croppedWidth, croppedHeight);

 		// Cap at 2048px for reasonable file sizes (excellent quality for all print sizes)
 		const optimalSize = Math.min(actualSquareSize, 2048);

 		// Get cropped canvas at maximum quality
 		const canvas = cropper.getCroppedCanvas({
 			width: Math.round(optimalSize),
 			height: Math.round(optimalSize),
 			imageSmoothingEnabled: true,
 			imageSmoothingQuality: 'high'
 		});

 		// Convert canvas to blob, then upload to S3
 		canvas.toBlob(async function(blob) {
 			try {
 				// Upload to S3 with progress
 				const s3Url = await uploadPhotoToS3(blob, showUploadProgress);

 				// Save S3 URL to global variable
 				uploadedPhotoUrl = s3Url;

 				// V9.96.26b: Mama-Pattern — Upload-Button ausblenden, Change-Row einblenden
 				syncPhotoChangeRowVisibility();

 				// Close crop popup and update interface
 				closeCropPopup();
 				showPhotoInTitleArea();

 			} catch (error) {
 				console.error('Failed to upload photo:', error);
 				showToast('Foto konnte nicht hochgeladen werden. Bitte versuche es erneut.');
 			}
 		}, 'image/png');
 	} else {
 		// Fallback if cropper not available - just close popup
 		closeCropPopup();
 		showPhotoInTitleArea();
 	}
}

// Function to apply valentine crop after upload
async function applyValentineCropAfterUpload() {
 	if (cropper) {
 		// Get the actual crop box dimensions
 		const cropBoxData = cropper.getCropBoxData();
 		const imageData = cropper.getImageData();

 		// Calculate the actual dimensions of the cropped area in the original image
 		const scaleX = imageData.naturalWidth / imageData.width;
 		const scaleY = imageData.naturalHeight / imageData.height;

 		const croppedWidth = cropBoxData.width * scaleX;
 		const croppedHeight = cropBoxData.height * scaleY;

 		// Use minimum to ensure square without upscaling
 		const actualSquareSize = Math.min(croppedWidth, croppedHeight);

 		// Cap at 2048px for reasonable file sizes (excellent quality for all print sizes)
 		const optimalSize = Math.min(actualSquareSize, 2048);

 		// Get cropped canvas at maximum quality
 		const canvas = cropper.getCroppedCanvas({
 			width: Math.round(optimalSize),
 			height: Math.round(optimalSize),
 			imageSmoothingEnabled: true,
 			imageSmoothingQuality: 'high'
 		});

 		// Convert canvas to blob, then upload to S3
 		canvas.toBlob(async function(blob) {
 			try {
 				// Upload to S3 with progress
 				const s3Url = await uploadPhotoToS3(blob, showUploadProgress);

 				// Save S3 URL to global variable
 				uploadedPhotoUrl = s3Url;

 				// Update the SVG image href in the valentine-svg textarea with S3 URL
 				updateValentineSvgHref(s3Url);

 				// Apply current background color to SVG outline
 				const currentBgColor = $('.map-preview-title').css('background-color') || '#ffffff';
 				if (currentBgColor !== 'rgba(0, 0, 0, 0)' && currentBgColor !== 'transparent') {
 					updateValentineSvgOutlineColor(currentBgColor);
 				}

 				// Close crop popup
 				closeCropPopup();

 				// Small delay to ensure SVG is updated before showing
 				setTimeout(() => {
 					showValentinePhotoInTitleArea();
 				}, 100);

 			} catch (error) {
 				console.error('Failed to upload photo:', error);
 				showToast('Foto konnte nicht hochgeladen werden. Bitte versuche es erneut.');
 			}
 		}, 'image/png');
 	} else {
 		// Fallback if cropper not available - just close popup
 		closeCropPopup();
 		setTimeout(() => {
 			showValentinePhotoInTitleArea();
 		}, 100);
 	}
}

// Function to cancel crop after upload
function cancelCropAfterUpload() {
 	// Clear uploaded photo since crop was cancelled
 	uploadedPhotoUrl = null;
 	uploadedPhotoData = null;

 	// Close crop popup and update interface
 	closeCropPopup();
 	showPhotoInTitleArea();

}

// Function to cancel valentine crop after upload
function cancelValentineCropAfterUpload() {
 	// Clear uploaded photo since crop was cancelled
 	uploadedPhotoUrl = null;
 	uploadedPhotoData = null;

 	// Close crop popup and update interface
 	closeCropPopup();
 	showValentinePhotoInTitleArea();

}

// Fallback function if Cropper.js doesn't load
function showSimpleCropInterface(imageElement, photoData) {
 	// Replace the cropper image with a simple preview
 	const cropContent = imageElement.closest('.crop-popup').querySelector('.crop-content');
 	if (cropContent) {
 		const cropTexts = getCropTexts();
 		cropContent.innerHTML = `
 			<div style="margin-bottom: 20px; text-align: center;">
 				<h3 style="margin: 0 0 20px 0; color: #16212c;">${cropTexts.title}</h3>
 				<p style="margin: 0 0 20px 0; color: #666; font-size: 14px;">Cropper.js library didn't load. Using simple preview instead.</p>

 				<div style="position: relative; margin-bottom: 20px; display: inline-block;">
 					<img src="${photoData}" alt="Preview" style="max-width: 100%; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
 					<div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 180px; height: 180px; border: 3px solid #000000; border-radius: 50%; pointer-events: none; box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.3);"></div>
 				</div>

 				<div style="margin-bottom: 20px;">
 					<button onclick="applyCropAfterUpload()" style="padding: 12px 30px; margin-right: 10px; background: #000000; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 500;">${cropTexts.apply}</button>
 					<button onclick="cancelCropAfterUpload()" style="padding: 12px 30px; background: #6c757d; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 500;">${cropTexts.cancel}</button>
 				</div>
 			</div>
 		`;
 	}
}

// Fallback function for valentine crop if Cropper.js doesn't load
function showSimpleValentineCropInterface(imageElement, photoData) {
 	// Replace the cropper image with a simple preview
 	const cropContent = imageElement.closest('.crop-popup').querySelector('.crop-content');
 	if (cropContent) {
 		const cropTexts = getCropTexts();
 		cropContent.innerHTML = `
 			<div style="margin-bottom: 20px; text-align: center;">
 				<h3 style="margin: 0 0 20px 0; color: #16212c;">${cropTexts.title}</h3>
 				<p style="margin: 0 0 20px 0; color: #666; font-size: 14px;">Cropper.js library didn't load. Using simple preview instead.</p>

 				<div style="position: relative; margin-bottom: 20px; display: inline-block;">
 					<img src="${photoData}" alt="Preview" style="max-width: 100%; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
 					<div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 180px; height: 180px; border: 3px solid #000000; border-radius: 50%; pointer-events: none; box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.3);"></div>
 				</div>

 				<div style="margin-bottom: 20px;">
 					<button onclick="applyValentineCropAfterUpload()" style="padding: 12px 30px; margin-right: 10px; background: #000000; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 500;">${cropTexts.apply}</button>
 					<button onclick="cancelValentineCropAfterUpload()" style="padding: 12px 30px; background: #6c757d; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 500;">${cropTexts.cancel}</button>
 				</div>
 			</div>
 		`;
 	}
}

// Function to update the SVG image href in valentine-svg textarea
function updateValentineSvgHref(imageDataUrl) {
	// Get the valentine-svg textarea
	const valentineSvgTextarea = document.getElementById('valentine-svg');
	if (valentineSvgTextarea) {
		// Get the current SVG content
		let svgContent = valentineSvgTextarea.value;


		// Check if href exists
		const hrefMatch = svgContent.match(/href="[^"]*"/);

		// Update the href attribute in the image element
		const updatedContent = svgContent.replace(
			/href="[^"]*"/,
			`href="${imageDataUrl}"`
		);

		// Update the textarea value
		valentineSvgTextarea.value = updatedContent;

	} else {
	}
}

// Function to update the SVG outline color in valentine-svg textarea
function updateValentineSvgOutlineColor(backgroundColor) {
	// Get the valentine-svg textarea
	const valentineSvgTextarea = document.getElementById('valentine-svg');
	if (valentineSvgTextarea) {
		// Get the current SVG content
		let svgContent = valentineSvgTextarea.value;


		// Update the path.outline fill color
		// Look for the path with class="outline"
		const outlinePattern = /class="outline"[^>]*fill="[^"]*"/;
		if (svgContent.match(outlinePattern)) {
			// Replace existing fill color in path.outline
			svgContent = svgContent.replace(
				/(class="outline"[^>]*)fill="[^"]*"/,
				`$1fill="${backgroundColor}"`
			);
		} else {
			// If no fill attribute exists, add it
			svgContent = svgContent.replace(
				/class="outline"/,
				`class="outline" fill="${backgroundColor}"`
			);
		}

		// Update the textarea value
		valentineSvgTextarea.value = svgContent;

		// Also update any currently displayed valentine photo preview
		const valentinePreview = document.querySelector('.photo-preview.with-valentine');
		if (valentinePreview) {
			valentinePreview.innerHTML = svgContent;
		}

	} else {
	}
}

// Valentine cropper control functions
window.zoomValentineCropper = function(delta) {
 	if (cropper) {
 		cropper.zoom(delta);
 	}
};

window.resetValentineCropper = function() {
 	if (cropper) {
 		cropper.reset();
 		// Restore fixed crop box size after reset
 		setTimeout(() => {
 			if (cropper) {
 				const containerData = cropper.getContainerData();
 				cropper.setCropBoxData({
 					width: 150,
 					height: 150,
 					left: (containerData.width - 150) / 2,
 					top: (containerData.height - 150) / 2
 				});
 			}
 		}, 100);
 	}
};

// Function to apply crop (simplified - just saves the image as-is for now)
function applyCrop() {
	const currentPhoto = uploadedPhotoData;
	if (currentPhoto) {
		// For now, just keep the same image (in a real implementation, you'd use a cropping library)
		closeCropPopup();
	}
}

function addMapOverlay() {
	// Add a subtle overlay to the map for better text readability
	const overlay = document.createElement('div');
	overlay.className = 'map-overlay';
	overlay.style.cssText = `
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(255, 255, 255, 0.1);
		pointer-events: none;
		z-index: 1;
		border-radius: 8px;
	`;

	document.getElementById('map').appendChild(overlay);
}

// Add poster title overlay to the map
function addPosterTitleOverlay() {
	const mapContainer = document.getElementById('map');
	if (!mapContainer) return;
	
	// Remove existing title overlay
	const existingTitle = mapContainer.querySelector('.poster-title');
	if (existingTitle) {
		existingTitle.remove();
	}
	
	// Create title overlay
	const titleOverlay = document.createElement('div');
	titleOverlay.className = 'poster-title';
	titleOverlay.innerHTML = `
		<h3>MIAMI, UNITED STATES</h3>
		<p>25°46'N / 80°12'W</p>
	`;
	
	mapContainer.appendChild(titleOverlay);
}

// Update poster title overlay
function updatePosterTitle(title, subtitle) {
	const titleOverlay = document.querySelector('.poster-title');
	if (titleOverlay) {
		const h3 = titleOverlay.querySelector('h3');
		const p = titleOverlay.querySelector('p');

		// Replace newlines with <br> tags for HTML display
		if (h3) {
			const titleHtml = (title || 'MIAMI, UNITED STATES');
			// .replace(/\n/g, '<br>')
			h3.innerHTML = titleHtml;
		}
		if (p) {
			const subtitleHtml = (subtitle || "25°46'N / 80°12'W");
			// .replace(/\n/g, '<br>')
			p.innerHTML = subtitleHtml;
		}
	}
}

// Size to aspect ratio mapping (height/width for PORTRAIT orientation)
// These are actual paper proportions
const sizeRatios = {
	'A4': 1.414,        // 21 x 29.7 cm (height/width = 29.7/21)
	// Portrait format (height > width) - PRIMARY KEYS
	'30x40cm': 1.333,   // 30 x 40 cm (height/width = 40/30)
	'40x50cm': 1.25,    // 40 x 50 cm (height/width = 50/40)
	'40x60cm': 1.5,     // 40 x 60 cm (height/width = 60/40)
	'60x80cm': 1.333,   // 60 x 80 cm (height/width = 80/60)
	'50x70cm': 1.4,     // 50 x 70 cm (height/width = 70/50)
	'70x100cm': 1.428,  // 70 x 100 cm (height/width = 100/70)
	'75x100cm': 1.333,  // 75 x 100 cm (height/width = 100/75)
	// Landscape format (width > height) - FALLBACK KEYS
	'40x30cm': 1.333,   // 40 x 30 cm (same ratio as 30x40cm)
	'50x40cm': 1.25,    // 50 x 40 cm (same ratio as 40x50cm)
	'60x40cm': 1.5,     // 60 x 40 cm (same ratio as 40x60cm)
	'80x60cm': 1.333,   // 80 x 60 cm (same ratio as 60x80cm)
	'100x70cm': 1.428,  // 100 x 70 cm (same ratio as 70x100cm)
	'70x50cm': 1.4      // 70 x 50 cm (same ratio as 50x70cm)
};

let resizeType = "portrait";

// Function to update frame image based on orientation and selected frame color
function updateFrameImage() {
	const currentOrientation = resizeType; // 'portrait', 'landscape', or 'square'

	// Check if current product type should show frames
	const currentTypeTab = $('.tab__switcher ul > li > a.current').attr('data-id');
	const typeConfig = window.productTypeConfig ? window.productTypeConfig['type' + currentTypeTab] : null;

	const $allMediaContainers = $('.main__wrapper .outer__main .canvas__wrapper .media');
	// Frame-Carrier ist .inn.single-map-view — umschliesst Map + Stadtname +
	// Koordinaten (= das ganze Poster). Hat echte Hoehe vom Inhalt.
	const $posterEl = $('.canvas__wrapper .inn.single-map-view');

	// If product type doesn't have frame picker enabled, hide frame and return.
	if (!typeConfig || !typeConfig.showFramePicker) {
		$allMediaContainers.find('img').remove();
		$posterEl.removeClass('has-frame').removeAttr('data-frame-color');
		$('#map').removeClass('has-frame').removeAttr('data-frame-color');
		return;
	}

	const $currentFrame = $('.elem__picker.image__changer ul li a.current');
	if (!$currentFrame.length) return;

	const frameColor = $currentFrame.attr('data-frame-color');
	if (!frameColor) return;

	// CSS-Holzrahmen ums ganze Poster (.inn.single-map-view).
	$posterEl
		.addClass('has-frame')
		.attr('data-frame-color', frameColor);

	// Cleanup: alte PNG-<img> + ggf. has-frame auf alten Containern.
	$allMediaContainers.find('img').remove();
	$allMediaContainers.removeClass('has-frame').removeAttr('data-frame-color');
	$('#map').removeClass('has-frame').removeAttr('data-frame-color');
}

// Toleranter Lookup: matched "30x40cm" UND "30x40 cm" (Leerzeichen).
// DOM-Text der Size-Picker-Items hat Leerzeichen vor "cm"; Map-Keys nicht.
function lookupSizeRatio(sizeStr) {
	if (!sizeStr) return null;
	return sizeRatios[sizeStr] || sizeRatios[sizeStr.replace(/\s+/g, '')] || null;
}

// Get the selected size or default to first size
function getSelectedSizeRatio() {
	// Use data-size attribute first for backend compatibility
	const selectedSize = $('.elem__picker .size__picker a.current').attr('data-size') || $('.elem__picker .size__picker a.current .head p').text().trim();
	const ratio = lookupSizeRatio(selectedSize);
	if (ratio) return ratio;
	// Default to first size in the list (A4)
	return sizeRatios['A4'] || 0.85;
}

let currentAspectRatio = getSelectedSizeRatio(); // Get initial ratio from selected/first size

// Resize frame function - must be defined before document.ready
function resizeFrame(){
	// Check if we're on mobile
	const isMobile = window.innerWidth <= 767;
	const isSmallMobile = window.innerWidth <= 480;
	const isLandscapeMobile = isMobile && window.innerWidth > window.innerHeight;
	if(isPrintMode){
	// Determine layout type once for the entire print mode block
	const layoutType = printConfig ? (printConfig.layoutType || 'single') : 'single';

	if(printConfig.resizeType == 'landscape' && $('ul.type__switcher li a.current').data('type') !== 'landscape'){
	 $('ul.type__switcher li a[data-type="landscape"]').click()
	}

	// Initialize print mode configuration
	if(!window.printModeInitialized && printConfig) {
		window.printModeInitialized = true;

		// Switch to double/triple layout if needed
		if(layoutType === 'double' && typeof switchMapLayout === 'function') {
			switchMapLayout(true, false);

			// Wait for double maps to be created
			const waitForDoubleMaps = setInterval(() => {
				if(typeof map1 !== 'undefined' && map1 && typeof map2 !== 'undefined' && map2) {
					clearInterval(waitForDoubleMaps);
					configurePrintMaps();
				}
			}, 100);

		} else if(layoutType === 'triple' && typeof switchMapLayout === 'function') {
			switchMapLayout(false, true);

			// Wait for triple maps to be created
			const waitForTripleMaps = setInterval(() => {
				if(typeof map1Triple !== 'undefined' && map1Triple &&
				   typeof map2Triple !== 'undefined' && map2Triple &&
				   typeof map3Triple !== 'undefined' && map3Triple) {
					clearInterval(waitForTripleMaps);
					configurePrintMaps();
				}
			}, 100);

		} else {
			// Single map - already exists
			configurePrintMaps();
		}

		function configurePrintMaps() {
			const layoutType = printConfig.layoutType || 'single';
			const mapInstances = layoutType === 'triple' ? [map1Triple, map2Triple, map3Triple]
			                   : layoutType === 'double' ? [map1, map2]
			                   : [map];

			const maps = printConfig.maps || [];


			// SET CONTAINER DIMENSIONS BEFORE ZOOM CALCULATION
			// This ensures zoom is calculated based on actual print dimensions, not preview dimensions

			$('.print-title, .mapboxgl-ctrl-top-right').hide();
			$('.container').css({
				'max-width': '100vw',
				'padding-left': '0',
				'padding-right': '0',
				'margin': '0'
			});

			// Scale photo preview based on print size FOR ALL LAYOUTS
			// Base size: 180px for 640px canvas (28% of width)
			// Scale proportionally: (printWidth / 640) * 180
			const photoSize = Math.round((printConfig.width / 640) * 180);
			const photoPadding = Math.round(photoSize * 0.083); // Maintain 15/180 ratio
			$('.photo-preview').css({
				'width': photoSize + 'px',
				'height': photoSize + 'px',
				'padding': photoPadding + 'px',
				'top': '5%' // Keep at 5% - scales naturally with container height
			});

			// Handle single map layout with explicit dimensions
			if(layoutType === 'single') {
				// Set main wrapper dimensions
				$('.main__wrapper .outer__main').css({
					'width': printConfig.width + 'px',
					'height': printConfig.height + 'px',
					'position': 'relative',
					'overflow': 'hidden'
				});

				// Set canvas wrapper dimensions
				$('.main__wrapper .outer__main .canvas__wrapper').css({
					'width': printConfig.width + 'px !important',
					'height': printConfig.height + 'px !important',
					'max-width': printConfig.width + 'px',
					'max-height': printConfig.height + 'px'
				});

				// Set inner canvas dimensions
				$('.main__wrapper .outer__main .canvas__wrapper .inn').css({
					'width': printConfig.width + 'px !important',
					'height': printConfig.height + 'px !important',
					'max-width': printConfig.width + 'px',
					'max-height': printConfig.height + 'px'
				});

				$('div#map').css({
					'width': printConfig.width + 'px !important',
					'height': printConfig.height + 'px !important',
					'max-width': printConfig.width + 'px',
					'max-height': printConfig.height + 'px'
				});

				// Resize map to fit new dimensions
				if(map) {
					map.resize();
				}

			}


			// Wait a tick for DOM to update, then configure zoom
			setTimeout(() => {
				configureMapZoom();
			}, 100);
		}

		function fixImagePrint(){
			const photoSize = Math.round((printConfig.width / 640) * 180);
			$('canvas.mapboxgl-canvas').css({
				'max-height': '94%',
			});
			const photoPadding = Math.round(photoSize * 0.083); // Maintain 15/180 ratio

			// Position photo at map-title boundary
			// CSS transform: translate(-50%, -50%) already shifts up by 50% of element height,
			// so photoTop only needs a small negative offset
			var photoTop = -Math.round(photoSize * 0.15);

			$('.photo-preview').css({
				'width': photoSize + 'px',
				'height': photoSize + 'px',
				'padding': photoPadding + 'px',
				'top': photoTop + 'px'
			});

			// Valentine gets same pixel-based positioning
			$('.with-valentine.photo-preview').css({
				'top': photoTop + 'px'
			});
		}

		function configureMapZoom() {
			const layoutType = printConfig.layoutType || 'single';
			const mapInstances = layoutType === 'triple' ? [map1Triple, map2Triple, map3Triple]
			                   : layoutType === 'double' ? [map1, map2]
			                   : [map];
			const maps = printConfig.maps || [];

			// Configure each map
			mapInstances.forEach((mapInstance, idx) => {
				if(!mapInstance) return;

				const mapConfig = maps[idx] || printConfig;

				// Set center and zoom with adjustment for print size
				if(mapConfig.center && mapConfig.zoom) {
					// Get ORIGINAL frontend preview dimensions (when user set zoom)
					// These come from the config sent by frontend
					const originalContainerWidth = mapConfig.containerWidth || 640;
					const originalContainerHeight = mapConfig.containerHeight || 640;

					// Read ACTUAL print dimensions from DOM (container has been resized)
					const mapContainer = mapInstance.getContainer();
					const actualContainerWidth = mapContainer ? mapContainer.offsetWidth : printConfig.width;
					const actualContainerHeight = mapContainer ? mapContainer.offsetHeight : printConfig.height;


					// Calculate zoom adjustment based on size difference
					// actualMapSize = print dimensions, frontendMapSize = original preview dimensions
					let actualMapSize, frontendMapSize;
					if (layoutType === 'double') {
						actualMapSize = Math.min(actualContainerWidth / 2, actualContainerHeight) * 0.8;
						frontendMapSize = originalContainerWidth;
					} else if (layoutType === 'triple') {
						// INCREASED from 0.75 to 0.9 to zoom in more and match frontend
						actualMapSize = Math.min(actualContainerWidth / 3, actualContainerHeight) * 0.9;
						frontendMapSize = originalContainerWidth;
					} else {
						// For single maps: use width for landscape, height for portrait
						// Compare print size to original preview size
						if (actualContainerWidth > actualContainerHeight) {
							// Landscape: width is constraining dimension
							actualMapSize = actualContainerWidth;
							frontendMapSize = originalContainerWidth;
						} else {
							// Portrait: height is constraining dimension
							actualMapSize = actualContainerHeight;
							frontendMapSize = originalContainerHeight;
						}
					}

					// Calculate zoom adjustment: log2(print_size / frontend_size)
					const zoomAdjustment = Math.log2(actualMapSize / frontendMapSize);

					// Add very small detail boost for print quality
					// Triple maps get a bit more boost to compensate for smaller map size
					const printDetailBoost = layoutType === 'triple' ? 0.2 : (layoutType === 'double' ? 0.15 : 0);

					const adjustedZoom = mapConfig.zoom + zoomAdjustment + printDetailBoost;


					// Set zoom FIRST, then center (to avoid center shift when zoom changes)
					mapInstance.setZoom(adjustedZoom);
					mapInstance.setCenter(mapConfig.center);


					// Verify the zoom was applied
					setTimeout(() => {
						const actualZoom = mapInstance.getZoom();
						if(printConfig.layout == 'heart'){
							$('.design__info .elem__picker ul li a').eq(4).click()
						}else if(printConfig.layout == 'circle'){
							$('.design__info .elem__picker ul li a').eq(3).click()
						}else if(printConfig.layoutSelected == 'with photo'){
							$('.design__info .elem__picker ul li a').eq(1).click()
							setTimeout(()=>{
								fixImagePrint()
							}, 150)
						}else if(printConfig.layoutSelected == 'valentine'){
							$('.design__info .elem__picker ul li a').eq(2).click()
							setTimeout(()=>{
								fixImagePrint()
							}, 150)
						}
					}, 500);
				}

																												// Set center and zoom with adjustment for print size

																												if(mapConfig.center && mapConfig.zoom) {

																													const originalContainerWidth = mapConfig.containerWidth || 640;

																													const originalContainerHeight = mapConfig.containerHeight || 640;

																				

																													const mapContainer = mapInstance.getContainer();

																													const actualContainerWidth = mapContainer ? mapContainer.offsetWidth : printConfig.width;

																													const actualContainerHeight = mapContainer ? mapContainer.offsetHeight : printConfig.height;



																													// Calculate scale factors for both dimensions
																													// NOTE: originalContainerWidth/Height comes from each individual map's container
																													// (e.g., each circular map in double/triple layout), NOT the full container
																													// So we use the same calculation for all layout types
																													const scaleW = actualContainerWidth / originalContainerWidth;
																													const scaleH = actualContainerHeight / originalContainerHeight;

																				

																													// Use MINIMUM scale factor to ensure "Fit" behavior (preserves horizontal extent on Portrait)

																													const minScale = Math.min(scaleW, scaleH);

																													const zoomAdjustment = Math.log2(minScale);

																				

																													// Add very small detail boost for print quality

																													const printDetailBoost = layoutType === 'triple' ? 0.2 : (layoutType === 'double' ? 0.15 : 0);

																													const adjustedZoom = mapConfig.zoom + zoomAdjustment + printDetailBoost;

																				

																													mapInstance.setZoom(adjustedZoom);

																													mapInstance.setCenter(mapConfig.center);

																				

																													// Verify the zoom was applied

																													setTimeout(() => {

																														const actualZoom = mapInstance.getZoom();

																														if(printConfig.layoutSelected == 'with photo'){

																															$('.design__info .elem__picker ul li a').eq(1).click()

																															setTimeout(()=>{ fixImagePrint() }, 150)

																														}else if(printConfig.layoutSelected == 'valentine'){

																															$('.design__info .elem__picker ul li a').eq(2).click()

																															setTimeout(()=>{ fixImagePrint() }, 150)

																														}

																													}, 500);

																												}

																				

																												// Add markers - wait for map to be fully loaded first

																												if(mapConfig.markers && mapConfig.markers.length > 0) {

																													let markersAdded = false;

																													const addMarkersToMap = () => {

																														if (markersAdded) return;

																														markersAdded = true;

																				

																														setTimeout(() => {

																															const baseSize = (layoutType === 'single') ? 40 : 30;

																															const mapContainer = mapInstance.getContainer();

																															const actualW = mapContainer ? mapContainer.offsetWidth : printConfig.width;

																															const actualH = mapContainer ? mapContainer.offsetHeight : printConfig.height;

																															const refDim = Math.min(actualW, actualH);

																															const markerScale = refDim / 640;



																															mapConfig.markers.forEach(markerData => {

																																const markerSize = Math.round(baseSize * markerScale);

																																const markerCoords = markerData.coordinates || markerData.position;

																																if(!markerCoords) return;

																				

																																let markerEl = null;

																																if(markerData.icon) {

																																	markerEl = document.createElement('div');

																																	markerEl.className = 'custom-marker';

																				

																																	if (markerData.icon === 'heart') {

																																		markerEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="' + markerSize + '" height="' + markerSize + '" viewBox="0 0 35.908 32.946">' +

																																			'<path class="marker-fill" fill="' + (markerData.color || '#E53422') + '" d="M19.954,35.946l-2.6-2.37C8.1,25.191,2,19.661,2,12.875A9.779,9.779,0,0,1,11.875,3a10.752,10.752,0,0,1,8.079,3.752A10.752,10.752,0,0,1,28.033,3a9.779,9.779,0,0,1,9.875,9.875c0,6.787-6.1,12.316-15.351,20.719Z" transform="translate(-2 -3)"></path>' +

																																		'</svg>';

																																	} else if (markerData.icon === 'pin' || !markerData.icon.includes('<')) {

																																		markerEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="' + markerSize + '" height="' + markerSize + '" viewBox="0 0 24 22" fill="none">' +

																																			'<path class="marker-fill" fill="' + (markerData.color || '#E53422') + '" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path>' +

																																		'</svg>';

																																	} else {

																																		markerEl.innerHTML = markerData.icon;

																																	}

																				

																																	markerEl.style.width = markerSize + "px";

																																	markerEl.style.height = markerSize + "px";

																																	markerEl.style.margin = "0";

																																	markerEl.style.padding = "0";

																																	markerEl.style.marginLeft = "0px";

																																	markerEl.style.marginTop = "0px";

																																	markerEl.style.transform = "translate(0, 0)";

																																	markerEl.style.display = 'flex';

																																	markerEl.style.alignItems = 'center';

																																	markerEl.style.justifyContent = 'center';

																				

																																	const fills = markerEl.querySelectorAll('.marker-fill');

																																	const strokes = markerEl.querySelectorAll('.marker-stroke');

																																	const color = markerData.color || '#E53422';

																																	fills.forEach(el => el.style.fill = color);

																																	strokes.forEach(el => el.style.stroke = color);

																				

																																	const svg = markerEl.querySelector('svg');

																																	if(svg) {

																																		svg.setAttribute('width', markerSize);

																																		svg.setAttribute('height', markerSize);

																																		svg.style.width = '100%';

																																		svg.style.height = '100%';

																																	}

																																}

																				

																																let markerOptions = { anchor: 'center', offset: [0, 0] };

																																if(markerEl) {

																																	markerOptions.element = markerEl;

																																} else {

																																	markerOptions.color = markerData.color || '#E53422';

																																}

																				

																																new mapboxgl.Marker(markerOptions).setLngLat(markerCoords).addTo(mapInstance);

																															});

																														}, 500);

																													};

																				

																													if (mapInstance.loaded()) {

																														addMarkersToMap();

																													} else {

																														mapInstance.once('idle', addMarkersToMap);

																														mapInstance.once('load', addMarkersToMap);

																														setTimeout(addMarkersToMap, 3000);

																													}

																												}			});

		// Apply custom colors and style
		const applyStyleAndColors = async () => {
			// Apply custom colors FIRST if provided
			if(printConfig.customColors) {
				Object.assign(customColors, printConfig.customColors);

				// Apply background color to all elements
				if(printConfig.customColors.background) {
					const bgColor = printConfig.customColors.background;
					$('.map-preview-title').css('background-color', bgColor);
					$('.main__wrapper .outer__main .canvas__wrapper canvas').css('background-color', bgColor);
					$('.main__wrapper .outer__main .canvas__wrapper .inn').css('background-color', bgColor);
					$('div#map').css('background-color', bgColor);
					$('.double-map-view, .triple-map-view').css('background-color', bgColor);
					$('.double-map-container, .triple-map-container').css('background-color', bgColor);
					$('.double-map, .triple-map').css('background-color', bgColor);
					$('#map1, #map2, #map1-triple, #map2-triple, #map3-triple').css('background-color', bgColor);

					// Adjust text color based on background
					const textColor = getContrastTextColor(bgColor);
					$('.map-preview-title h3, .map-preview-title p').css('color', textColor);
					$('.double-map-title h2, .triple-map-title h2').css('color', textColor);
					$('.map-label h3, .map-label p').css('color', textColor);
				}
			}

			// If custom style, click the Custom style button to trigger proper initialization
			if(printConfig.style === 'custom') {
				$('.elem__picker ul li a[data-style="custom"]').click();

				// Wait a bit for style to load, then apply colors
				await new Promise(function(resolve) { setTimeout(resolve, 1000); });

				if(typeof applyCustomMapColors === 'function') {
					applyCustomMapColors();
				}
			} else if(printConfig.style && typeof changeMapStyle === 'function') {
				await changeMapStyle(printConfig.style);
			}
		};

		// Wait for all maps to be idle
		const waitForMapsIdle = () => {
			let idleCount = 0;
			const totalMaps = mapInstances.length;

			mapInstances.forEach((mapInstance, idx) => {
				if(mapInstance) {
					mapInstance.once('idle', () => {
						idleCount++;

						if(idleCount === totalMaps) {
							setTimeout(() => {
								window.mapRenderComplete = true;
							}, 2000);
						}
					});
				}
			});

			// Fallback timeout
			setTimeout(() => {
				if(!window.mapRenderComplete) {
					window.mapRenderComplete = true;
				}
			}, 30000);
		};

		// Apply style and colors, then wait for idle
		applyStyleAndColors().then(() => {
			waitForMapsIdle();
		}).catch(err => {
			waitForMapsIdle(); // Continue anyway
		});
		}
	}

	// Update UI elements (titles, subtitles)
	if(printConfig.layoutType == 'double'){
		// Set main title
		if(printConfig.mainTitle) {
			$('.double-map-title h2').text(printConfig.mainTitle);
			$('#double-main-title').val(printConfig.mainTitle);
		}

		// Configure individual maps - there's ONE .double-map-container with TWO .map-wrapper children
		if(printConfig.maps && printConfig.maps.length >= 2) {
			// Map 1 (first .map-wrapper)
			if(printConfig.maps[0]) {
				const map1Config = printConfig.maps[0];
				if(map1Config.title && map1Config.title.enabled) {
					$('.double-map-container .map-wrapper').eq(0).find('.map-label h3').text(map1Config.title.text || '');
					$('.double-map-container .map-wrapper').eq(0).find('.map-label p').text(map1Config.title.subtitle || '');
					$('#double-large-text-1').val(map1Config.title.text || '');
					$('#double-small-text-1').val(map1Config.title.subtitle || '');
				}
			}

			// Map 2 (second .map-wrapper)
			if(printConfig.maps[1]) {
				const map2Config = printConfig.maps[1];
				if(map2Config.title && map2Config.title.enabled) {
					$('.double-map-container .map-wrapper').eq(1).find('.map-label h3').text(map2Config.title.text || '');
					$('.double-map-container .map-wrapper').eq(1).find('.map-label p').text(map2Config.title.subtitle || '');
					$('#double-large-text-2').val(map2Config.title.text || '');
					$('#double-small-text-2').val(map2Config.title.subtitle || '');
				}
			}
		}
	}

	if(printConfig.layoutType == 'triple'){
		// Set main title
		if(printConfig.mainTitle) {
			$('.triple-map-title h2').text(printConfig.mainTitle);
			$('#triple-map-main-title').val(printConfig.mainTitle);
		}

		// Configure individual maps - there's ONE .triple-map-container with THREE .map-wrapper children
		if(printConfig.maps && printConfig.maps.length >= 3) {
			// Map 1 (first .map-wrapper)
			if(printConfig.maps[0]) {
				const map1Config = printConfig.maps[0];
				if(map1Config.title && map1Config.title.enabled) {
					$('.triple-map-container .map-wrapper').eq(0).find('.map-label h3').text(map1Config.title.text || '');
					$('.triple-map-container .map-wrapper').eq(0).find('.map-label p').text(map1Config.title.subtitle || '');
					$('#triple-large-text-1').val(map1Config.title.text || '');
					$('#triple-small-text-1').val(map1Config.title.subtitle || '');
				}
			}

			// Map 2 (second .map-wrapper)
			if(printConfig.maps[1]) {
				const map2Config = printConfig.maps[1];
				if(map2Config.title && map2Config.title.enabled) {
					$('.triple-map-container .map-wrapper').eq(1).find('.map-label h3').text(map2Config.title.text || '');
					$('.triple-map-container .map-wrapper').eq(1).find('.map-label p').text(map2Config.title.subtitle || '');
					$('#triple-large-text-2').val(map2Config.title.text || '');
					$('#triple-small-text-2').val(map2Config.title.subtitle || '');
				}
			}

			// Map 3 (third .map-wrapper)
			if(printConfig.maps[2]) {
				const map3Config = printConfig.maps[2];
				if(map3Config.title && map3Config.title.enabled) {
					$('.triple-map-container .map-wrapper').eq(2).find('.map-label h3').text(map3Config.title.text || '');
					$('.triple-map-container .map-wrapper').eq(2).find('.map-label p').text(map3Config.title.subtitle || '');
					$('#triple-large-text-3').val(map3Config.title.text || '');
					$('#triple-small-text-3').val(map3Config.title.subtitle || '');
				}
			}
		}
	}

	$('.print-title, .mapboxgl-ctrl-top-right').hide();
	$('.container').css({
		'max-width': '100vw',
		'padding-left': '0',
		'padding-right': '0',
		'margin': '0'
	})

	// Handle single map layout with explicit dimensions
	if(layoutType === 'single') {
		// Set main wrapper dimensions
		$('.main__wrapper .outer__main').css({
			'width': printConfig.width + 'px',
			'height': printConfig.height + 'px',
			'position': 'relative',
			'overflow': 'hidden'
		});

		// Set canvas wrapper dimensions
		$('.main__wrapper .outer__main .canvas__wrapper').css({
			'width': printConfig.width + 'px',
			'height': printConfig.height + 'px',
			'max-width': printConfig.width + 'px',
			'max-height': printConfig.height + 'px'
		});

		// Set inner canvas dimensions
		$('.main__wrapper .outer__main .canvas__wrapper .inn').css({
			'width': printConfig.width + 'px',
			'height': printConfig.height + 'px',
			'max-width': printConfig.width + 'px',
			'max-height': printConfig.height + 'px'
		});

		$('div#map').css({
			'width': $('.main__wrapper .outer__main .canvas__wrapper .inn')[0].clientWidth + 'px',
			'height': $('.main__wrapper .outer__main .canvas__wrapper .inn')[0].clientHeight + 'px',
			'max-width': $('.main__wrapper .outer__main .canvas__wrapper .inn')[0].clientWidth + 'px',
			'max-height': $('.main__wrapper .outer__main .canvas__wrapper .inn')[0].clientHeight + 'px'
		})

		// Force map canvas to exact dimensions
		$('.main__wrapper .outer__main .canvas__wrapper .mapboxgl-canvas').css({
			'width': printConfig.width + 'px',
			'height': printConfig.height + 'px'
		});

		// Resize map to fit new dimensions
		setTimeout(() => {
			$('div#map').css({
			'width': $('.main__wrapper .outer__main .canvas__wrapper .inn')[0].clientWidth + 'px',
			'height': $('.main__wrapper .outer__main .canvas__wrapper .inn')[0].clientHeight + 'px',
			'max-width': $('.main__wrapper .outer__main .canvas__wrapper .inn')[0].clientWidth + 'px',
			'max-height': $('.main__wrapper .outer__main .canvas__wrapper .inn')[0].clientHeight + 'px'
		})
			if(map) map.resize();
		}, 500);

	}

	// Ensure double/triple containers are visible and properly sized
	if(layoutType === 'double') {
		// Show double map view (landscape)
		$('.double-map-view').css({
			'display': 'block !important',
			'visibility': 'visible',
			'width': printConfig.width + 'px',
			'height': printConfig.height + 'px',
			'position': 'relative',
			'overflow': 'hidden'
		});

		// Override hardcoded CSS - remove all constraints
		$('.double-map-container').css({
			'width': '100%',
			'height': '100%',
			'max-width': 'none',
			'display': 'flex',
			'flex-direction': 'row',
			'gap': '0',
			'padding': '0',
			'align-items': 'stretch',
			'justify-content': 'space-between'
		});

		$('.double-map-container .map-wrapper').css({
			'flex': '1',
			'display': 'flex',
			'flex-direction': 'column',
			'height': '100%',
			'width': '50%',
			'align-items': 'center',
			'justify-content': 'center'
		});

		// Override hardcoded CSS - make maps circular and properly sized
		// Calculate map size - they should be circles (square aspect ratio)
		// Use 80% of available space for the maps
		const mapSize = Math.min(printConfig.width / 2, printConfig.height) * 0.8;


		$('.double-map-container .double-map').css({
			'width': mapSize + 'px !important',
			'height': mapSize + 'px !important',
			'min-width': mapSize + 'px',
			'min-height': mapSize + 'px',
			'max-width': mapSize + 'px',
			'max-height': mapSize + 'px',
			'border-radius': '50%',
			'border': 'none',
			'box-shadow': 'none',
			'overflow': 'hidden',
			'background-color': 'transparent',
			'flex-shrink': '0'
		});

		// Also set canvas dimensions
		$('.double-map-container .double-map .mapboxgl-canvas').css({
			'width': mapSize + 'px !important',
			'height': mapSize + 'px !important'
		});

		// Force maps to resize
		setTimeout(() => {
			if(map1) map1.resize();
			if(map2) map2.resize();
		}, 500);

		// Adjust main title font size (INCREASED!)
		const mainTitleSize = printConfig.height / 20; // INCREASED for better readability
		$('.double-map-title h2').css({
			'font-size': mainTitleSize + 'px',
			'line-height': (mainTitleSize * 1.2) + 'px',
			'margin': '0',
			'padding': (printConfig.height / 50) + 'px 0',
			'white-space': 'nowrap' // Prevent wrapping
		});

		// Dynamically adjust main title font size
		setTimeout(() => {
			const mainTitleEl = $('.double-map-title h2')[0];
			if (mainTitleEl) {
				let fontSize = parseFloat(window.getComputedStyle(mainTitleEl).fontSize);
				const containerWidth = $(mainTitleEl).parent().width();
				const minMainTitleSize = printConfig.height / 50; // INCREASED minimum

				while (mainTitleEl.scrollWidth > containerWidth && fontSize > minMainTitleSize) {
					fontSize -= 1;
					$(mainTitleEl).css('font-size', fontSize + 'px');
				}
			}
		}, 100);

		// Add padding to map labels to prevent text from touching edges
		$('.double-map-container .map-label').css({
			'padding': (printConfig.height / 80) + 'px ' + (printConfig.height / 60) + 'px', // vertical horizontal
			'box-sizing': 'border-box'
		});

		// Adjust map label fonts (INCREASED!)
		const labelTitleSize = printConfig.height / 25;  // INCREASED for better readability
		const labelSubtitleSize = printConfig.height / 35; // INCREASED for better readability
		$('.double-map-container .map-label h3').css({
			'font-size': labelTitleSize + 'px',
			'line-height': (labelTitleSize * 1.2) + 'px',
			'margin': '0',
			'padding': (printConfig.height / 100) + 'px 0',
			'white-space': 'nowrap' // Prevent wrapping
		});

		$('.double-map-container .map-label p').css({
			'font-size': labelSubtitleSize + 'px',
			'line-height': (labelSubtitleSize * 1.3) + 'px',
			'margin': '0',
			'padding': '0',
			'white-space': 'nowrap' // Prevent wrapping
		});

		// Dynamically adjust font size for double map labels
		setTimeout(() => {
			// Allow more reduction for long text - reduced minimums
			const minLabelH3Size = printConfig.height / 60; // Allow smaller for long names
			const minLabelPSize = printConfig.height / 80;  // Allow smaller for long names

			$('.double-map-container .map-label h3').each(function() {
				let fontSize = parseFloat(window.getComputedStyle(this).fontSize);
				const containerWidth = $(this).parent().width();

				while (this.scrollWidth > containerWidth && fontSize > minLabelH3Size) {
					fontSize -= 1;
					$(this).css('font-size', fontSize + 'px');
				}
			});

			$('.double-map-container .map-label p').each(function() {
				let fontSize = parseFloat(window.getComputedStyle(this).fontSize);
				const containerWidth = $(this).parent().width();

				while (this.scrollWidth > containerWidth && fontSize > minLabelPSize) {
					fontSize -= 0.8;
					$(this).css('font-size', fontSize + 'px');
				}
			});
		}, 100);

		// Hide other layout views
		$('.triple-map-view, .single-map-view').css('display', 'none');
	} else if(layoutType === 'triple') {
		// Show triple map view (landscape)
		$('.triple-map-view').css({
			'display': 'block !important',
			'visibility': 'visible',
			'width': printConfig.width + 'px',
			'height': printConfig.height + 'px',
			'position': 'relative',
			'overflow': 'hidden'
		});

		// Override hardcoded CSS - remove all constraints
		$('.triple-map-container').css({
			'width': '100%',
			'height': '100%',
			'max-width': 'none',
			'display': 'flex',
			'flex-direction': 'row',
			'gap': '0',
			'padding': '0',
			'align-items': 'stretch',
			'justify-content': 'space-between'
		});

		$('.triple-map-container .map-wrapper').css({
			'flex': '1',
			'display': 'flex',
			'flex-direction': 'column',
			'height': '100%',
			'width': '33.333%',
			'align-items': 'center',
			'justify-content': 'center'
		});

		// Override hardcoded CSS - make maps circular and properly sized
		// Calculate map size - they should be circles (square aspect ratio)
		// Use 75% of available space for the maps (slightly smaller for 3 maps)
		const mapSize = Math.min(printConfig.width / 3, printConfig.height) * 0.75;


		$('.triple-map-container .triple-map').css({
			'width': mapSize + 'px !important',
			'height': mapSize + 'px !important',
			'min-width': mapSize + 'px',
			'min-height': mapSize + 'px',
			'max-width': mapSize + 'px',
			'max-height': mapSize + 'px',
			'border-radius': '50%',
			'border': 'none',
			'box-shadow': 'none',
			'overflow': 'hidden',
			'background-color': 'transparent',
			'flex-shrink': '0'
		});

		// Also set canvas dimensions
		$('.triple-map-container .triple-map .mapboxgl-canvas').css({
			'width': mapSize + 'px !important',
			'height': mapSize + 'px !important'
		});

		// Force maps to resize
		setTimeout(() => {
			if(map1Triple) map1Triple.resize();
			if(map2Triple) map2Triple.resize();
			if(map3Triple) map3Triple.resize();
		}, 500);

		// Adjust main title font size (INCREASED!)
		const mainTitleSize = printConfig.height / 20; // INCREASED for better readability
		$('.triple-map-title h2').css({
			'font-size': mainTitleSize + 'px',
			'line-height': (mainTitleSize * 1.2) + 'px',
			'margin': '0',
			'padding': (printConfig.height / 50) + 'px 0',
			'white-space': 'nowrap' // Prevent wrapping
		});

		// Dynamically adjust main title font size
		setTimeout(() => {
			const mainTitleEl = $('.triple-map-title h2')[0];
			if (mainTitleEl) {
				let fontSize = parseFloat(window.getComputedStyle(mainTitleEl).fontSize);
				const containerWidth = $(mainTitleEl).parent().width();
				const minMainTitleSize = printConfig.height / 50; // INCREASED minimum

				while (mainTitleEl.scrollWidth > containerWidth && fontSize > minMainTitleSize) {
					fontSize -= 1;
					$(mainTitleEl).css('font-size', fontSize + 'px');
				}
			}
		}, 100);

		// Add padding to map labels to prevent text from touching edges
		$('.triple-map-container .map-label').css({
			'padding': (printConfig.height / 80) + 'px ' + (printConfig.height / 60) + 'px', // vertical horizontal
			'box-sizing': 'border-box'
		});

		// Adjust map label fonts (INCREASED!)
		const labelTitleSize = printConfig.height / 25;  // INCREASED for better readability
		const labelSubtitleSize = printConfig.height / 35; // INCREASED for better readability
		$('.triple-map-container .map-label h3').css({
			'font-size': labelTitleSize + 'px',
			'line-height': (labelTitleSize * 1.2) + 'px',
			'margin': '0',
			'padding': (printConfig.height / 100) + 'px 0',
			'white-space': 'nowrap' // Prevent wrapping
		});

		$('.triple-map-container .map-label p').css({
			'font-size': labelSubtitleSize + 'px',
			'line-height': (labelSubtitleSize * 1.3) + 'px',
			'margin': '0',
			'padding': '0',
			'white-space': 'nowrap' // Prevent wrapping
		});

		// Dynamically adjust font size for triple map labels
		setTimeout(() => {
			// Allow more reduction for long text - reduced minimums
			const minLabelH3Size = printConfig.height / 60; // Allow smaller for long names
			const minLabelPSize = printConfig.height / 80;  // Allow smaller for long names

			$('.triple-map-container .map-label h3').each(function() {
				let fontSize = parseFloat(window.getComputedStyle(this).fontSize);
				const containerWidth = $(this).parent().width();

				while (this.scrollWidth > containerWidth && fontSize > minLabelH3Size) {
					fontSize -= 1;
					$(this).css('font-size', fontSize + 'px');
				}
			});

			$('.triple-map-container .map-label p').each(function() {
				let fontSize = parseFloat(window.getComputedStyle(this).fontSize);
				const containerWidth = $(this).parent().width();

				while (this.scrollWidth > containerWidth && fontSize > minLabelPSize) {
					fontSize -= 0.8;
					$(this).css('font-size', fontSize + 'px');
				}
			});
		}, 100);

		// Hide other layout views
		$('.double-map-view, .single-map-view').css('display', 'none');
	}

	// Only apply padding for single layout, NOT for double/triple
	if(layoutType === 'single') {
		$('.map-preview-title').css({
			'padding': printConfig.height/50+'px',
		})

		$('.main__wrapper .outer__main .canvas__wrapper canvas, .map-preview-title').css({
			'padding': printConfig.height/70+'px'
		});
	} else {
		// Remove padding for double/triple layouts
		$('.map-preview-title').css({
			'padding': '0'
		})

		$('.main__wrapper .outer__main .canvas__wrapper canvas, .double-map-container canvas, .triple-map-container canvas').css({
			'padding': '0'
		});
	}

	// Apply font if specified
	if(printConfig.title && printConfig.title.font) {
		$(`.elem__picker ul li a[data-font="${printConfig.title.font}"]`).click()
	}

	// Add padding to map preview title to prevent text from touching edges
	// REDUCED padding to minimize white space
	$('.map-preview-title').css({
		'padding': (printConfig.height / 150) + 'px ' + (printConfig.height / 100) + 'px', // vertical horizontal - reduced from /80 and /60
		'box-sizing': 'border-box'
	});

	// Initial font sizes - use PX instead of REM for consistent scaling
	// INCREASED for better readability on large posters
	const titleFontSize = printConfig.height / 20;  // Large title (236px for 4724px, 472px for 9449px)
	const subtitleFontSize = printConfig.height / 30; // Subtitle (157px for 4724px, 315px for 9449px)

	$('.map-preview-title h3').css({
		'font-size': titleFontSize + 'px',
		'line-height': (titleFontSize * 1.2) + 'px',
		'white-space': 'nowrap' // Prevent wrapping
	})

	$('.map-preview-title p').css({
		'font-size': subtitleFontSize + 'px',
		'line-height': (subtitleFontSize * 1.3) + 'px',
		'white-space': 'nowrap' // Prevent wrapping
	})


	// Dynamically adjust font size to fit text on one line
	function adjustTitleFontSize() {
		const h3Element = $('.map-preview-title h3')[0];
		const pElement = $('.map-preview-title p')[0];

		// Set minimum font sizes proportional to print size for readability (INCREASED!)
		const minH3Size = printConfig.height / 35; // 135px for 4724px, 270px for 9449px
		const minPSize = printConfig.height / 50;  // 94px for 4724px, 189px for 9449px

		if (h3Element) {
			let fontSize = parseFloat(window.getComputedStyle(h3Element).fontSize);
			const containerWidth = $(h3Element).parent().width();

			// Reduce font size until text fits, but keep it readable
			while (h3Element.scrollWidth > containerWidth && fontSize > minH3Size) {
				fontSize -= 1;
				$(h3Element).css('font-size', fontSize + 'px');
			}
		}

		if (pElement) {
			let fontSize = parseFloat(window.getComputedStyle(pElement).fontSize);
			const containerWidth = $(pElement).parent().width();

			// Reduce font size until text fits, but keep it readable
			while (pElement.scrollWidth > containerWidth && fontSize > minPSize) {
				fontSize -= 0.8;
				$(pElement).css('font-size', fontSize + 'px');
			}
		}
	}

	// Call after a short delay to ensure DOM is updated
	setTimeout(adjustTitleFontSize, 100);
	}

	// In print mode, dimensions are already set by configurePrintMaps() above.
	// Do NOT continue to the editor dimension code — it would overwrite print dimensions.
	if (isPrintMode) return;

	// Adjust max dimensions based on screen size
	const screenPadding = isSmallMobile ? 20 : (isMobile ? 30 : 0);

	// Desktop: Vorschau waechst mit dem Bildschirm.
	// Hoehe = Viewport minus Sticky-Offset (top: 160px) und etwas Luft, gedeckelt bei 1000px,
	// Untergrenze 620px, damit auf kleinen Laptops nichts kleiner wird als bisher.
	// Breite = freie Spalte neben dem 445px-Panel.
	const DESKTOP_VERTICAL_OFFSET = 180;   // sticky top + Luft nach unten
	const DESKTOP_MIN_HEIGHT = 620;        // entspricht dem bisherigen Zustand
	const DESKTOP_MAX_HEIGHT = 1000;
	const PANEL_WIDTH = 445;               // .main__switcher, siehe citymap.css
	const COLUMN_GUTTER = 120;             // Abstand Panel <-> Vorschau plus Seitenrand

	const desktopMaxHeight = Math.min(
		Math.max(window.innerHeight - DESKTOP_VERTICAL_OFFSET, DESKTOP_MIN_HEIGHT),
		DESKTOP_MAX_HEIGHT
	);
	const desktopMaxWidth = Math.max(window.innerWidth - PANEL_WIDTH - COLUMN_GUTTER, 420);

	const availableWidth = isMobile ? (window.innerWidth - screenPadding) : desktopMaxWidth;

	const maxTotalHeight = isMobile ? 750 : desktopMaxHeight; // Maximum total poster height (map + title)
	const maxWidth = availableWidth;  // Maximum poster width for portrait
	const maxLandscapeWidth = isMobile ? availableWidth : Math.min(desktopMaxWidth, 1200); // Maximum width for landscape

	// In print, map takes ~83.5% of poster height, title takes ~16.5%
	// We must match this ratio in preview so marker positions align correctly
	const MAP_HEIGHT_RATIO = 0.835; // Map is 83.5% of total poster height

	let width, mapHeight, totalHeight;

	// Calculate dimensions based on orientation
	// IMPORTANT: Aspect ratio applies to TOTAL poster (map + title), not just map
	// Check if with-photo layout needs more space
	const isLargerLayout = true; // All layouts use larger poster preview

	if (resizeType === "landscape") {
		// Landscape - width is LARGER than height
		// For landscape: totalWidth / totalHeight = ratio
		// Start with a base total height and calculate width
		// Special layouts need a larger poster for proper proportions
		totalHeight = isMobile ? 350 : desktopMaxHeight;
		width = totalHeight * currentAspectRatio; // width = total height × (width/height ratio)

		// If width exceeds max, recalculate proportionally
		const landscapeMax = isMobile ? 1000 : maxLandscapeWidth;
		if (width > landscapeMax) {
			width = landscapeMax;
			totalHeight = width / currentAspectRatio; // total height = width / (width/height ratio)
		}
		// Map height is 83.5% of total (matching print proportions)
		mapHeight = Math.round(totalHeight * MAP_HEIGHT_RATIO);
	} else if (resizeType === "square") {
		// Square - total dimensions should be equal (1:1 ratio)
		// For square: totalWidth = totalHeight
		totalHeight = isMobile ? availableWidth : desktopMaxHeight;
		width = totalHeight; // Width equals height for square
		// Auf Desktop darf das Quadrat die freie Spalte nicht sprengen
		if (!isMobile && width > maxWidth) {
			width = maxWidth;
			totalHeight = width;
		}
		// Map height is 83.5% of total (matching print proportions)
		mapHeight = Math.round(totalHeight * MAP_HEIGHT_RATIO);
	} else {
		// Portrait (default) - height is LARGER than width
		// For portrait: totalHeight / width = ratio
		// Total poster (map + title) should match the aspect ratio

		width = maxWidth;
		totalHeight = width * currentAspectRatio; // total height = width × (height/width ratio)

		// If total height exceeds max, scale down proportionally
		if (totalHeight > maxTotalHeight) {
			totalHeight = maxTotalHeight;
			width = totalHeight / currentAspectRatio; // width = total height / (height/width ratio)
		}
		// Map height is 83.5% of total (matching print proportions)
		mapHeight = Math.round(totalHeight * MAP_HEIGHT_RATIO);
	}

	// Calculate title height for CSS (the remaining 16.5%)
	const titleHeight = totalHeight - mapHeight;

	// Round dimensions
	let finalWidth = Math.round(width);
	let finalHeight = Math.round(mapHeight);
	let finalTotalHeight = Math.round(totalHeight);
	let finalTitleHeight = Math.round(titleHeight);

	// Typografie im Titelblock mitskalieren: 520px ist die bisherige Referenzbreite.
	// Nie unter 1, damit Mobil unveraendert bleibt.
	const posterScale = Math.max(1, finalWidth / 520);

	// FIRST: Update parent containers to hold the total poster height
	// This prevents parent constraints from overriding our dimensions
	$('.main__wrapper .outer__main .canvas__wrapper').css({
		"max-height": "none"
	});
	$('.main__wrapper .outer__main .canvas__wrapper .inn.single-map-view').css({
		"width": finalWidth + "px",
		"height": finalTotalHeight + "px",
		"max-height": "none"
	});
	document.querySelectorAll('.inn.single-map-view').forEach(function(el){
		el.style.setProperty('--dl-poster-scale', posterScale.toFixed(3));
	});

	// Apply dimensions to map container
	// No borderCompensation needed — border is now a ::before pseudo-element overlay
	$("#map").css({
		"height": finalHeight + "px",
		"width": finalWidth + "px",
		"max-height": finalHeight + "px",
		"max-width": "100%",
		"display": "block",
		"visibility": "visible"
	});

	// Also resize preview title container to match poster dimensions
	// CRITICAL: Set both width AND height so title takes exactly 16.5% of poster
	$('.map-preview-title').css({
		"width": finalWidth + "px",
		"height": finalTitleHeight + "px",
		"max-width": "100%",
		"box-sizing": "border-box"
	});

	// Titel-/Untertitelgroesse an die neue Postergroesse anpassen. Ohne diesen Aufruf
	// bliebe die inline gesetzte Schriftgroesse aus dem letzten Textupdate stehen.
	if (typeof adjustPreviewTitleFontSize === 'function') {
		const _t = document.getElementById('preview-title');
		const _s = document.getElementById('preview-subtitle');
		if (_t) adjustPreviewTitleFontSize(_t);
		if (_s) adjustPreviewTitleFontSize(_s, 14, 1);
	}

	// TEMP-DIAGNOSE 2026-04-30 — wieder entfernen nach Verifikation.
	try {
		const _diagInn = document.querySelector('.inn.single-map-view');
		window.__cmdiag = {
			callCount: ((window.__cmdiag && window.__cmdiag.callCount) || 0) + 1,
			resizeType: resizeType,
			currentAspectRatio: currentAspectRatio,
			isMobile: isMobile,
			innerWidth: window.innerWidth,
			availableWidth: availableWidth,
			finalWidth: finalWidth,
			finalTotalHeight: finalTotalHeight,
			finalMapHeight: finalHeight,
			finalTitleHeight: finalTitleHeight,
			innInline: _diagInn ? _diagInn.style.cssText.slice(0,140) : null,
			innComputed: _diagInn ? (parseFloat(getComputedStyle(_diagInn).width).toFixed(0)+'×'+parseFloat(getComputedStyle(_diagInn).height).toFixed(0)) : null,
			ts: Date.now(),
		};
	} catch(e) { console.warn('[cmdiag]', e); }

	fixCanvasSize();
	if (map && map.loaded()) {
		setTimeout(function() {
			map.resize();
		}, 150);
	}
}

// Global helper function to find variant based on selected options
// Made global so it can be accessed from both document.ready and initShopifyIntegration
window.findVariantBySelectedOptions = function() {
	if (typeof productVariants === 'undefined' || !productVariants) return null;

	// Get currently selected size (option2) - ONLY from visible size picker
	const selectedSize = $('.size__picker:visible a.current').attr('data-size') ||
						 $('.size__picker:visible a.current .head p').text().trim();

	// Get currently selected type (option1) - use data-type attribute first for backend compatibility
	const selectedType = $('.tab__switcher ul > li > a.current').attr('data-type') || $('.tab__switcher ul > li > a.current').text().trim();

	// Find variant matching both options
	const variant = productVariants.find(v => {
		const sizeMatches = v.option2 === selectedSize;
		const typeMatches = !selectedType || v.option1 === selectedType || !v.option1;
		return sizeMatches && typeMatches;
	});

	return variant;
};

// Global helper function to filter available sizes based on selected format
window.filterAvailableSizes = function(selectedType) {
	if (!window.productVariants) return;

	// Get all available sizes for this format type
	const availableSizes = window.productVariants
		.filter(v => v.option1 === selectedType)
		.map(v => v.option2);

	// Show/hide size options based on availability
	$('.size__picker a').each(function() {
		const $sizeOption = $(this);
		const size = $sizeOption.attr('data-size');

		if (availableSizes.includes(size)) {
			$sizeOption.show();
		} else {
			$sizeOption.hide();
		}
	});

	// If current size is not available for this format, select first available
	const $currentSize = $('.size__picker:visible a.current');
	const currentSize = $currentSize.attr('data-size');
	if (currentSize && !availableSizes.includes(currentSize) && availableSizes.length > 0) {
		// Select first available size
		$('.size__picker a').removeClass('current');
		$('.size__picker a[data-size="' + availableSizes[0] + '"]').addClass('current');

		// Trigger map resize with new aspect ratio
		const newSize = availableSizes[0];
		const newRatio = lookupSizeRatio(newSize);
		if (newRatio) {
			currentAspectRatio = newRatio;
			// Debounce reinitializeMap to prevent rapid successive calls
			if (reinitializeTimeout) {
				clearTimeout(reinitializeTimeout);
			}
			reinitializeTimeout = setTimeout(function() {
				reinitializeMap();
			}, 300);
		}
	}
};

// Global helper function to filter available formats based on selected size
window.filterAvailableFormats = function(selectedSize) {
	if (!window.productVariants) return;

	// Get all available formats for this size
	const availableFormats = window.productVariants
		.filter(v => v.option2 === selectedSize)
		.map(v => v.option1);

	// Show/hide format tabs based on availability
	$('.tab__switcher ul > li > a').each(function() {
		const $formatTab = $(this);
		const formatText = $formatTab.attr('data-type') || $formatTab.text().trim();

		if (availableFormats.includes(formatText)) {
			$formatTab.parent().show();
		} else {
			$formatTab.parent().hide();
		}
	});

	// If current format is not available for this size, select first available
	const $currentFormat = $('.tab__switcher ul > li > a.current');
	const currentFormat = $currentFormat.attr('data-type') || $currentFormat.text().trim();
	if (currentFormat && !availableFormats.includes(currentFormat) && availableFormats.length > 0) {
		// Select first available format
		$('.tab__switcher ul > li > a').removeClass('current');
		const firstAvailableFormat = availableFormats[0];
		const $newFormat = $('.tab__switcher ul > li > a').filter(function() {
			return ($(this).attr('data-type') || $(this).text().trim()) === firstAvailableFormat;
		});

		if ($newFormat.length > 0) {
			$newFormat.addClass('current');

			// Show the corresponding format container
			const newFormatId = $newFormat.attr('data-id');
			if (newFormatId) {
				$('.el__format').css("display", "none");
				$('.el__format[data-id="' + newFormatId + '"]').fadeIn(300);
				// V9.96.4: USP-Box (editor-benefits-wrapper) auch nach Type toggeln
				$('.editor-benefits-wrapper').css("display", "none");
				$('.editor-benefits-wrapper[data-id="' + newFormatId + '"]').fadeIn(300);
			}

			// Update prices for new format
			window.updateSizePickerPrices(firstAvailableFormat);
		}
	}
};

// Global helper function to update size picker prices when product type changes
window.updateSizePickerPrices = function(selectedType) {
	if (!window.productVariants) {
		return;
	}

	// Update each size option with correct price for the selected type
	$('.size__picker a').each(function() {
		const $sizeOption = $(this);
		const size = $sizeOption.attr('data-size');

		// Find variant matching this size + selected type
		const variant = window.productVariants.find(v =>
			v.option2 === size && v.option1 === selectedType
		);

		if (variant) {
			// Format price with manual currency symbol
			let priceFormatted;
			let currencySymbol = '€'; // Default to EUR
			let amount;
			
			// Determine currency symbol
			if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
				const currencySymbols = {
					'EUR': '€',
					'USD': '$',
					'GBP': '£',
					'CHF': 'CHF '
				};
				currencySymbol = currencySymbols[window.Shopify.currency.active] || '€';
			}
			
			// Format the amount
			if (window.Shopify && window.Shopify.formatMoney) {
				amount = Shopify.formatMoney(variant.price, '{{amount_with_comma_separator}}');
			} else {
				amount = (variant.price / 100).toFixed(2).replace('.', ',');
			}
			
			// Combine symbol and amount
			priceFormatted = currencySymbol + amount;

			// Update price display in the size picker
			$sizeOption.find('.content p').text(priceFormatted);

			// Update data attributes
			$sizeOption.attr('data-price', (variant.price / 100).toFixed(2).replace('.', ','));
			$sizeOption.attr('data-variant-id', variant.id);
		}
	});
};

$(document).ready(function(){

	// Foto-Upload-Section (zwischen Layout und Ausrichtung im Karte-Tab) —
	// File-Input change triggert je nach Layout den passenden Upload-
	// Handler. Drag-Drop spiegelt die .drag-over Optik vom Foto-Editor.
	// Initial sync versteckt die Section solange kein Foto-Layout aktiv
	// ist. <label>-Wrapper triggert <input> nativ — kein extra Click-
	// Handler aufs Zone-Element noetig (sonst doppelter Open-Pfad).
	const ciInput = document.getElementById('citymap-photo-upload-input');
	if (ciInput) {
		ciInput.addEventListener('change', function (ev) {
			getActivePhotoUploadHandler()(ev);
		});
	}
	const ciChange = document.getElementById('citymap-photo-change-btn');
	if (ciChange) {
		ciChange.addEventListener('click', function () {
			const input = document.getElementById('citymap-photo-upload-input');
			if (input) input.click();
		});
	}
	// V9.96.26b: Neu zuschneiden — öffnet Cropper mit dem letzten Upload
	const ciRecrop = document.getElementById('citymap-photo-recrop-btn');
	if (ciRecrop) {
		ciRecrop.addEventListener('click', function () {
			if (window.__cmLastUploadedPhotoData) {
				openCropPopupAfterUpload(window.__cmLastUploadedPhotoData);
			} else if (uploadedPhotoUrl) {
				// Fallback: lade vom S3-URL nach (z.B. nach Page-Reload)
				openCropPopupAfterUpload(uploadedPhotoUrl);
			}
		});
	}
	const ciZone = document.getElementById('citymap-photo-upload-zone');
	if (ciZone) {
		['dragenter', 'dragover'].forEach(function (ev) {
			ciZone.addEventListener(ev, function (e) {
				e.preventDefault();
				ciZone.classList.add('drag-over');
			});
		});
		['dragleave', 'drop'].forEach(function (ev) {
			ciZone.addEventListener(ev, function (e) {
				e.preventDefault();
				ciZone.classList.remove('drag-over');
			});
		});
		ciZone.addEventListener('drop', function (e) {
			if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) {
				const fakeEv = { target: { files: e.dataTransfer.files } };
				getActivePhotoUploadHandler()(fakeEv);
			}
		});
	}
	syncPhotoUploadSectionVisibility();

	// Test if map container exists
	const mapContainer = document.getElementById('map');

	if (mapContainer) {
	}

	// Initialize variant filtering on page load
	if (window.productVariants) {
		// Get initially selected format - use data-type attribute for backend compatibility
		const initialFormat = $('.tab__switcher ul > li > a.current').attr('data-type') || $('.tab__switcher ul > li > a.current').text().trim();
		if (initialFormat) {
			// Filter available sizes for the initial format
			window.filterAvailableSizes(initialFormat);
		}

		// Get initially selected size
		const initialSize = $('.size__picker:visible a.current').attr('data-size');
		if (initialSize) {
			// Filter available formats for the initial size
			window.filterAvailableFormats(initialSize);
		}
	}

	// Set initial size BEFORE initializing the map
	// This ensures the map loads with correct dimensions from the start
	resizeFrame();

	// Auto-detect layout_mode from visible view divs (set by Liquid conditionals)
	// This handles triple-only and double-only products that don't use URL preset params
	const tripleViewVisible = document.querySelector('.inn.triple-map-view');
	const doubleViewVisible = document.querySelector('.inn.double-map-view');
	if (tripleViewVisible && tripleViewVisible.style.display !== 'none' && !tripleViewVisible.closest('[style*="display: none"]')) {
		switchMapLayout(false, true);
	} else if (doubleViewVisible && doubleViewVisible.style.display !== 'none' && !doubleViewVisible.closest('[style*="display: none"]')) {
		switchMapLayout(true, false);
	}

	// Initialize marker settings with default icon (first pin icon SVG)
	const defaultIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 24 24" fill="none">
													<path class="marker-fill" fill="#E53422" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path>
												</svg>`;

	// Set default pin icon for the single map
	markerSettings['single'].iconElement = defaultIconSVG;

	Object.keys(markerSettings).forEach(key => {
		markerSettings[key].iconElement = defaultIconSVG;
	});

	// Copy all marker icons from single layout to double and triple layouts
	setTimeout(function() {
		const singleLayoutIcons = $('.details__wrapper .marker__switcher .elem__picker ul, .markers__wrapper .marker__switcher .elem__picker ul').html();

		if (singleLayoutIcons) {
			// Update double layout icons for both maps
			$('.details__wrapper--double .map-section').each(function(index) {
				const mapNum = index + 1;
				const $iconList = $(this).find('.marker__switcher .elem__picker ul');
				if ($iconList.length > 0) {
					$iconList.html(singleLayoutIcons);
					// Update class names for double layout
					$iconList.find('a').removeClass('current').addClass(`double-marker-icon-${mapNum}`).attr('data-map', `double-${mapNum}`);
					$iconList.find('a').first().addClass('current');
				}
			});

			// Update triple layout icons for all three maps
			$('.details__wrapper--triple .map-section').each(function(index) {
				const mapNum = index + 1;
				const $iconList = $(this).find('.marker__switcher .elem__picker ul');
				if ($iconList.length > 0) {
					$iconList.html(singleLayoutIcons);
					// Update class names for triple layout
					$iconList.find('a').removeClass('current').addClass(`triple-marker-icon-${mapNum}`).attr('data-map', `triple-${mapNum}`);
					$iconList.find('a').first().addClass('current');
				}
			});
		}
	}, 100);

	$('.elem__picker ul li a').on('click' ,function(e){
		e.preventDefault();
		$(this).closest('ul').find('.current').removeClass("current");
		$(this).addClass('current');
		if ($(this).closest('.tab__switcher').length) {
			// Get currently selected size from visible size picker
			const $currentSize = $('.size__picker:visible a.current').first();
			const currentSizeData = $currentSize.attr('data-size');

			// Get selected type - use data-type attribute first for backend compatibility
			const selectedType = $(this).attr('data-type') || $(this).text().trim();

			// Filter available sizes for the selected format
			window.filterAvailableSizes(selectedType);

			// Update prices in ALL size pickers
			window.updateSizePickerPrices(selectedType);

			// Sync selection across ALL size pickers (before showing new container)
			if (currentSizeData) {
				$('.size__picker a').removeClass('current');
				$('.size__picker a[data-size="' + currentSizeData + '"]').addClass('current');
			}

			// Now show the selected format container
			$('.el__format').css("display" ,"none");
			$('.el__format[data-id='+ $(this).attr("data-id") +']').fadeIn(300);
			// V9.96.4: USP-Box (editor-benefits-wrapper) auch nach Type toggeln
			$('.editor-benefits-wrapper').css("display", "none");
			$('.editor-benefits-wrapper[data-id='+ $(this).attr("data-id") +']').fadeIn(300);

			// Update product type info (delivery dates, descriptions, frame picker)
			const selectedTypeId = $(this).attr("data-id");
			if (window.updateProductTypeInfo && selectedTypeId) {
				window.updateProductTypeInfo(selectedTypeId);
			}

			// Update frame visibility based on product type
			updateFrameImage();

			// Dispatch variant change event immediately
			const variant = findVariantBySelectedOptions();
			if (variant) {
				document.dispatchEvent(new CustomEvent('variant:change', {
					detail: { variant: variant }
				}));
			}
			// Auto-select first frame option when Framed Poster is clicked
			if ($(this).attr("data-id") === '2') {
				const $frameOptions = $('.el__format[data-id="2"] .image__changer ul li a');
				if ($frameOptions.length > 0) {
					// Find the current frame option, or use the first one
					const $currentFrame = $frameOptions.filter('.current');
					if ($currentFrame.length > 0) {
						// Trigger click on the already selected frame to show it
						$currentFrame.trigger('click');
					} else {
						// No frame selected, select the first one
						$frameOptions.first().addClass('current').trigger('click');
					}
				}
			} else {
				// Remove frame when switching to other product types
				$('.main__wrapper .outer__main .canvas__wrapper .media img').remove();
			}
		}
	});

	$('.info__button').on('click' ,function(e){
		e.preventDefault();
		$('.info__popup[data-id='+ $(this).attr("data-id") +']').fadeIn(300);
		$('body,html').css("overflow-y" ,"hidden");
	});
	$('.info__popup .box>.top>a').on('click' ,function(e){
		$('.info__popup').fadeOut(300);
		$('body,html').css("overflow-y" ,"initial");
	});

	$('.estimated .show__more>a').on("click" ,function(e){
		e.preventDefault();
		$(this).closest('.show__more').css("display" ,"none");
		$(this).closest('.estimated').find("li").css('display' , "flex");
	});


	// Map title handler removed - now using delegated handler below

	$('.size__picker a').on("click" ,function(e){
		e.preventDefault();

		// TEMP-DIAGNOSE 2026-04-30
		try {
			window.__cmdiag = window.__cmdiag || {};
			window.__cmdiag.events = (window.__cmdiag.events || []).slice(-9);
			window.__cmdiag.events.push('SIZE_CLICK data-size=' + $(this).attr('data-size'));
		} catch(e) {}

		// Get the selected size
		const selectedSize = $(this).attr('data-size');

		// Sync selection across ALL size pickers (including hidden ones)
		$('.size__picker a').removeClass('current');
		$('.size__picker a[data-size="' + selectedSize + '"]').addClass('current');

		// Filter available formats for the selected size
		window.filterAvailableFormats(selectedSize);

		// Find variant based on all selected options and dispatch event
		const variant = findVariantBySelectedOptions();
		if (variant) {
			document.dispatchEvent(new CustomEvent('variant:change', {
				detail: { variant: variant }
			}));
		}

		// Get the ORIGINAL size for ratio lookup (before orientation transformation)
		// Use data-size attribute first for backend compatibility
		const originalSize = $(this).attr('data-size') || $(this).find('.head p').attr('data-original-size') || $(this).find('.head p').text().trim();
		const displayedSize = $(this).find('.head p').text().trim();

		const sizeRatio = lookupSizeRatio(originalSize);

		// TEMP-DIAGNOSE 2026-04-30
		try {
			window.__cmdiag.events.push('SIZE_BRANCH origSize=' + originalSize + ' ratio=' + sizeRatio);
		} catch(e) {}

		if (sizeRatio) {
			// sizeRatios stores height/width for portrait orientation
			if (resizeType === "square") {
				currentAspectRatio = 1.0;
			} else {
				// Use the original size's ratio for both portrait and landscape
				currentAspectRatio = sizeRatio;
			}


			// Debounce reinitializeMap to prevent rapid successive calls
			if (reinitializeTimeout) {
				clearTimeout(reinitializeTimeout);
			}
			reinitializeTimeout = setTimeout(function() {
				// TEMP-DIAGNOSE 2026-04-30
				try {
					window.__cmdiag.events.push('REINIT_TIMEOUT_FIRE map=' + !!map + ' isReinit=' + isReinitializing + ' aspect=' + currentAspectRatio);
				} catch(e) {}
				reinitializeMap();
			}, 300); // Wait 300ms after last size change
		}
	});

	$('.add__details').on('click' ,function(e){
		$('.main__switcher>ul>li:nth-child(2)>a').click();
	});
	$('.select__format').on('click' ,function(e){
		$('.main__switcher>ul>li:nth-child(4)>a').click();
	});

	$('.main__switcher > ul > li > a').on('click', function(e){
		e.preventDefault();
		if (!$(this).hasClass("current")) {
			$(this).closest('ul').find('.current').removeClass("current");
			$(this).addClass('current');

			// Hide all panels including double and triple details and new location/markers panels
			$('.design__info, .details__wrapper, .format__wrapper, .location__wrapper, .markers__wrapper, .preview__wrapper').css("display", 'none');
			$('.details__wrapper--double, .location__wrapper--double, .markers__wrapper--double').css("display", 'none');
			$('.details__wrapper--triple, .location__wrapper--triple, .markers__wrapper--triple').css("display", 'none');

			// Show the appropriate panel based on layout and tab
			const tabName = $(this).attr("data-tab");

			// Update active tab attribute for CSS-driven Weiter/Cart visibility
			$('.main__switcher').attr('data-active-tab', tabName);

			// Handle Location tab
			if (tabName === 'location__wrapper') {
				if (isTripleMapLayout) {
					// Check if separate location wrapper exists for triple layout
					if ($('.location__wrapper--triple').length > 0) {
						$('.location__wrapper--triple').fadeIn(300);
					} else {
						// Fallback to details wrapper with proper hiding
						$('.details__wrapper--triple')
							.removeClass('hide-location-inputs hide-maps')
							.addClass('hide-main-title hide-fonts hide-markers-titles')
							.fadeIn(300);
					}
				} else if (isDoubleMapLayout) {
					// Check if separate location wrapper exists for double layout
					if ($('.location__wrapper--double').length > 0) {
						$('.location__wrapper--double').fadeIn(300);
					} else {
						// Fallback to details wrapper with proper hiding
						$('.details__wrapper--double')
							.removeClass('hide-location-inputs hide-maps')
							.addClass('hide-main-title hide-fonts hide-markers-titles')
							.fadeIn(300);
					}
				} else {
					$('.location__wrapper').fadeIn(300);
				}
			}
			// Handle Markers tab
			else if (tabName === 'markers__wrapper') {
				if (isTripleMapLayout) {
					// Check if separate markers wrapper exists for triple layout
					if ($('.markers__wrapper--triple').length > 0) {
						$('.markers__wrapper--triple').fadeIn(300);
						initPickerSvgColors($('.markers__wrapper--triple'));
					} else {
						// Fallback to details wrapper with proper hiding
						$('.details__wrapper--triple')
							.removeClass('hide-markers-titles hide-maps')
							.addClass('hide-main-title hide-fonts hide-location-inputs')
							.fadeIn(300);
						initPickerSvgColors($('.details__wrapper--triple'));
					}
				} else if (isDoubleMapLayout) {
					// Check if separate markers wrapper exists for double layout
					if ($('.markers__wrapper--double').length > 0) {
						$('.markers__wrapper--double').fadeIn(300);
						initPickerSvgColors($('.markers__wrapper--double'));
					} else {
						// Fallback to details wrapper with proper hiding
						$('.details__wrapper--double')
							.removeClass('hide-markers-titles hide-maps')
							.addClass('hide-main-title hide-fonts hide-location-inputs')
							.fadeIn(300);
						initPickerSvgColors($('.details__wrapper--double'));
					}
				} else {
					$('.markers__wrapper').fadeIn(300);
					initPickerSvgColors($('.markers__wrapper'));
				}
			}
			// Handle Design tab
			else if (tabName === 'design__info') {
				$('.design__info').fadeIn(300);
				// For double/triple layouts, show details wrapper (main title + fonts)
				if (isTripleMapLayout) {
					$('.details__wrapper--triple').fadeIn(300);
				} else if (isDoubleMapLayout) {
					$('.details__wrapper--double').fadeIn(300);
				}
			}
		// Handle Preview tab
		else if (tabName === 'preview__wrapper') {
			$('.preview__wrapper').fadeIn(300);
			// Generate preview (will be implemented with backend)
			// Generate preview from backend
		}
			// Handle Format and other tabs
			else {
				$('.' + tabName).fadeIn(300);

				// V9.96.8: Beim ERSTEN Aufruf des Produkt-Tabs automatisch
				// Holzrahmen (data-id=2) auswählen — Default in Ort/Karte/Text
				// ist Mattes Poster (data-id=1), aber im Produkt-Tab soll der
				// User auf das gerahmte Premium-Produkt geleitet werden.
				if (tabName === 'format__wrapper' && !window.__citymapFormatTabVisited) {
					window.__citymapFormatTabVisited = true;
					var $framedTile = $('.tab__switcher ul > li > a[data-id="2"]').not('.current');
					if ($framedTile.length) {
						$framedTile.trigger('click');
					}
				}
			}
		}

		// Mobile: Tab-Bar an den Top scrollen, damit der neue Tab-Inhalt
		// sichtbar ist (Kunden tippten sonst verwirrt mehrfach). Auch wenn
		// der bereits aktive Tab nochmal getippt wird — gleiche UX.
		// Desktop bleibt aussen vor, weil der Switcher dort Flex-Sibling
		// vom Canvas ist und scrollIntoView den Page-Header weghaut.
		if (window.matchMedia('(max-width: 991px)').matches) {
			var sw = $(this).closest('.main__switcher')[0];
			if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	});


	// Weiter-Button am Ende von Tab 1-3 — wechselt zum naechsten Tab.
	// Cart-Button + Preis liegen jetzt INSIDE Tab 4 (Format) am Ende.
	// data-target-tab am Button ist statisch im Liquid gerendert
	// (nicht mehr dynamisch updaten wie alte updateWeiterButton).
	$(document).on('click', '.citymap-customizer .weiter-btn[data-target-tab]', function(e) {
		e.preventDefault();
		var targetTab = $(this).attr('data-target-tab');
		var scope = $(this).closest('.citymap-customizer')[0];
		if (!scope || !targetTab) return;
		var link = scope.querySelector('.main__switcher > ul > li > a[data-tab="' + targetTab + '"]');
		if (link) link.click();
		if (window.matchMedia('(max-width: 991px)').matches) {
			var sw = scope.querySelector('.main__switcher');
			if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	});

	$('.ideas__wrapper .top>a').on("click" ,function(e){
		e.preventDefault();
		$(this).closest('.ideas__wrapper').fadeOut(300);
		$("body,html").css("overflow-y" ,"initial");
	});


	$('.open__popup--ideas').on('click' ,function(e){
		e.preventDefault();
		$('.ideas__wrapper').fadeIn(300);
		$('body,html').css('overflow-y' ,"hidden");

		// Show first category by default
		$('.ideas__wrapper .content>ul>li>a').first().addClass('current');
		$('.list .elem[data-id="1"]').fadeIn(300);
	});



	$('.ideas__wrapper .content>ul>li>a').on('click' ,function(e){
		e.preventDefault();
		if (!$(this).hasClass('current')) {
			$(this).closest("ul").find('.current').removeClass('current');
			$(this).addClass('current');
			$('.list .elem').css("display" , "none");
			$('.list .elem[data-id='+ $(this).attr("data-id") +']').fadeIn(300);
		}
	});
	
	// Handle selecting ideas - clicking on idea message
	$(document).on('click', '.ideas__wrapper .list .elem .idea-item', function(e) {
		e.preventDefault();
		const ideaText = $(this).closest('.elem').attr('data-message');

		// Auto-break text at word boundaries if needed
		const formattedText = autoBreakAtWordBoundary(ideaText);

		// Update the title textarea with selected idea
		const titleTextarea = $('.map__title .content textarea').eq(0);
		titleTextarea.val(formattedText);

		// Validate and update character counter
		const titleCharCounter = document.getElementById('title-char-count');
		validateTextareaInput(titleTextarea[0], titleCharCounter, 40);

		const title = formattedText;
		const subtitle = $('.map__title .content textarea').eq(1).val() || "25°46'N / 80°12'W";

		// Update both poster and preview
		updatePosterTitle(title, subtitle);
		updatePreviewTitle(title, subtitle);

		// Close the popup
		$('.ideas__wrapper').fadeOut(300);
		$('body,html').css('overflow-y', 'initial');

	});


	// Map functionality
	initializeMap();

	// Style picker functionality
	$('.elem__picker ul li a').on('click', function(e) {
		e.preventDefault();

		// Check for data-style attribute first (for Mapbox styles), then fall back to text mapping
		let styleName = $(this).attr('data-style');
		const styleText = $(this).text().toLowerCase().trim();

		// Map style mapping - now using PositivePrints styles
		const styleMap = {
			'minimal': 'minimal',
			'beachglass': 'beachglass',
			'carbon': 'carbon',
			'black': 'black',
			'vintage': 'vintage',
			'classic': 'classic',
			'pink': 'pink',
			'green': 'green',
			'intense': 'intense',
			'atlas': 'atlas',
			'custom': 'custom'
		};

		// If no data-style attribute, use text-based mapping
		if (!styleName && styleMap[styleText]) {
			styleName = styleMap[styleText];
		}

		if (styleName) {
			// Show/hide custom style panel
			if (styleName === 'custom') {
				// Use current style as base for custom colors (not always minimal)
				if (currentStyle && currentStyle !== 'custom') {
					baseStyleForCustom = mapStyles[currentStyle] || currentStyle;
				}
				// Reset changed tracking — no colors explicitly changed yet
				customColorsChanged.clear();
				// Read current colors from map before switching to custom
				const activeMap = map || map1 || map1Triple;
				const currentColors = readCurrentColorsFromMap(activeMap);
				if (currentColors) {
					if (currentColors.land) customColors.land = currentColors.land;
					if (currentColors.roads) customColors.roads = currentColors.roads;
					if (currentColors.water) customColors.water = currentColors.water;
					if (currentColors.background) customColors.background = currentColors.background;
					if (currentColors.buildings) customColors.buildings = currentColors.buildings;
					if (currentColors.text) customColors.text = currentColors.text;
				}
				updateColorPickerUI();
				$('.custom__style').slideDown(300);
			} else {
				$('.custom__style').slideUp(300);

				// Reset background and text colors when switching away from custom
				$('.map-preview-title').css('background-color', '#ffffff');
				$('.map-preview-title h3, .map-preview-title p').css('color', '');
				$('.main__wrapper .outer__main .canvas__wrapper canvas').css('background-color', '');

				// Reset photo preview backgrounds
				$('.with-photo .photo-preview').css('background-color', '');
				$('.photo-preview.with-valentine path.outline').css('fill', '#fff');
				// Note: .photo-preview.with-valentine does NOT need background reset

				// Reset valentine SVG outline color to white
				updateValentineSvgOutlineColor('#ffffff');

			}

			changeMapStyle(styleName).catch(error => {
			});
		}
	});

	// Track previous layout to detect transitions from double/triple to single
	let previousLayoutText = '';

	// Layout picker functionality - target layout options specifically
	$('.design__info .elem__picker:first ul li a').on('click', function(e) {
		e.preventDefault();

		// Use data-layout attribute instead of text content for backend compatibility
		const layoutText = $(this).attr('data-layout') || $(this).text().toLowerCase().trim();


		// Layout mapping
		// V9.98: verlauf + box mappen intern auf 'square' (volle Rechteck-Map),
		// das CSS reagiert separat über das data-layout-Attribut auf .inn.single-map-view.
		const layoutMap = {
			'square': 'square',
			'with photo': 'with-photo',
			'valentine': 'heart',
			'circle': 'circle',
			'heart': 'full-heart',
			'house': 'default',
			'double map': 'double-map',
			'triple map': 'triple-map',
			'verlauf': 'square',
			'box': 'square'
		};

		if (layoutMap[layoutText]) {
			changeMapLayout(layoutMap[layoutText]);

			// V9.98: data-layout-Attribut für CSS-Overlay-Targeting (nur verlauf/box,
			// sonst Attribut entfernen damit Standard-Card-Layout zurückkehrt)
			if (layoutText === 'verlauf' || layoutText === 'box') {
				$('.inn.single-map-view').attr('data-layout', layoutText);
			} else {
				$('.inn.single-map-view').removeAttr('data-layout');
			}
			// V9.99.11: Box-Tab additiv NUR bei Layout=Box. Papier-Tab IMMER sichtbar
			// (auch bei Box-Layout, weil Box mit Rand die Papier-Color braucht).
			// .show()/.hide() statt .toggle(boolean) für robustes Verhalten.
			if (layoutText === 'box') {
				$('.custom__style .switcher a[data-id="box"]').show();
			} else {
				$('.custom__style .switcher a[data-id="box"]').hide();
				$('.custom__style .box[data-id="box"]').hide();
				// Falls Box-Tab gerade current war: fallback auf Land
				var $curBoxTab = $('.custom__style .switcher a.current');
				if ($curBoxTab.attr('data-id') === 'box') {
					$curBoxTab.removeClass('current');
					$('.custom__style .switcher a[data-id="land"]').addClass('current');
					$('.custom__style .box').css('display', 'none');
					$('.custom__style .box[data-id="land"]').fadeIn(300);
				}
			}
			// Mapbox auf neue Container-Höhe resizen (verlauf/box ändern visible map area)
			setTimeout(function() {
				if (typeof map !== 'undefined' && map && typeof map.resize === 'function') {
					try { map.resize(); } catch (e) { /* noop */ }
				}
			}, 80);
			// V9.98.1 Bug 2 Fix: Font-Adjust neu triggern damit Title-Größe der
			// neuen Container-Width entspricht (Box-Modus: schmaler Container,
			// Standard-Modus: breiter Container = Font wächst zurück zu Base 24px)
			// V9.98.7: Subtitle ebenfalls re-adjust (base 14, min 1)
			setTimeout(function() {
				if (typeof adjustPreviewTitleFontSize === 'function') {
					var previewTitleEl = document.getElementById('preview-title');
					var previewSubtitleEl = document.getElementById('preview-subtitle');
					if (previewTitleEl) adjustPreviewTitleFontSize(previewTitleEl);
					if (previewSubtitleEl) adjustPreviewTitleFontSize(previewSubtitleEl, 14, 1);
				}
			}, 150);

			// Check if we're switching FROM double/triple map TO single layout
			const wasDoubleOrTriple = previousLayoutText === 'double map' || previousLayoutText === 'triple map';
			const isNowSingle = layoutText !== 'double map' && layoutText !== 'triple map';

			// For double and triple map, hide portrait/square options and show only landscape
			if (layoutText === 'double map' || layoutText === 'triple map') {
				// Auto-select landscape orientation
				$('.elem__picker .type__switcher li a[data-type="landscape"]').click();
				// Hide portrait and square options
				$('.elem__picker .type__switcher li a[data-type="portrait"]').parent().hide();
				$('.elem__picker .type__switcher li a[data-type="square"]').parent().hide();
			} else {
				// Show all orientation options for other layouts
				$('.elem__picker .type__switcher li').show();
				// Only auto-select portrait if switching from double/triple to single
				if (wasDoubleOrTriple && isNowSingle) {
					$('.elem__picker .type__switcher li a[data-type="portrait"]').click();
				}
			}

			// Hide border picker for circle, heart and verlauf layouts (verlauf erzwingt ohne-Rand)
			if (layoutText === 'circle' || layoutText === 'heart' || layoutText === 'verlauf') {
				$('.border__picker').hide();
				// V9.98.3: Verlauf erzwingt "ohne Rand" — mit-Rand sieht an Seiten blöd aus
				if (layoutText === 'verlauf') {
					var withoutBorderBtn = $('.border__picker a[data-border="without"]');
					if (withoutBorderBtn.length && !withoutBorderBtn.hasClass('current')) {
						withoutBorderBtn.click();
					}
				}
			} else {
				$('.border__picker').show();
			}

			// Update previous layout tracker
			previousLayoutText = layoutText;

			// Foto-Upload-Section unter Layout-Picker je nach Layout
			// ein-/ausblenden (sichtbar nur fuer with-photo / heart).
			syncPhotoUploadSectionVisibility();

			// Switch visible tab content to match new layout
			const activeTab = $('.main__switcher > ul > li > a.current').attr('data-tab');
			if (activeTab === 'location__wrapper') {
				$('.location__wrapper, .location__wrapper--double, .location__wrapper--triple').css('display', 'none');
				if (layoutText === 'double map') {
					$('.location__wrapper--double').fadeIn(300);
				} else if (layoutText === 'triple map') {
					$('.location__wrapper--triple').fadeIn(300);
				} else {
					$('.location__wrapper').fadeIn(300);
				}
			} else if (activeTab === 'markers__wrapper') {
				$('.markers__wrapper, .markers__wrapper--double, .markers__wrapper--triple').css('display', 'none');
				if (layoutText === 'double map') {
					$('.markers__wrapper--double').fadeIn(300);
				} else if (layoutText === 'triple map') {
					$('.markers__wrapper--triple').fadeIn(300);
				} else {
					$('.markers__wrapper').fadeIn(300);
				}
			}
		} else {
		}
	});

	// Search functionality with suggestions
	let searchTimeout;
	$('.details__wrapper input[type="text"], .location__wrapper input[type="text"]').on('input', function() {
		const query = $(this).val().trim();
		const $input = $(this);
		const inputElement = this;
		
		// Show minimum character requirement
		const $span = $input.next('span');
		if (query.length < 3) {
			$span.text('').css('color', '#666');
			// Remove existing suggestions
			const existingSuggestions = document.querySelector('.location-suggestions');
			if (existingSuggestions) {
				existingSuggestions.remove();
			}
			return;
		}
		
		$span.text('Suche...').css('color', '#000000');

		clearTimeout(searchTimeout);
		searchTimeout = setTimeout(() => {
			if (map && map.loaded()) {
				searchLocation(query, false).then(suggestions => {
					if (suggestions && suggestions.length > 0) {
						showLocationSuggestions(suggestions, inputElement);
						$span.text(`${suggestions.length} Orte gefunden`).css('color', '#4CAF50');
					} else {
						$span.text('Keine Orte gefunden').css('color', '#000000');
					}
				}).catch(error => {
					$span.text('Suchfehler, bitte erneut versuchen').css('color', '#000000');
				});
			} else {
				$span.text('Karte wird geladen, bitte warten').css('color', '#000000');
			}
		}, 300);
	});

	// Handle Enter key to select first suggestion
	$('.details__wrapper input[type="text"], .location__wrapper input[type="text"]').on('keydown', function(e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			const suggestions = document.querySelector('.location-suggestions');
			if (suggestions) {
				const firstSuggestion = suggestions.querySelector('.suggestion-item');
				if (firstSuggestion) {
					firstSuggestion.click();
				}
			}
		}
	});

	// Add export button functionality
	$('.bottom__controls .btn a').on('click', function(e) {
		if ($(this).text().includes('Add to cart')) {
			e.preventDefault();
			exportMap();
		}
	});

	// Map marker toggle functionality (single layout only)
	// Use delegated event handler for map marker checkbox (single layout)
	$(document).on('change', '.details__wrapper .map__marker input[type="checkbox"], .markers__wrapper .map__marker input[type="checkbox"]', function() {
		toggleMapMarker();
	});
	
	// Google Places Autocomplete for marker address inputs
	var markerAutocompleteInitialized = {};
	function initMarkerAutocomplete() {
		if (typeof google === 'undefined' || !google.maps || !google.maps.places) return;

		// Single map marker address
		const singleInput = document.getElementById('marker-address-single');
		if (singleInput && !markerAutocompleteInitialized['single']) {
			markerAutocompleteInitialized['single'] = true;
			const ac = new google.maps.places.Autocomplete(singleInput);
			google.maps.event.addListener(ac, 'place_changed', function() {
				const place = ac.getPlace();
				if (place.geometry && place.geometry.location) {
					const lat = place.geometry.location.lat();
					const lng = place.geometry.location.lng();
					if (map && map.loaded()) {
						map.jumpTo({ center: [lng, lat], zoom: 14 });
						addMarker([lng, lat]);
						maybeTitleFromFirstMarker(place.name || singleInput.value, [lng, lat]);
					}
				}
			});
		}

		// Double map marker addresses
		['1', '2'].forEach(function(n) {
			const input = document.getElementById('double-marker-address-' + n);
			if (!input || markerAutocompleteInitialized['double-' + n]) return;
			markerAutocompleteInitialized['double-' + n] = true;
			const ac = new google.maps.places.Autocomplete(input);
			google.maps.event.addListener(ac, 'place_changed', function() {
				const place = ac.getPlace();
				if (place.geometry && place.geometry.location) {
					const lat = place.geometry.location.lat();
					const lng = place.geometry.location.lng();
					const mapInstance = n === '1' ? map1 : map2;
					if (mapInstance && mapInstance.loaded()) {
						mapInstance.jumpTo({ center: [lng, lat], zoom: 14 });
						addMarkerTo('double-' + n, [lng, lat]);
						$('#double-large-text-' + n).val(place.name || input.value);
						$('#double-small-text-' + n).val(formatCoordsDMS(lat, lng));
					}
				}
			});
		});

		// Triple map marker addresses
		['1', '2', '3'].forEach(function(n) {
			const input = document.getElementById('triple-marker-address-' + n);
			if (!input || markerAutocompleteInitialized['triple-' + n]) return;
			markerAutocompleteInitialized['triple-' + n] = true;
			const ac = new google.maps.places.Autocomplete(input);
			google.maps.event.addListener(ac, 'place_changed', function() {
				const place = ac.getPlace();
				if (place.geometry && place.geometry.location) {
					const lat = place.geometry.location.lat();
					const lng = place.geometry.location.lng();
					const mapInstance = n === '1' ? map1Triple : (n === '2' ? map2Triple : map3Triple);
					if (mapInstance && mapInstance.loaded()) {
						mapInstance.jumpTo({ center: [lng, lat], zoom: 14 });
						addMarkerTo('triple-' + n, [lng, lat]);
						$('#triple-large-text-' + n).val(place.name || input.value);
						$('#triple-small-text-' + n).val(formatCoordsDMS(lat, lng));
					}
				}
			});
		});
	}

	// Initialize Google Places when API is ready
	if (typeof google !== 'undefined' && google.maps && google.maps.places) {
		initMarkerAutocomplete();
	} else {
		var googleMapsCheck = setInterval(function() {
			if (typeof google !== 'undefined' && google.maps && google.maps.places) {
				clearInterval(googleMapsCheck);
				initMarkerAutocomplete();
			}
		}, 500);
		setTimeout(function() { clearInterval(googleMapsCheck); }, 10000);
	}
	
	// GPS coordinates input functionality - trigger on blur (focus out)
	$('.address__geo .double input[type="text"]').on('blur change keypress', function(e) {
		// If keypress, only respond to Enter key
		if (e.type === 'keypress' && e.which !== 13) {
			return;
		}
		
		const latInput = $('.address__geo .double input[type="text"]').eq(0);
		const lngInput = $('.address__geo .double input[type="text"]').eq(1);
		
		const lat = parseFloat(latInput.val());
		const lng = parseFloat(lngInput.val());
		
		
		if (!isNaN(lat) && !isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
			// Update map center to marker location
			if (map) {
				const coordinates = [lng, lat];
				
				
				// Center map on the marker location - ensure map is loaded
				if (map.loaded()) {
					map.setCenter(coordinates);
					map.setZoom(14);
				} else {
					map.once('load', () => {
						map.setCenter(coordinates);
						map.setZoom(14);
					});
				}
				
				// Small delay to ensure map has moved, then add marker
				setTimeout(() => {
					// Add marker only if checkbox is checked
					const markerCheckbox = document.querySelector('.map__marker input[type="checkbox"]');
					if (markerCheckbox && markerCheckbox.checked) {
						addMarker(coordinates);
						// Titel-Autofill NACH addMarker (damit die Erster-Marker-Prüfung stimmt)
						maybeTitleFromFirstMarker(formatCoordsDMS(lat, lng), coordinates);
					}
				}, 100);
			}
		} else if (latInput.val() !== '' || lngInput.val() !== '') {
			showToast('Bitte gib gültige Koordinaten ein. Breitengrad: -90 bis 90, Längengrad: -180 bis 180');
		}
	});
	
	// Marker icon selection functionality
	$(document).on('click', '.marker__switcher ul li a', function(e) {
		e.preventDefault();
		if (!$(this).hasClass('current')) {
			$(this).closest('ul').find('.current').removeClass('current');
			$(this).addClass('current');
		}

		// Get the SVG from the current (clicked) element
		const svgElement = $(this).find('.media svg');

		if (svgElement.length > 0) {
			// Clone the SVG and get its outer HTML
			const clonedSvg = svgElement.clone();
			const wrapper = $('<div>').append(clonedSvg);
			const iconHtml = wrapper.html();

			// mapId aus data-map der aktiven Farb-Anchor (Single hat keine → 'single')
			const $markerInfo = $(this).closest('.marker__info');
			const mapType = $markerInfo.find('.marker__color a.current').attr('data-map') || 'single';
			if (markerSettings[mapType]) {
				markerSettings[mapType].iconElement = iconHtml;
				if (selectedMarker[mapType] >= 0) {
					// Marker ausgewählt → wie bisher dessen Symbol ändern
					rebuildSelectedMarker(mapType);
				} else {
					// Nichts ausgewählt → Symbol-Klick schaltet die One-Shot-Platzierung wieder scharf
					// (nur wenn der Marker-Modus/Toggle an ist, erkennbar am registrierten Klick-Handler)
					const m = getMapForId(mapType);
					if (m && m._markerClickHandler) armMarkerPlacement(mapType);
				}
			}
		}
	});
	
	// Marker color selection functionality
	$(document).on('click', '.marker__color .wrap a', function(e) {
		// Let the native label/input handle the color picker opening
		if ($(this).hasClass('custom')) return;
		e.preventDefault();
		if (!$(this).hasClass('current')) {
			$(this).closest('.marker__color').find('.current').removeClass('current');
			$(this).addClass('current');
			
			// Get the color from the clicked element
			const colorElement = $(this).find('.color');
			let selectedColor = colorElement.css('background-color');
			
			
			// Convert rgb to hex if needed
			if (selectedColor && selectedColor.startsWith('rgb')) {
				selectedColor = rgbToHex(selectedColor);
			}
			
			if (selectedColor) {
				const mapType = $(this).attr('data-map') || 'single';
				if (markerSettings[mapType]) {
					markerSettings[mapType].color = selectedColor;
					rebuildSelectedMarker(mapType);
				}

				// Update picker SVG icons in the same marker__info section
				const $markerInfo = $(this).closest('.marker__info');
				// Clear inline styles first (from custom color picker), then set new color
				var $svgEls = $markerInfo.find('.elem__picker ul li a>span.media .img svg, .elem__picker ul li a>span.media .img svg path, .elem__picker ul li a>span.media .img svg g');
				$svgEls.each(function() {
					this.style.fill = selectedColor;
					this.setAttribute('fill', selectedColor);
					// Stroke nur setzen wenn Element bereits stroke hat, sonst aktiv entfernen
					if (this.getAttribute('stroke') && this.getAttribute('stroke') !== 'none') {
						this.style.stroke = selectedColor;
						this.setAttribute('stroke', selectedColor);
					} else {
						this.style.stroke = 'none';
						this.setAttribute('stroke', 'none');
					}
				});
				// Also update .marker-fill and .marker-stroke paths specifically
				$markerInfo.find('.elem__picker .marker-fill').each(function() {
					this.style.fill = selectedColor;
					this.setAttribute('fill', selectedColor);
					this.style.stroke = 'none';
					this.setAttribute('stroke', 'none');
				});
				$markerInfo.find('.elem__picker .marker-stroke').each(function() {
					this.style.stroke = selectedColor;
					this.setAttribute('stroke', selectedColor);
				});
			}
		}
	});

	// PROJ-25: Marker-Liste (jede Karte) — Zeile anklicken wählt aus, ✕ entfernt. mapId aus Container.
	$(document).on('click', '.marker-list__remove', function(e) {
		e.preventDefault();
		e.stopPropagation();
		const mapId = $(this).closest('.marker-list').attr('data-map') || 'single';
		const idx = parseInt($(this).closest('.marker-list__item').attr('data-index'), 10);
		if (!isNaN(idx)) removeMarker(mapId, idx);
	});
	$(document).on('click', '.marker-list__item', function(e) {
		if ($(e.target).closest('.marker-list__remove').length) return;
		const mapId = $(this).closest('.marker-list').attr('data-map') || 'single';
		const idx = parseInt($(this).attr('data-index'), 10);
		if (isNaN(idx)) return;
		// Zeile des ausgewählten Markers erneut antippen wählt ab (Toggle)
		if (idx === selectedMarker[mapId]) { selectedMarker[mapId] = -1; renderMarkerList(mapId); }
		else selectMarker(mapId, idx);
	});

	// Marker size picker handler
	$(document).on('click', '.marker__size-btn', function(e) {
		e.preventDefault();
		const newSize = parseInt($(this).attr('data-size'));
		if (!newSize) return;

		// Update UI
		$(this).closest('.marker__size-options').find('.marker__size-btn').removeClass('active');
		$(this).addClass('active');

		const mapType = $(this).attr('data-map') || 'single';
		if (markerSettings[mapType]) {
			markerSettings[mapType].size = newSize;
			rebuildSelectedMarker(mapType);
		}
	});


	// Map title toggle functionality (single layout only)
	// Use delegated event handler for map title checkbox (single layout)
	$(document).on('change', '.details__wrapper .map__title .title input[type="checkbox"], .markers__wrapper .map__title .title input[type="checkbox"]', function() {
		updateMapTitle();
	});

	// Double/Triple layout marker checkboxes (PROJ-24: 5 identische Handler über Factory gebündelt)
	// getMap/getMarker lesen die globalen Variablen erst zur Laufzeit (Klick-Zeit) — wie zuvor.
	// PROJ-25 Commit 3: Klick fügt einen Marker zur Teilkarte hinzu (statt zu ersetzen);
	// Checkbox aus entfernt alle Marker der Teilkarte. Nutzt das generalisierte mapId-System.
	function bindMarkerCheckbox(checkboxId, mapType, instructionText) {
		$(document).on('change', checkboxId, function() {
			var m = getMapForId(mapType);
			if ($(this).is(':checked')) {
				var $info = $(this).closest('.map__marker').next('.marker__info');
				$info.slideDown(300);
				initPickerSvgColors($info.parent());
				initMarkerAutocomplete();
				if (m) {
					// Scharf für den ersten Marker; kartenspezifischer Hinweis überschreibt den generischen Toast
					armMarkerPlacement(mapType);
					if (instructionText) showMarkerInstruction(instructionText);
					if (!m._markerClickHandler) {
						// One-Shot wie bei der Single-Karte: nur scharf gestellt setzt ein Klick einen Marker
						m._markerClickHandler = function(e) {
							var tgt = e.originalEvent && e.originalEvent.target;
							if (tgt && tgt.closest && tgt.closest('.mapboxgl-marker')) return;
							if (!markerPlacementArmed[mapType]) {
								// Entschärft: Tipp verschiebt den Zielmarker (ausgewählt, sonst zuletzt gesetzt), wie bei der Single-Karte
								var target = selectedMarker[mapType] >= 0 ? selectedMarker[mapType] : lastPlacedMarker[mapType];
								if (!moveMarkerTo(mapType, target, [e.lngLat.lng, e.lngLat.lat]) && mapMarkers[mapType].length === 0) {
									armMarkerPlacement(mapType);
								}
								return;
							}
							addMarkerTo(mapType, [e.lngLat.lng, e.lngLat.lat]);
							selectedMarker[mapType] = -1;
							renderMarkerList(mapType);
							showMarkerInstruction('Marker gesetzt. Tippe oder ziehe, um ihn zu verschieben. Für einen weiteren Marker ein Symbol antippen');
						};
						m.on('click', m._markerClickHandler);
					}
				} else if (instructionText) {
					showMarkerInstruction(instructionText);
				}
			} else {
				// Sicherheitsabfrage ab 2 Markern: erst beim zweiten Antippen wirklich alle entfernen
				if ((mapMarkers[mapType] || []).length >= 2 && !this._confirmClear) {
					$(this).prop('checked', true);
					this._confirmClear = true;
					showMarkerInstruction('Nochmal antippen, um alle ' + mapMarkers[mapType].length + ' Marker zu entfernen');
					var _cb = this;
					setTimeout(function() { _cb._confirmClear = false; }, 4000);
					return;
				}
				this._confirmClear = false;
				$(this).closest('.map__marker').next('.marker__info').slideUp(300);
				markerPlacementArmed[mapType] = false;
				if (m) {
					m.getCanvas().style.cursor = '';
					if (m._markerClickHandler) {
						m.off('click', m._markerClickHandler);
						m._markerClickHandler = null;
					}
				}
				clearMarkers(mapType);
			}
		});
	}

	bindMarkerCheckbox('#double-marker-1', 'double-1', 'Klicke oder tippe auf die linke Karte, um einen Marker zu setzen');
	bindMarkerCheckbox('#double-marker-2', 'double-2', 'Klicke oder tippe auf die rechte Karte, um einen Marker zu setzen');
	bindMarkerCheckbox('#triple-marker-1', 'triple-1', null);
	bindMarkerCheckbox('#triple-marker-2', 'triple-2', null);
	bindMarkerCheckbox('#triple-marker-3', 'triple-3', null);

	// Double layout title checkboxes
	$(document).on('change', '#double-title-1', function() {
		if ($(this).is(':checked')) {
			$(this).closest('.map__title').find('.content').slideDown(300);
		} else {
			$(this).closest('.map__title').find('.content').slideUp(300);
		}
	});

	$(document).on('change', '#double-title-2', function() {
		if ($(this).is(':checked')) {
			$(this).closest('.map__title').find('.content').slideDown(300);
		} else {
			$(this).closest('.map__title').find('.content').slideUp(300);
		}
	});

	// Triple layout title checkboxes
	$(document).on('change', '#triple-title-1', function() {
		if ($(this).is(':checked')) {
			$(this).closest('.map__title').find('.content').slideDown(300);
		} else {
			$(this).closest('.map__title').find('.content').slideUp(300);
		}
	});

	$(document).on('change', '#triple-title-2', function() {
		if ($(this).is(':checked')) {
			$(this).closest('.map__title').find('.content').slideDown(300);
		} else {
			$(this).closest('.map__title').find('.content').slideUp(300);
		}
	});

	$(document).on('change', '#triple-title-3', function() {
		if ($(this).is(':checked')) {
			$(this).closest('.map__title').find('.content').slideDown(300);
		} else {
			$(this).closest('.map__title').find('.content').slideUp(300);
		}
	});

	// Double and Triple layout marker icon selection
	// Double/triple icon and color selection is handled by the generic
	// .marker__switcher and .marker__color handlers above

	// Initialize picker SVG colors for a given marker__info section
	function initPickerSvgColors($wrapper) {
		$wrapper.find('.marker__info').each(function() {
			var $info = $(this);
			var $currentColor = $info.find('.marker__color a.current');
			var color = null;

			// Get color from the current swatch
			if ($currentColor.length) {
				var bg = $currentColor.find('.color').css('background-color');
				if (bg && bg.startsWith('rgb')) {
					color = rgbToHex(bg);
				} else {
					color = bg;
				}
			}

			// Fallback to markerSettings or default
			if (!color) {
				var mapType = $info.find('.marker__color a[data-map]').attr('data-map');
				if (mapType && markerSettings[mapType]) {
					color = markerSettings[mapType].color;
				}
			}
			if (!color) color = markerSettings['single'].color;

			// Apply to picker SVGs
			$info.find('.elem__picker ul li a>span.media .img svg, .elem__picker ul li a>span.media .img svg path, .elem__picker ul li a>span.media .img svg g').each(function() {
				this.style.fill = color;
				this.setAttribute('fill', color);
				if (this.getAttribute('stroke') && this.getAttribute('stroke') !== 'none') {
					this.style.stroke = color;
					this.setAttribute('stroke', color);
				} else {
					this.style.stroke = 'none';
					this.setAttribute('stroke', 'none');
				}
			});
			$info.find('.elem__picker .marker-fill').each(function() {
				this.style.fill = color;
				this.setAttribute('fill', color);
				this.style.stroke = 'none';
				this.setAttribute('stroke', 'none');
			});
			$info.find('.elem__picker .marker-stroke').each(function() {
				this.style.stroke = color;
				this.setAttribute('stroke', color);
			});
		});
	}

	// PROJ-25: createMarkerForMap entfernt — makeMarkerInstance(mapId) übernimmt.

	// PROJ-25 Commit 3: updateMarkerIcon/updateMarkerColor (switch-basiert auf currentDoubleMarker*)
	// entfernt — rebuildSelectedMarker(mapType) übernimmt Icon-/Farbwechsel für alle Karten.

	/**
	 * Auto-breaks text at word boundaries when first line exceeds 40 characters
	 * @param {string} text - The text to process
	 * @returns {string} - Text with line break inserted at word boundary if needed
	 */
	function autoBreakAtWordBoundary(text) {
		// If text is 40 chars or less, no breaking needed
		if (text.length <= 40) {
			return text;
		}

		// Find the last space at or before position 40
		let breakPoint = -1;
		for (let i = 40; i >= 0; i--) {
			if (text[i] === ' ') {
				breakPoint = i;
				break;
			}
		}

		// If no space found in first 40 chars, break at 40 (hard break)
		if (breakPoint === -1) {
			breakPoint = 40;
		}

		// Split text at break point
		const firstLine = text.substring(0, breakPoint).trim();
		let secondLine = text.substring(breakPoint).trim();

		// Ensure second line doesn't exceed 40 chars
		if (secondLine.length > 40) {
			secondLine = secondLine.substring(0, 40);
		}

		return firstLine + '\n' + secondLine;
	}

	// Single-line normalisierung — Newlines strippen, kein Char-Limit mehr.
	// (maxLength + charCountElement Args bleiben zwecks Rueckwaertskompatibilitaet
	// in der Signatur, werden aber ignoriert. Limits 2026-04-28 entfernt.)
	function validateTextareaInput(textarea, charCountElement, maxLength) {
		let value = textarea.value;
		value = value.replace(/[\r\n]/g, '');
		if (textarea.value !== value) {
			textarea.value = value;
		}
		return value;
	}

	// Prevent line breaks in title/subtitle textareas (single line only)
	$('.details__wrapper .map__title .content textarea, .markers__wrapper .map__title .content textarea').on('keydown', function(e) {
		if (e.key === 'Enter') {
			e.preventDefault();
		}
	}).on('input', function() {
		// Strip any newlines that might have been pasted
		this.value = this.value.replace(/[\r\n]/g, '');
	});

	// Title input change handlers (single layout only)
	$('.details__wrapper .map__title .content textarea, .markers__wrapper .map__title .content textarea').on('input', function() {
		const titleInput = $('.details__wrapper .map__title .content textarea, .markers__wrapper .map__title .content textarea').eq(0);
		const subtitleInput = $('.details__wrapper .map__title .content textarea, .markers__wrapper .map__title .content textarea').eq(1);

		// Validate input with line breaks and character limits
		const titleCharCounter = document.getElementById('title-char-count');
		const subtitleCharCounter = document.getElementById('subtitle-char-count');

		const title = validateTextareaInput(titleInput[0], titleCharCounter, 40) || '';
		const subtitle = validateTextareaInput(subtitleInput[0], subtitleCharCounter, 48) || '';

		updatePosterTitle(title, subtitle);
		updatePreviewTitle(title, subtitle);
	});

	// Paste event handlers - strip line breaks for single line input
	$('.details__wrapper .map__title .content textarea, .markers__wrapper .map__title .content textarea').on('paste', function(e) {
		e.preventDefault();

		// Get pasted text from clipboard
		const pastedText = (e.originalEvent || e).clipboardData.getData('text/plain');

		// Strip line breaks for single line input
		const formattedText = pastedText.replace(/[\r\n]/g, ' ').trim();

		// Get current cursor position
		const textarea = this;
		const startPos = textarea.selectionStart;
		const endPos = textarea.selectionEnd;

		// Insert formatted text at cursor position
		const currentValue = textarea.value;
		const newValue = currentValue.substring(0, startPos) + formattedText + currentValue.substring(endPos);

		// Set new value
		textarea.value = newValue;

		// Move cursor to end of inserted text
		const newCursorPos = startPos + formattedText.length;
		textarea.setSelectionRange(newCursorPos, newCursorPos);

		// Trigger input event to update preview and validate
		$(textarea).trigger('input');
	});

	// Initialize character counters on page load
	$(document).ready(function() {
		const titleInput = document.getElementById('map-title-input');
		const subtitleInput = document.getElementById('map-subtitle-input');
		const titleCharCounter = document.getElementById('title-char-count');
		const subtitleCharCounter = document.getElementById('subtitle-char-count');

		if (titleInput && titleCharCounter) {
			const titleChars = titleInput.value.replace(/\n/g, '').length;
			titleCharCounter.textContent = titleChars;
		}

		if (subtitleInput && subtitleCharCounter) {
			const subtitleChars = subtitleInput.value.replace(/\n/g, '').length;
			subtitleCharCounter.textContent = subtitleChars;
		}
	});

	// Initialize map title state (single layout only)
	const titleCheckbox = $('.details__wrapper .map__title .title input[type="checkbox"], .markers__wrapper .map__title .title input[type="checkbox"]');
	if (titleCheckbox.prop('checked')) {
		$('.details__wrapper .map__title .content, .markers__wrapper .map__title .content').show();
		const posterTitle = document.querySelector('.poster-title');
		if (posterTitle) {
			posterTitle.style.display = 'block';
		}
	} else {
		const posterTitle = document.querySelector('.poster-title');
		if (posterTitle) {
			posterTitle.style.display = 'none';
		}
	}

	// Initialize frame image on page load
	setTimeout(function() {
		updateFrameImage();
	}, 500);













	// Marker info toggle (address vs GPS) for all map types
	$(document).on('click', '.marker__info>.btns>a', function(e){
		e.preventDefault();
		if (!$(this).hasClass("current")) {
			$(this).closest(".btns").find(">a").removeClass("current");
			$(this).addClass('current');
			const $markerInfo = $(this).closest('.marker__info');
			const dataId = $(this).attr("data-id");
			if (dataId && dataId.startsWith("address")) {
				$markerInfo.find('.address__info').fadeIn(300);
				$markerInfo.find('.address__geo').css("display" ,"none");
			}
			if (dataId && dataId.startsWith("gps")) {
				$markerInfo.find('.address__info').css("display" ,"none");
				$markerInfo.find('.address__geo').fadeIn(300)
			}
		}
	});


	$('.elem__picker.image__changer ul li a').on('click' ,function(e){
		if ($(this).closest('.image__changer').length) {
			if ($(this).hasClass('current')) {
				// Update frame based on orientation and color
				updateFrameImage();
			}
		}
	});


	// V9.99.11: Box-Tab defensiv beim Initial-Load verstecken (CSS display:inline-flex
	// überschreibt sonst Liquid-inline-style:display:none). Box-Tab erscheint erst
	// nach Layout-Switch zu Box (siehe Layout-Click-Handler V9.99.11-Block).
	$('.custom__style .switcher a[data-id="box"]').hide();
	$('.custom__style .box[data-id="box"]').hide();

	$('.custom__style>.switcher>a').on("click" ,function(e){
		e.preventDefault();
		if (!$(this).hasClass('current')) {
			$(this).closest(".switcher").find(".current").removeClass('current');
			$(this).addClass('current');
			$('.custom__style .box').css("display" , 'none');
			$('.custom__style .box[data-id='+ $(this).attr("data-id") +']').fadeIn(300);
		}
	});



	// Note: marker__color .wrap a click is handled by the delegated handler above


	$('.custom__style .wrap a').on("click" ,function(e){
		// Don't prevent default for custom color picker links - let the color picker work
		if ($(this).hasClass('custom')) {
			return;
		}

		e.preventDefault();
		if (!$(this).hasClass('current')) {
			// Get the active tab to determine which property we're changing
			const activeTab = $('.custom__style .switcher a.current').attr('data-id');
			customColorsChanged.add(activeTab);

			// Get the color from the span element
			const colorElement = $(this).find('.color');
			let selectedColor = colorElement.css('background-color');
			
			// Convert rgb to hex if needed
			if (selectedColor && selectedColor.startsWith('rgb')) {
				selectedColor = rgbToHex(selectedColor);
			}
			
			// Update the customColors object based on active tab
			if (activeTab && selectedColor) {
				if (activeTab === 'land') {
					customColors.land = selectedColor;
				} else if (activeTab === 'roads') {
					customColors.roads = selectedColor;
				} else if (activeTab === 'water') {
					customColors.water = selectedColor;
				} else if (activeTab === 'background') {
					customColors.background = selectedColor;
					document.documentElement.style.setProperty('--paper-color', selectedColor);
					// Apply background color to preview title and canvas element
					$('.map-preview-title').css('background-color', selectedColor);
					$('.main__wrapper .outer__main .canvas__wrapper canvas').css('background-color', selectedColor);
					$('.main__wrapper .outer__main .canvas__wrapper .inn').css('background-color', selectedColor);
					$('div#map').css('background-color', selectedColor);
					$('canvas.mapboxgl-canvas').css('background-color', selectedColor);
					$('.photo-preview').css('background-color', selectedColor);
					$('div#map.layout-circle').css('background-color', selectedColor);
					$('div#map.layout-full-heart').css('background-color', selectedColor);

					// Update SVG shape frame overlay color (circle/heart)
					updateShapeFrameColor(selectedColor);

					// Apply background color to double and triple map layouts
					$('.double-map-view').css('background-color', selectedColor);
					$('.triple-map-view').css('background-color', selectedColor);
					$('.double-map-container').css('background-color', selectedColor);
					$('.triple-map-container').css('background-color', selectedColor);
					$('.double-map').css('background-color', selectedColor);
					$('.triple-map').css('background-color', selectedColor);
					$('#map1, #map2').css('background-color', selectedColor);
					$('#map1-triple, #map2-triple, #map3-triple').css('background-color', selectedColor);

					// Apply background color to photo preview areas
					$('.with-photo .photo-preview').css('background-color', selectedColor);
					$('.photo-preview.with-valentine path.outline').css('fill', selectedColor);
					// Note: .photo-preview.with-valentine does NOT get background color

					// For valentine SVG, update the path.outline fill color
					updateValentineSvgOutlineColor(selectedColor);

					// Automatically adjust text color based on background brightness
					const textColor = getContrastTextColor(selectedColor);
					$('.map-preview-title h3, .map-preview-title p').css('color', textColor);

					// Apply text color to double and triple map labels
					$('.double-map-title h2').css('color', textColor);
					$('.triple-map-title h2').css('color', textColor);
					$('.map-label h3, .map-label p').css('color', textColor);

				} else if (activeTab === 'buildings') {
					customColors.buildings = selectedColor;
				} else if (activeTab === 'text') {
					customColors.text = selectedColor;
					$('.map-preview-title h3, .map-preview-title p').css('color', selectedColor);
					$('.double-map-title h2').css('color', selectedColor);
					$('.triple-map-title h2').css('color', selectedColor);
					$('.map-label h3, .map-label p').css('color', selectedColor);
				} else if (activeTab === 'box') {
					// V9.99.10: Box-Background-Color (Box-Layout) via CSS-var
					customColors.box = selectedColor;
					document.documentElement.style.setProperty('--box-color', selectedColor);
				}

				// Set current style to 'custom' to preserve it across layout switches
				currentStyle = 'custom';

				// Apply the new colors to the map
				applyCustomMapColors();

			}

			// Update UI
			$(this).closest(".box").find('.current').removeClass('current');
			$(this).addClass('current');
		}
	});


	// Set first size as selected if none is selected
	if ($('.elem__picker .size__picker a.current').length === 0) {
		$('.elem__picker .size__picker a').first().addClass('current');
	}
	
	resizeFrame();

	$(window).on('resize' ,function(){
		resizeFrame();
	});

	// Function to update size picker display based on orientation
	function updateSizePickerDisplay() {
		const currentOrientation = resizeType; // 'portrait', 'landscape', or 'square'


		// Update all size picker options
		$('.elem__picker .size__picker a').each(function() {
			const $sizeOption = $(this);
			const $textElement = $sizeOption.find('.head p');
			const originalText = $textElement.attr('data-original-size') || $textElement.text().trim();

			// Store original if not already stored
			if (!$textElement.attr('data-original-size')) {
				$textElement.attr('data-original-size', originalText);
			}

			// Parse dimensions from text (e.g., "40x30cm" or "A4")
			const match = originalText.match(/(\d+)\s*[xX×]\s*(\d+)\s*(?:cm)?/);

			if (match) {
				let width = parseInt(match[1]);
				let height = parseInt(match[2]);

				// Apply orientation transformation
				if (currentOrientation === 'landscape') {
					// Landscape: ensure width > height (swap if needed)
					if (width < height) {
						[width, height] = [height, width];
					}
					$textElement.text(`${width}x${height}cm`);
				} else if (currentOrientation === 'portrait') {
					// Portrait: ensure height > width (swap if needed)
					if (width > height) {
						[width, height] = [height, width];
					}
					$textElement.text(`${width}x${height}cm`);
				} else if (currentOrientation === 'square') {
					// Square: use the smaller dimension for both
					const minDim = Math.min(width, height);
					$textElement.text(`${minDim}x${minDim}cm`);
				}

			} else {
				// For non-numeric sizes (like "A4"), keep original
				$textElement.text(originalText);
			}
		});
	}

	// Initialize size picker display on page load
	updateSizePickerDisplay();

	$('.elem__picker .type__switcher li a').on('click' ,function(e){
		e.preventDefault();
		
		// Update current class
		if (!$(this).hasClass('current')) {
			$(this).closest('ul').find('.current').removeClass('current');
			$(this).addClass('current');
		}
		
		const layoutType = $(this).attr("data-type");
		
		// Get currently selected size
		const currentSize = $('.elem__picker .size__picker a.current .head p').text().trim();
		
		const sizeRatio = lookupSizeRatio(currentSize);

		// Base ratios for each layout type
		if (layoutType == "portrait") {
			resizeType = "portrait";
			currentAspectRatio = sizeRatio || 1.414; // Default A4 portrait
		}
		else if (layoutType == "square") {
			resizeType = "square";
			currentAspectRatio = 1.0; // Square is always 1:1
		}
		else if (layoutType == "landscape") {
			resizeType = "landscape";
			// For landscape, use the same ratio as portrait
			// Portrait: 21×29.7cm (ratio = 29.7/21 = 1.414 for height/width)
			// Landscape: 29.7×21cm (ratio = 29.7/21 = 1.414 for width/height)
			// The ratio value is the same, just applied to different dimensions
			currentAspectRatio = sizeRatio || 1.414; // Default A4 landscape
		}
		

		// Update size picker display to reflect new orientation
		updateSizePickerDisplay();

		// Update frame image based on new orientation
		updateFrameImage();

		// Reinitialize map for crisp rendering with new dimensions
		reinitializeMap();
	});
	
	
	// Double map title event listeners
	$('#double-map-main-title').on('input', function() {
		const title = $(this).val();
		$('.double-map-title h2').text(title);
	});

	$('#double-map-title-1').on('input', function() {
		const title = $(this).val();
		$('.map-1-title').text(title);
	});

	$('#double-map-title-2').on('input', function() {
		const title = $(this).val();
		$('.map-2-title').text(title);
	});

	// Double/Triple map place search (PROJ-24: 5 identische Handler über Factory gebündelt)
	// getMap liest die globale Map-Variable erst beim Timeout-Ablauf — wie zuvor.
	function bindPlaceSearchInput(inputId, timeoutKey, getMap) {
		$(inputId).on('input', function() {
			const query = $(this).val().trim();
			const $input = $(this);
			const inputElement = this;
			const $span = $input.next('span');

			if (query.length < 3) {
				$span.text('').css('color', '#666');
				return;
			}

			$span.text('Suche...').css('color', '#000000');

			clearTimeout(window[timeoutKey]);
			window[timeoutKey] = setTimeout(() => {
				const map = getMap();
				if (map && map.loaded()) {
					searchLocation(query, false).then(suggestions => {
						if (suggestions && suggestions.length > 0) {
							showLocationSuggestions(suggestions, inputElement);
							$span.text(`${suggestions.length} Orte gefunden`).css('color', '#4CAF50');
						} else {
							$span.text('Keine Orte gefunden').css('color', '#000000');
						}
					}).catch(error => {
						$span.text('Suchfehler, bitte erneut versuchen').css('color', '#000000');
					});
				} else {
					$span.text('Karte wird geladen, bitte warten').css('color', '#000000');
				}
			}, 300);
		});
	}

	bindPlaceSearchInput('#double-map-place-1', 'doubleMapSearchTimeout1', function() { return map1; });
	bindPlaceSearchInput('#double-map-place-2', 'doubleMapSearchTimeout2', function() { return map2; });
	bindPlaceSearchInput('#triple-map-place-1', 'tripleMapSearchTimeout1', function() { return map1Triple; });
	bindPlaceSearchInput('#triple-map-place-2', 'tripleMapSearchTimeout2', function() { return map2Triple; });
	bindPlaceSearchInput('#triple-map-place-3', 'tripleMapSearchTimeout3', function() { return map3Triple; });

	// Double map marker toggle is handled by the handlers above (Set A)

	// Double map address/GPS toggle is handled by the generic handler above

	// Double/triple marker address search is handled by Google Places Autocomplete
	// initialized in initMarkerAutocomplete()

	// GPS-Koordinaten-Eingaben Double/Triple (PROJ-24: 5 identische Handler über Factory gebündelt)
	// getMap/getMarker lesen die globalen Variablen erst zur Event-Zeit — wie zuvor.
	// PROJ-25 Commit 3: GPS-Eingabe fügt einen Marker zur Teilkarte hinzu (Array-System).
	function bindGpsCoordInputs(latId, lngId, mapType, largeTextId, smallTextId) {
		$(latId + ', ' + lngId).on('blur change keypress', function(e) {
			if (e.type === 'keypress' && e.which !== 13) return;

			const lat = parseFloat($(latId).val());
			const lng = parseFloat($(lngId).val());

			if (!isNaN(lat) && !isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
				const m = getMapForId(mapType);
				if (m && m.loaded()) {
					const coordinates = [lng, lat];
					m.setCenter(coordinates);
					m.setZoom(14);

					addMarkerTo(mapType, coordinates);

					$(largeTextId).val(formatCoordsDMS(lat, lng));
					$(smallTextId).val(formatCoordsDMS(lat, lng));
				}
			}
		});
	}

	bindGpsCoordInputs('#double-marker-lat-1', '#double-marker-lng-1', 'double-1', '#double-large-text-1', '#double-small-text-1');
	bindGpsCoordInputs('#double-marker-lat-2', '#double-marker-lng-2', 'double-2', '#double-large-text-2', '#double-small-text-2');
	bindGpsCoordInputs('#triple-marker-lat-1', '#triple-marker-lng-1', 'triple-1', '#triple-large-text-1', '#triple-small-text-1');
	bindGpsCoordInputs('#triple-marker-lat-2', '#triple-marker-lng-2', 'triple-2', '#triple-large-text-2', '#triple-small-text-2');
	bindGpsCoordInputs('#triple-marker-lat-3', '#triple-marker-lng-3', 'triple-3', '#triple-large-text-3', '#triple-small-text-3');

	// Double map title toggle functionality
	$(document).on('change', '#double-title-1', function() {
		const isChecked = $(this).prop('checked');
		const $mapSection = $(this).closest('.map-section');
		const $content = $mapSection.find('.map__title .content').first();
		
		if (isChecked) {
			$content.slideDown(300);
			// Show map labels
			$('.double-map-container .map-wrapper').eq(0).find('.map-label').show();
		} else {
			$content.slideUp(300);
			// Hide map labels
			$('.double-map-container .map-wrapper').eq(0).find('.map-label').hide();
		}
	});

	$(document).on('change', '#double-title-2', function() {
		const isChecked = $(this).prop('checked');
		const $mapSection = $(this).closest('.map-section');
		const $content = $mapSection.find('.map__title .content').first();
		
		if (isChecked) {
			$content.slideDown(300);
			// Show map labels
			$('.double-map-container .map-wrapper').eq(1).find('.map-label').show();
		} else {
			$content.slideUp(300);
			// Hide map labels
			$('.double-map-container .map-wrapper').eq(1).find('.map-label').hide();
		}
	});

	// Double map main title input handler
	$('#double-main-title').on('input', function() {
		const mainTitle = $(this).val() || '';
		$('.double-map-title h2').text(mainTitle);
	});

	// Double map title text input handlers
	$('#double-large-text-1, #double-small-text-1').on('input', function() {
		const largeText = $('#double-large-text-1').val() || '';
		const smallText = $('#double-small-text-1').val() || '';
		$('.double-map-container .map-wrapper:first .map-label h3').text(largeText);
		$('.double-map-container .map-wrapper:first .map-label p').text(smallText);
	});

	$('#double-large-text-2, #double-small-text-2').on('input', function() {
		const largeText = $('#double-large-text-2').val() || '';
		const smallText = $('#double-small-text-2').val() || '';
		$('.double-map-container .map-wrapper:last .map-label h3').text(largeText);
		$('.double-map-container .map-wrapper:last .map-label p').text(smallText);
	});

	// Triple map main title input handler
	$('#triple-main-title').on('input', function() {
		const mainTitle = $(this).val() || '';
		$('.triple-map-title h2').text(mainTitle);
	});

	// Triple map title text input handlers
	$('#triple-large-text-1, #triple-small-text-1').on('input', function() {
		const largeText = $('#triple-large-text-1').val() || '';
		const smallText = $('#triple-small-text-1').val() || '';
		$('.triple-map-container .map-wrapper:nth-child(1) .map-label h3').text(largeText);
		$('.triple-map-container .map-wrapper:nth-child(1) .map-label p').text(smallText);
	});

	$('#triple-large-text-2, #triple-small-text-2').on('input', function() {
		const largeText = $('#triple-large-text-2').val() || '';
		const smallText = $('#triple-small-text-2').val() || '';
		$('.triple-map-container .map-wrapper:nth-child(2) .map-label h3').text(largeText);
		$('.triple-map-container .map-wrapper:nth-child(2) .map-label p').text(smallText);
	});

	$('#triple-large-text-3, #triple-small-text-3').on('input', function() {
		const largeText = $('#triple-large-text-3').val() || '';
		const smallText = $('#triple-small-text-3').val() || '';
		$('.triple-map-container .map-wrapper:nth-child(3) .map-label h3').text(largeText);
		$('.triple-map-container .map-wrapper:nth-child(3) .map-label p').text(smallText);
	});

	// Font picker functionality - use event delegation for dynamically added elements
	$(document).on('click', '.font__picker .font-options li a, .font__picker .font-options-grid li a', function(e) {
		e.preventDefault();
		e.stopPropagation();

		// Remove current class from all font options
		$('.font__picker .font-options li a, .font__picker .font-options-grid li a').removeClass('current');
		$(this).addClass('current');

		// Get selected font
		const selectedFont = $(this).attr('data-font');

		// Save current font globally
		currentFont = selectedFont;

		// Apply font to all text elements in the map preview areas
		applyFontToAllLayouts(selectedFont);
	});

	// Border picker functionality (from original citymap (5).js)
	$('.border__picker .border-options li a').on('click', function(e) {
		e.preventDefault();

		// Remove current class from all border options
		$('.border__picker .border-options li a').removeClass('current');
		$(this).addClass('current');

		// Get selected border option
		const selectedBorder = $(this).attr('data-border');

		// Save current border globally
		currentBorder = selectedBorder;

		// Add or remove no-border class from #map (controls ::before white frame overlay)
		const mapContainer = $('#map');
		if (selectedBorder === 'without') {
			mapContainer.addClass('no-border');
		} else {
			mapContainer.removeClass('no-border');
		}
		// Recalculate dimensions (border affects content area with box-sizing: border-box)
		resizeFrame();
		setTimeout(function() { map.resize(); }, 50);
	});

	// Tab help toggle (Glühbirne an/aus + Hilfetext aufklappen/zuklappen)
	// Sync: Ein/Aus gilt für ALLE Tabs gleichzeitig
	$(document).on('click', '.tab-help__toggle', function(e) {
		e.preventDefault();
		var $thisContent = $(this).closest('.tab-help').next('.tab-help__content');
		var isCurrentlyVisible = $thisContent.is(':visible');

		if (isCurrentlyVisible) {
			$('.tab-help__content').slideUp(300);
			$('.tab-help__toggle').removeClass('is-active');
		} else {
			$('.tab-help__content').slideDown(300);
			$('.tab-help__toggle').addClass('is-active');
		}
	});
	$(document).on('click', '.tab-help__close a', function(e) {
		e.preventDefault();
		$('.tab-help__content').slideUp(300);
		$('.tab-help__toggle').removeClass('is-active');
	});

	// V9.96.9: Glühbirne default AUS — User-Wunsch, Konfigurator soll mit
	// eingeklapptem Hilfetext starten. Toggle bleibt funktional.

	// PROJ-25: Der frühere #single-marker-Handler war redundant zum generischen
	// .map__marker-Checkbox-Handler oben (→ toggleMapMarker) und rief die entfernte
	// placeMarkerAtLocation. Entfernt; toggleMapMarker übernimmt Single-Marker-Modus.

	// Map title checkbox handler
	$(document).on('change', '#single-title', function() {
		const posterTitle = document.querySelector('.poster-title');
		if ($(this).is(':checked')) {
			$(this).closest('.title').next('.content').slideDown(300);
			if (posterTitle) {
				posterTitle.style.display = 'block';
			}
		} else {
			$(this).closest('.title').next('.content').slideUp(300);
			if (posterTitle) {
				posterTitle.style.display = 'none';
			}
		}
	});

	// Double layout marker checkbox slideDown/slideUp handled by the main handlers above

	// Double layout title checkbox handlers
	$(document).on('change', '#double-title-1', function() {
		const mapLabel = document.querySelector('.double-map-container .map-wrapper:first .map-label');
		if ($(this).is(':checked')) {
			$(this).closest('.title').next('.content').slideDown(300);
			if (mapLabel) {
				mapLabel.style.display = 'block';
			}
		} else {
			$(this).closest('.title').next('.content').slideUp(300);
			if (mapLabel) {
				mapLabel.style.display = 'none';
			}
		}
	});

	$(document).on('change', '#double-title-2', function() {
		const mapLabel = document.querySelector('.double-map-container .map-wrapper:last .map-label');
		if ($(this).is(':checked')) {
			$(this).closest('.title').next('.content').slideDown(300);
			if (mapLabel) {
				mapLabel.style.display = 'block';
			}
		} else {
			$(this).closest('.title').next('.content').slideUp(300);
			if (mapLabel) {
				mapLabel.style.display = 'none';
			}
		}
	});

	// Triple layout marker checkbox slideDown/slideUp handled by the main handlers above

	// Triple layout title checkbox handlers
	$(document).on('change', '#triple-title-1', function() {
		const mapLabel = document.querySelector('.triple-map-container .map-wrapper:nth-child(1) .map-label');
		if ($(this).is(':checked')) {
			$(this).closest('.title').next('.content').slideDown(300);
			if (mapLabel) {
				mapLabel.style.display = 'block';
			}
		} else {
			$(this).closest('.title').next('.content').slideUp(300);
			if (mapLabel) {
				mapLabel.style.display = 'none';
			}
		}
	});

	$(document).on('change', '#triple-title-2', function() {
		const mapLabel = document.querySelector('.triple-map-container .map-wrapper:nth-child(2) .map-label');
		if ($(this).is(':checked')) {
			$(this).closest('.title').next('.content').slideDown(300);
			if (mapLabel) {
				mapLabel.style.display = 'block';
			}
		} else {
			$(this).closest('.title').next('.content').slideUp(300);
			if (mapLabel) {
				mapLabel.style.display = 'none';
			}
		}
	});

	$(document).on('change', '#triple-title-3', function() {
		const mapLabel = document.querySelector('.triple-map-container .map-wrapper:nth-child(3) .map-label');
		if ($(this).is(':checked')) {
			$(this).closest('.title').next('.content').slideDown(300);
			if (mapLabel) {
				mapLabel.style.display = 'block';
			}
		} else {
			$(this).closest('.title').next('.content').slideUp(300);
			if (mapLabel) {
				mapLabel.style.display = 'none';
			}
		}
	});

	// Debounce timer for custom color picker
	let customColorDebounceTimer = null;

	// Custom color picker functionality - handle both input and change events for immediate feedback
	$(document).on('input change', '.custom-color-picker', function(e) {
		e.stopPropagation();
		const selectedColor = $(this).val();
		const $customLink = $(this).closest('a.custom');

		// Check if this is a marker color picker or style color picker
		const isMarkerColor = $(this).closest('.marker__color').length > 0;
		const isCustomStyle = $(this).closest('.custom__style').length > 0;

		if (isMarkerColor) {
			// Handle marker color
			// Remove current class from all marker color options in this section
			$(this).closest('.marker__color').find('a').removeClass('current');
			$customLink.addClass('current');

			const mapType = $customLink.attr('data-map') || 'single';
			if (markerSettings[mapType]) {
				markerSettings[mapType].color = selectedColor;
				rebuildSelectedMarker(mapType);
			}

			// Update picker SVG icons in the same marker__info section
			const $markerInfo = $(this).closest('.marker__info');
			$markerInfo.find('.elem__picker ul li a>span.media .img svg, .elem__picker ul li a>span.media .img svg path, .elem__picker ul li a>span.media .img svg g').each(function() {
				this.style.fill = selectedColor;
				this.setAttribute('fill', selectedColor);
				if (this.getAttribute('stroke') && this.getAttribute('stroke') !== 'none') {
					this.style.stroke = selectedColor;
					this.setAttribute('stroke', selectedColor);
				} else {
					this.style.stroke = 'none';
					this.setAttribute('stroke', 'none');
				}
			});
			$markerInfo.find('.elem__picker .marker-fill').each(function() {
				this.style.fill = selectedColor;
				this.setAttribute('fill', selectedColor);
				this.style.stroke = 'none';
				this.setAttribute('stroke', 'none');
			});
			$markerInfo.find('.elem__picker .marker-stroke').each(function() {
				this.style.stroke = selectedColor;
				this.setAttribute('stroke', selectedColor);
			});

		} else if (isCustomStyle) {
			// Handle custom map style colors (land, roads, water, background)
			const colorType = $customLink.attr('data-type');
			customColorsChanged.add(colorType);

			// Remove current class from all options in this box
			$(this).closest('.box').find('a').removeClass('current');
			$customLink.addClass('current');

			// Update the visual color swatch immediately for instant feedback
			$customLink.find('.color').css('background-color', selectedColor);

			// Update custom color for the specific type
			if (colorType && customColors[colorType] !== undefined) {
				customColors[colorType] = selectedColor;

				// Special handling for background color - apply to all necessary elements
				if (colorType === 'background') {
					document.documentElement.style.setProperty('--paper-color', selectedColor);
					// Apply background color to all canvas and preview elements immediately
					$('.map-preview-title').css('background-color', selectedColor);
					$('.main__wrapper .outer__main .canvas__wrapper canvas').css('background-color', selectedColor);
					$('.main__wrapper .outer__main .canvas__wrapper .inn').css('background-color', selectedColor);
					$('canvas.mapboxgl-canvas').css('background-color', selectedColor);
					$('.photo-preview').css('background-color', selectedColor);
					$('div#map').css('background-color', selectedColor);
					$('div#map.layout-circle').css('background-color', selectedColor);
					$('div#map.layout-full-heart').css('background-color', selectedColor);

					// Update SVG shape frame overlay color
					updateShapeFrameColor(selectedColor);

					// Apply background color to double and triple map layouts
					$('.double-map-view').css('background-color', selectedColor);
					$('.triple-map-view').css('background-color', selectedColor);
					$('.double-map-container').css('background-color', selectedColor);
					$('.triple-map-container').css('background-color', selectedColor);
					$('.double-map').css('background-color', selectedColor);
					$('.triple-map').css('background-color', selectedColor);
					$('#map1, #map2').css('background-color', selectedColor);
					$('#map1-triple, #map2-triple, #map3-triple').css('background-color', selectedColor);

					// Apply background color to photo preview areas
					$('.with-photo .photo-preview').css('background-color', selectedColor);
					$('.photo-preview.with-valentine path.outline').css('fill', selectedColor);

					// Automatically adjust text color based on background brightness
					const textColor = getContrastTextColor(selectedColor);
					$('.map-preview-title h3, .map-preview-title p').css('color', textColor);

					// Apply text color to double and triple map labels
					$('.double-map-title h2').css('color', textColor);
					$('.triple-map-title h2').css('color', textColor);
					$('.map-label h3, .map-label p').css('color', textColor);

				}

				// Special handling for text color
				if (colorType === 'text') {
					$('.map-preview-title h3, .map-preview-title p').css('color', selectedColor);
					$('.double-map-title h2').css('color', selectedColor);
					$('.triple-map-title h2').css('color', selectedColor);
					$('.map-label h3, .map-label p').css('color', selectedColor);
				}

				// V9.99.10: Box-Background-Color via CSS-var
				if (colorType === 'box') {
					document.documentElement.style.setProperty('--box-color', selectedColor);
				}

				// Set current style to 'custom' to preserve it across layout switches
				currentStyle = 'custom';

				// Clear previous timer
				if (customColorDebounceTimer) {
					clearTimeout(customColorDebounceTimer);
				}

				// Apply the color to the map after debounce (only on 'input' event)
				// For 'change' event (when user closes picker), apply immediately
				if (e.type === 'change') {
					applyCustomMapColors();
				} else {
					// Debounce for 'input' event (while dragging)
					customColorDebounceTimer = setTimeout(function() {
						applyCustomMapColors();
					}, 300);
				}
			}
		} else {
			// Handle style color
			// Remove current class from all color options
			$(this).closest('.elem__picker').find('a').removeClass('current');
			$customLink.addClass('current');

			// Determine which color section this is (outline, cover, border, custom)
			const $colorSection = $(this).closest('.color').parent().parent();
			const sectionTitle = $colorSection.find('p').first().text().trim();


			// Apply color based on section type
			if (sectionTitle.includes('Outline')) {
				$('.outline').css('fill', selectedColor);
			} else if (sectionTitle.includes('Cover')) {
				$('.cover').css('fill', selectedColor);
			} else if (sectionTitle.includes('Border')) {
				$('.bor').css('fill', selectedColor);
			} else if (sectionTitle.includes('Custom')) {
				$('.cust').css('fill', selectedColor);
			}
		}
	});

	// Helper function to extract marker icon type from HTML
	function extractMarkerIconType(markerHtml) {
		// Default to 'heart' if no marker or invalid HTML
		if (!markerHtml || typeof markerHtml !== 'string') {
			return 'heart';
		}

		// Try to detect icon type from the SVG HTML
		const lowerHtml = markerHtml.toLowerCase();

		if (lowerHtml.includes('house') || lowerHtml.includes('home')) {
			return 'house';
		} else if (lowerHtml.includes('star')) {
			return 'star';
		} else {
			return 'heart'; // Default
		}
	}

	// Helper function to generate UUID v4
	function generateUUID() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			const r = Math.random() * 16 | 0;
			const v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	// Function to generate poster and add to cart
	// Build configuration JSON for rendering
	// Used by both preview and final render
	window.buildConfigurationJSON = function() {
		// Get the actual Mapbox style URL from mapStyles mapping
		const styleUrl = mapStyles[currentStyle] || currentStyle;

		// Detect current shape from UI - use data-layout attribute for backend compatibility
		const selectedShapeText = $('.design__info .elem__picker:first ul li a.current').attr('data-layout') || $('.design__info .elem__picker:first ul li a.current').text().toLowerCase().trim();

		// Map frontend layout text to backend shape format
		let shapeType = 'square';
		if (selectedShapeText === 'circle') {
			shapeType = 'circle';
		} else if (selectedShapeText === 'heart') {
			shapeType = 'heart';
		} else if (selectedShapeText === 'square') {
			shapeType = 'square';
		}

		// Detect current font from UI
		const selectedFontElement = $('.font__picker .font-options li a.current, .font__picker .font-options-grid li a.current');
		const detectedFont = selectedFontElement.attr('data-font') || currentFont || 'Poppins';

		const config = {
			jobId: generateUUID(),
			layout: {
				type: isTripleMapLayout ? 'triple' : (isDoubleMapLayout ? 'double' : 'single'),
				shape: shapeType,
				layoutSelected: selectedShapeText
			},
			style: styleUrl,
			styleName: currentStyle,
			customColors: currentStyle === 'custom' ? customColors : null,
			maps: [],
			frame: {
				enabled: false
			},
			print: {
				width: 80,
				height: 60,
				dpi: 300,
				orientation: resizeType || 'landscape',
				format: 'PNG'
			},
			qualityPreset: 'ultra',
			ui: {
				shape: selectedShapeText,
				font: detectedFont,
				border: currentBorder, // 'with' or 'without' - for canvas border padding
				layoutType: isTripleMapLayout ? 'triple' : (isDoubleMapLayout ? 'double' : 'single')
			}
		};

		// Capture uploaded photo
		const photoPreviewImg = document.querySelector('.photo-preview img');
		// Priority: S3 URL > DOM base64 > global base64 variable
		if (uploadedPhotoUrl) {
			config.uploadedPhotoUrl = uploadedPhotoUrl;
			config.uploadedPhoto = null; // Clear base64 field
		} else if (photoPreviewImg && photoPreviewImg.src && photoPreviewImg.src.startsWith('data:image')) {
			config.uploadedPhoto = photoPreviewImg.src;
		} else if (uploadedPhotoData) {
			// Legacy fallback: base64 (deprecated)
			config.uploadedPhoto = uploadedPhotoData;
		} else {
			config.uploadedPhoto = null;
			config.uploadedPhotoUrl = null;
		}

		// Get selected size
		const selectedSize = $('.elem__picker .size__picker a.current .head p').text().trim();
		if (selectedSize) {
			const parsedSize = typeof parsePaperSize !== 'undefined'
				? parsePaperSize(selectedSize, resizeType)
				: null;

			if (parsedSize) {
				config.print.width = parsedSize.widthCm;
				config.print.height = parsedSize.heightCm;
			} else {
				const sizeMatch = selectedSize.match(/(\d+)\s*(?:cm)?\s*[xX×]\s*(\d+)\s*(?:cm)?/i);
				if (sizeMatch) {
					config.print.width = parseInt(sizeMatch[1]);
					config.print.height = parseInt(sizeMatch[2]);
				}
			}

			// Override DPI for specific sizes to stay within pixel limits
			const sizeSet = new Set([config.print.width, config.print.height]);
			if (sizeSet.has(60) && sizeSet.has(80)) {
				config.print.dpi = 250;
			} else if (sizeSet.has(70) && sizeSet.has(100)) {
				config.print.dpi = 200;  // 70x100cm: ~43 megapixels
			} else if (sizeSet.has(75) && sizeSet.has(100)) {
				config.print.dpi = 220;
			}
		}

		// Calculate pixel dimensions
		const widthInches = config.print.width / 2.54;
		const heightInches = config.print.height / 2.54;
		config.print.width_px = Math.floor(widthInches * config.print.dpi);
		config.print.height_px = Math.floor(heightInches * config.print.dpi);

		// Collect map data based on layout type
		if (isTripleMapLayout) {
			// Triple map layout — Marker aus mapMarkers['triple-1/2/3'] via collectMarkers
			const maps = [
				{ map: map1Triple, titleId: 'triple-large-text-1', subtitleId: 'triple-small-text-1', markerId: 'triple-1' },
				{ map: map2Triple, titleId: 'triple-large-text-2', subtitleId: 'triple-small-text-2', markerId: 'triple-2' },
				{ map: map3Triple, titleId: 'triple-large-text-3', subtitleId: 'triple-small-text-3', markerId: 'triple-3' }
			];

			maps.forEach((mapData) => {
				if (mapData.map) {
					const center = mapData.map.getCenter();
					const container = mapData.map.getContainer();
					const mapConfig = {
						center: [center.lng, center.lat],
						zoom: mapData.map.getZoom(),
						bounds: (() => {
							const b = mapData.map.getBounds();
							return {
								ne: [b.getNorthEast().lng, b.getNorthEast().lat],
								sw: [b.getSouthWest().lng, b.getSouthWest().lat]
							};
						})(),
						containerWidth: container ? container.offsetWidth : 640,
						containerHeight: container ? container.offsetHeight : 640,
						markers: collectMarkers(mapData.markerId),
						title: {
							enabled: true,
							largeText: document.getElementById(mapData.titleId)?.value || '',
							smallText: document.getElementById(mapData.subtitleId)?.value || '',
							font: detectedFont
						}
					};

					config.maps.push(mapConfig);
				}
			});

			config.mainTitle = document.getElementById('triple-map-main-title')?.value || '';
		} else if (isDoubleMapLayout) {
			// Double map layout — Marker aus mapMarkers['double-1/2'] via collectMarkers
			const maps = [
				{ map: map1, titleId: 'double-large-text-1', subtitleId: 'double-small-text-1', markerId: 'double-1' },
				{ map: map2, titleId: 'double-large-text-2', subtitleId: 'double-small-text-2', markerId: 'double-2' }
			];

			maps.forEach((mapData) => {
				if (mapData.map) {
					const center = mapData.map.getCenter();
					const container = mapData.map.getContainer();
					const mapConfig = {
						center: [center.lng, center.lat],
						zoom: mapData.map.getZoom(),
						bounds: (() => {
							const b = mapData.map.getBounds();
							return {
								ne: [b.getNorthEast().lng, b.getNorthEast().lat],
								sw: [b.getSouthWest().lng, b.getSouthWest().lat]
							};
						})(),
						containerWidth: container ? container.offsetWidth : 640,
						containerHeight: container ? container.offsetHeight : 640,
						markers: collectMarkers(mapData.markerId),
						title: {
							enabled: true,
							largeText: document.getElementById(mapData.titleId)?.value || '',
							smallText: document.getElementById(mapData.subtitleId)?.value || '',
							font: detectedFont
						}
					};

					config.maps.push(mapConfig);
				}
			});

			config.mainTitle = document.getElementById('double-main-title')?.value || '';
		} else {
			// Single map
			if (map) {
				const center = map.getCenter();
				const container = map.getContainer();
				const bounds = map.getBounds();
				console.log('📍 Capturing map bounds for render:', {
					ne: [bounds.getNorthEast().lng, bounds.getNorthEast().lat],
					sw: [bounds.getSouthWest().lng, bounds.getSouthWest().lat]
				});
				const mapConfig = {
					center: [center.lng, center.lat],
					zoom: map.getZoom(),
					bounds: {
						ne: [bounds.getNorthEast().lng, bounds.getNorthEast().lat],
						sw: [bounds.getSouthWest().lng, bounds.getSouthWest().lat]
					},
					containerWidth: container ? container.offsetWidth : 800,
					containerHeight: container ? container.offsetHeight : 800,
					markers: collectMarkers('single'),
					title: {
						enabled: true,
						largeText: document.getElementById('map-title-input')?.value || '',
						smallText: document.getElementById('map-subtitle-input')?.value || '',
						font: detectedFont
					}
				};

				config.maps.push(mapConfig);
			}
		}

		return config;
	};

	/* ==========================================================================================
	   PROJ-99 — Bearbeiten-Modus: gespeicherten Zustand auf den INTERAKTIVEN Editor anwenden
	   ==========================================================================================
	   Gegenstueck zu backendConfigSammeln(). Eingabe ist genau das Objekt, das beim Einlegen an
	   /api/v1/render/ ging (Server gibt es unter GET /api/v1/job-config/<uuid>/ zurueck).

	   Grundsatz: NICHT den Druckmodus nachbauen. `isPrintMode` bleibt false, die Print-Anwendung
	   (Z. 4763 ff.) baut die Seite zu einer Druckvorlage um — hier soll der Kunde weiter klicken
	   koennen. Stattdessen werden dieselben UI-Elemente ausgeloest, die der Kunde selbst
	   anklicken wuerde. Damit laufen alle bestehenden Folgewirkungen (Preise, Varianten-Event,
	   Rahmenbild, Seitenverhaeltnis, Stil-Nachladen) mit, und die Oberflaeche ZEIGT den Zustand
	   (aktive Kachel, Textarea-Inhalt) statt ihn nur an die Karte zu geben.

	   Reihenfolge ist nicht beliebig:
	     1. Ausrichtung + Groesse + Layout + Rand + Stil + Schrift  (diese Klicks bauen die Karte
	        teils neu auf — reinitializeMap() ist debounced und asynchron)
	     2. auf die neue Karte warten
	     3. Foto, Titel, Karten-Mitte/Zoom, Marker  (alles, was an der fertigen Karte haengt)

	   Rueckgabe: { angewendet: [...], fehlend: [...] }. `fehlend` sind Felder, die die Config
	   nicht hergab oder fuer die es keine Kachel gibt (alte Zeile, entfernte Option) — der
	   Aufrufer zeigt dann einen Hinweis, der Editor bleibt bedienbar.
	*/

	function dlWarte(ms) {
		return new Promise(function (aufloesen) { setTimeout(aufloesen, ms); });
	}

	/* Wartet, bis nach den Layout-/Groessen-Klicks wieder eine benutzbare Karte dasteht.
	   400 ms Vorlauf, weil der Groessen-Picker reinitializeMap() erst 300 ms nach dem Klick
	   ausloest (Debounce, Z. ~6440). */
	async function dlKarteBereit(maxMs) {
		const grenze = Date.now() + (maxMs || 12000);
		await dlWarte(400);
		while (Date.now() < grenze) {
			const aktiv = isTripleMapLayout ? map1Triple : (isDoubleMapLayout ? map1 : map);
			if (aktiv && !isReinitializing && typeof aktiv.loaded === 'function' && aktiv.loaded()) return true;
			await dlWarte(120);
		}
		return false;
	}

	/* Klickt eine Kachel, wenn sie existiert und nicht ohnehin schon aktiv ist.
	   Dieselbe Kachel steht oft mehrfach im DOM: die Groessen je Produktart (vier `.el__format`-
	   Behaelter, drei davon ausgeblendet) und die Schriften je Layout (Einzel-, Doppel-,
	   Dreifachkarte). Massgeblich ist die SICHTBARE — sonst meldet `hasClass('current')` den
	   Zustand einer ausgeblendeten Liste und der Klick bliebe aus. Ist gar nichts sichtbar
	   (der Picker liegt in einem zugeklappten Tab), gilt der erste Treffer; sein Klick-Handler
	   synchronisiert die uebrigen Listen ohnehin. */
	function dlKachelWaehlen($kachel) {
		if (!$kachel || $kachel.length === 0) return false;
		const $sichtbar = $kachel.filter(':visible');
		const $ziel = $sichtbar.length ? $sichtbar.eq(0) : $kachel.eq(0);
		if (!$ziel.hasClass('current')) $ziel.trigger('click');
		return true;
	}

	/* Config-Werte landen in jQuery-Selektoren. Sie kommen zwar vom eigenen Server, sind aber
	   Kundendaten (Stilname, Schrift, Rahmenfarbe) — ein Anfuehrungszeichen darin wuerde den
	   Selektor sprengen. CSS.escape gibt es in allen Zielbrowsern; der Ersatz deckt nur den
	   Fall ab, dass es ihn doch nicht gibt. */
	function dlSelektorWert(wert) {
		const text = String(wert == null ? '' : wert);
		if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') return CSS.escape(text);
		return text.replace(/["'\\\]]/g, '\\$&');
	}

	/* Setzt ein Textfeld und loest die Handler aus, die daran haengen (Poster-Titel, Vorschau,
	   Zeichenzaehler). .val() allein feuert kein Ereignis — genau die Falle, die im
	   Preset-Pfad (Z. ~535) schon einmal kommentiert wurde. */
	function dlTextSetzen(id, wert) {
		const feld = document.getElementById(id);
		if (!feld) return false;
		feld.value = wert == null ? '' : String(wert);
		$(feld).trigger('input').trigger('change');
		return true;
	}

	window.konfigurationAnwenden = async function (config) {
		const angewendet = [];
		const fehlend = [];
		if (!config || typeof config !== 'object') {
			return { angewendet: angewendet, fehlend: ['config'] };
		}

		const karten = Array.isArray(config.maps) ? config.maps : [];
		const druck = config.print || {};
		const ui = config.ui || {};

		/* ---- 1. Ausrichtung (portrait | landscape | square) -------------------------------- */
		const ausrichtung = config.resizeType || druck.orientation || null;
		if (ausrichtung) {
			if (dlKachelWaehlen($('.elem__picker .type__switcher li a[data-type="' + dlSelektorWert(ausrichtung) + '"]'))) {
				angewendet.push('resizeType');
			} else {
				fehlend.push('resizeType');
			}
		} else {
			fehlend.push('resizeType');
		}

		/* ---- 2. Groesse ------------------------------------------------------------------- */
		/* Verglichen wird nicht der Text, sondern das, was parsePaperSize aus dem
		   data-size-Attribut macht — derselbe Weg, den backendConfigSammeln() geht. Die
		   Beschriftung dreht sich bei Querformat (updateSizePickerDisplay), das Attribut nicht. */
		if (druck.width && druck.height) {
			const gesucht = [Number(druck.width), Number(druck.height)].sort(function (a, b) { return a - b; }).join('x');
			let treffer = null;
			$('.size__picker a[data-size]').each(function () {
				if (treffer) return;
				const roh = $(this).attr('data-size');
				const geparst = (typeof parsePaperSize !== 'undefined') ? parsePaperSize(roh, ausrichtung || 'portrait') : null;
				if (!geparst) return;
				const paar = [Number(geparst.widthCm), Number(geparst.heightCm)].sort(function (a, b) { return a - b; }).join('x');
				if (paar === gesucht) treffer = $(this);
			});
			if (treffer) {
				dlKachelWaehlen(treffer);
				angewendet.push('print.width/height');
			} else {
				fehlend.push('print.width/height');
			}
		} else {
			fehlend.push('print.width/height');
		}

		/* ---- 3. Layout-Form bzw. Doppel-/Dreifachkarte ------------------------------------ */
		/* `layoutSelected` traegt beides: die Form der Einzelkarte (square, circle, heart,
		   with photo, valentine, verlauf, box) UND die Mehrkarten-Layouts (double map,
		   triple map) — es ist der data-layout-Wert der aktiven Kachel. */
		const layoutGewaehlt = config.layoutSelected || (config.layout && config.layout.layoutSelected) || ui.shape || null;
		if (layoutGewaehlt) {
			const $layout = $('.design__info .elem__picker:first ul li a[data-layout="' + dlSelektorWert(layoutGewaehlt) + '"]');
			if (dlKachelWaehlen($layout)) angewendet.push('layoutSelected');
			else fehlend.push('layoutSelected');
		} else {
			fehlend.push('layoutSelected');
		}

		/* ---- 4. Rand ---------------------------------------------------------------------- */
		const rand = config.border || ui.border || null;
		if (rand) {
			if (dlKachelWaehlen($('.border__picker .border-options li a[data-border="' + dlSelektorWert(rand) + '"]'))) angewendet.push('border');
			else fehlend.push('border');
		} else {
			fehlend.push('border');
		}

		/* ---- 5. Kartenstil ---------------------------------------------------------------- */
		const stil = config.styleName || null;
		if (stil) {
			const $stil = $('.elem__picker ul li a[data-style="' + dlSelektorWert(stil) + '"]');
			if (dlKachelWaehlen($stil)) {
				angewendet.push('styleName');
				/* Eigene Farben NACH dem Klick setzen: der Klick-Handler liest die Farben aus der
				   aktuellen Karte und ueberschreibt customColors (Z. ~6705) — davor gesetzte
				   Werte waeren weg. */
				if (stil === 'custom' && config.customColors && typeof config.customColors === 'object') {
					Object.keys(config.customColors).forEach(function (schluessel) {
						customColors[schluessel] = config.customColors[schluessel];
						if (typeof customColorsChanged !== 'undefined' && customColorsChanged.add) customColorsChanged.add(schluessel);
					});
					if (config.baseStyleForCustom) baseStyleForCustom = config.baseStyleForCustom;
					if (typeof updateColorPickerUI === 'function') updateColorPickerUI();
					if (typeof applyCustomMapColors === 'function') applyCustomMapColors();
					angewendet.push('customColors');
				}
			} else {
				fehlend.push('styleName');
			}
		} else {
			fehlend.push('styleName');
		}

		/* ---- 6. Schrift ------------------------------------------------------------------- */
		const schrift = ui.font || (karten[0] && karten[0].title && karten[0].title.font) || null;
		if (schrift) {
			const $schrift = $('.font__picker .font-options li a[data-font="' + dlSelektorWert(schrift) + '"], .font__picker .font-options-grid li a[data-font="' + dlSelektorWert(schrift) + '"]');
			if (dlKachelWaehlen($schrift)) angewendet.push('ui.font');
			else fehlend.push('ui.font');
		} else {
			fehlend.push('ui.font');
		}

		/* ---- 7. Foto ---------------------------------------------------------------------- */
		/* Das Bild liegt bereits im Bucket — es wird NICHT neu hochgeladen, nur die Adresse
		   uebernommen (Spec: „Rueckladen darf das Foto nicht erneut hochladen muessen"). */
		if (config.uploadedPhotoUrl) {
			uploadedPhotoUrl = config.uploadedPhotoUrl;
			uploadedPhotoData = null;
			angewendet.push('uploadedPhotoUrl');
		} else if (config.uploadedPhoto) {
			uploadedPhotoData = config.uploadedPhoto;
			uploadedPhotoUrl = null;
			angewendet.push('uploadedPhoto');
		}
		if (config.uploadedPhotoUrl || config.uploadedPhoto) {
			if (typeof syncPhotoUploadSectionVisibility === 'function') syncPhotoUploadSectionVisibility();
			/* Die Foto-Flaeche wird beim Layout-Wechsel gezeichnet — nach dem Setzen der
			   Adresse noch einmal, damit sie das Foto statt des Mockups zeigt. */
			if (currentLayout === 'heart' && typeof showValentinePhotoInTitleArea === 'function') showValentinePhotoInTitleArea();
			else if (currentLayout === 'with-photo' && typeof showPhotoInTitleArea === 'function') showPhotoInTitleArea();
		}

		/* ---- 8. auf die neu aufgebaute Karte warten --------------------------------------- */
		const karteDa = await dlKarteBereit();
		if (!karteDa) fehlend.push('karte');

		/* ---- 9. Titel / Untertitel / Haupttitel ------------------------------------------- */
		const layoutTyp = (config.layout && config.layout.type) || ui.layoutType || 'single';
		if (layoutTyp === 'triple') {
			['1', '2', '3'].forEach(function (nr, i) {
				const k = karten[i];
				if (!k || !k.title) { fehlend.push('maps[' + i + '].title'); return; }
				dlTextSetzen('triple-large-text-' + nr, k.title.largeText);
				dlTextSetzen('triple-small-text-' + nr, k.title.smallText);
				angewendet.push('maps[' + i + '].title');
			});
			/* backendConfigSammeln() liest den Haupttitel aus #triple-map-main-title, im Markup
			   heisst das Feld aber #triple-main-title (Befund PROJ-99, Altbestand — deshalb ist
			   `mainTitle` bei Dreifachkarten immer leer). Beide werden gesetzt, damit der
			   Zustand sichtbar ist und ein spaeterer Fix nichts nachziehen muss. */
			if (config.mainTitle) {
				const gesetzt = dlTextSetzen('triple-main-title', config.mainTitle);
				dlTextSetzen('triple-map-main-title', config.mainTitle);
				if (gesetzt) angewendet.push('mainTitle'); else fehlend.push('mainTitle');
			}
		} else if (layoutTyp === 'double') {
			['1', '2'].forEach(function (nr, i) {
				const k = karten[i];
				if (!k || !k.title) { fehlend.push('maps[' + i + '].title'); return; }
				dlTextSetzen('double-large-text-' + nr, k.title.largeText);
				dlTextSetzen('double-small-text-' + nr, k.title.smallText);
				angewendet.push('maps[' + i + '].title');
			});
			if (config.mainTitle) {
				if (dlTextSetzen('double-main-title', config.mainTitle)) angewendet.push('mainTitle');
				else fehlend.push('mainTitle');
			}
		} else {
			const k = karten[0];
			if (k && k.title) {
				dlTextSetzen('map-title-input', k.title.largeText);
				dlTextSetzen('map-subtitle-input', k.title.smallText);
				angewendet.push('maps[0].title');
			} else {
				fehlend.push('maps[0].title');
			}
		}

		/* ---- 10. Karten-Mitte und Zoom ---------------------------------------------------- */
		/* jumpTo statt flyTo: kein Flug ueber den halben Globus, der Zustand soll sofort
		   dastehen. Bounds/containerWidth/containerHeight aus der Config werden bewusst NICHT
		   angewendet — die ergeben sich aus Mitte, Zoom und der aktuellen Containergroesse
		   und werden beim naechsten Einsammeln neu gemessen. */
		const kartenIds = layoutTyp === 'triple'
			? ['triple-1', 'triple-2', 'triple-3']
			: (layoutTyp === 'double' ? ['double-1', 'double-2'] : ['single']);

		kartenIds.forEach(function (kartenId, i) {
			const k = karten[i];
			const ziel = getMapForId(kartenId);
			if (!k || !ziel) { fehlend.push('maps[' + i + '].center'); return; }
			try {
				if (Array.isArray(k.center) && k.center.length >= 2) {
					ziel.jumpTo({ center: [Number(k.center[0]), Number(k.center[1])], zoom: Number(k.zoom) });
					angewendet.push('maps[' + i + '].center/zoom');
				} else {
					fehlend.push('maps[' + i + '].center');
				}
			} catch (e) {
				console.warn('[PROJ-99] Karte ' + kartenId + ' konnte nicht gesetzt werden:', e);
				fehlend.push('maps[' + i + '].center');
			}
		});

		/* ---- 11. Marker ------------------------------------------------------------------- */
		/* Erst leeren, dann aus der Config neu setzen — genau der Weg von
		   loadMapConfiguration() (localStorage), nur fuer alle Kartenplaetze. */
		kartenIds.forEach(function (kartenId, i) {
			const k = karten[i];
			if (!getMapForId(kartenId)) return;
			clearMarkers(kartenId);
			const liste = (k && Array.isArray(k.markers)) ? k.markers : [];
			liste.forEach(function (mk) {
				if (!mk || !Array.isArray(mk.coordinates)) return;
				markerSettings[kartenId].iconElement = mk.icon || null;
				markerSettings[kartenId].color = mk.color;
				markerSettings[kartenId].size = mk.size;
				addMarkerTo(kartenId, mk.coordinates);
			});
			if (liste.length) angewendet.push('maps[' + i + '].markers');
		});

		/* Marker-Schalter mitziehen: ohne ihn blieben die Marker-Felder zugeklappt, obwohl
		   Marker auf der Karte stehen. */
		if (karten[0] && Array.isArray(karten[0].markers) && karten[0].markers.length) {
			const $schalter = $('.details__wrapper .map__marker input[type="checkbox"], .markers__wrapper .map__marker input[type="checkbox"]');
			if ($schalter.length && !$schalter.prop('checked')) {
				$schalter.prop('checked', true);
				$('.details__wrapper .marker__info, .markers__wrapper .marker__info').show();
			}
			if (typeof renderMarkerList === 'function') renderMarkerList(kartenIds[0]);
		}

		return { angewendet: angewendet, fehlend: fehlend };
	};

	/* Produktart und Rahmenfarbe stehen NICHT in der Render-Config (der Server rendert das
	   Motiv, nicht das Produkt) — sie stehen als `_Product Type` / `_Frame Color` in der
	   Warenkorbzeile. Deshalb ein eigener, kleiner Schritt aus den Zeilen-Eigenschaften. */
	window.zeilenAngabenAnwenden = function (eigenschaften) {
		const angewendet = [];
		const fehlend = [];
		if (!eigenschaften) return { angewendet: angewendet, fehlend: ['zeile'] };

		const produktart = eigenschaften['_Product Type'];
		if (produktart) {
			/* Drei Wege, absichtlich in dieser Reihenfolge:
			   1. data-type — der saubere Wert aus dem Produkt (Option 1).
			   2. exakter Text der Kachel.
			   3. Text ohne das Abzeichen: `_Product Type` entsteht als
			      $('.tab__switcher ul li a.current').text().trim() und zieht damit auch die
			      Abzeichen-Beschriftung („Beliebt", „Premium") mit hinein — Altbestand, auf
			      den echte Warenkorbzeilen stehen. Deshalb wird normalisiert verglichen und
			      das Abzeichen als Praefix zugelassen. */
			const normal = t => String(t == null ? '' : t).replace(/\s+/g, ' ').trim();
			const gesucht = normal(produktart);
			let $tab = $('.tab__switcher ul li a[data-type="' + dlSelektorWert(produktart) + '"]');
			if ($tab.length === 0) {
				$tab = $('.tab__switcher ul li a').filter(function () { return normal($(this).text()) === gesucht; });
			}
			if ($tab.length === 0) {
				$tab = $('.tab__switcher ul li a').filter(function () {
					const rein = normal($(this).attr('data-type'));
					/* Das Abzeichen steht VOR dem Produktnamen, also reicht endsWith —
					   Gleichheit ist darin enthalten. */
					return !!rein && gesucht.endsWith(rein);
				});
			}
			if (dlKachelWaehlen($tab)) angewendet.push('_Product Type');
			else fehlend.push('_Product Type');
		}

		const rahmenfarbe = eigenschaften['_Frame Color'];
		if (rahmenfarbe) {
			if (dlKachelWaehlen($('.frame-picker ul li a[data-frame-color="' + dlSelektorWert(rahmenfarbe) + '"]'))) angewendet.push('_Frame Color');
			else fehlend.push('_Frame Color');
		}

		return { angewendet: angewendet, fehlend: fehlend };
	};

	/* PROJ-99: Zustand des Editors einsammeln — genau das Objekt, das beim Einlegen an
	   /api/v1/render/ geht und das der Server unter GET /api/v1/job-config/<uuid>/ wieder
	   herausgibt. Wortgleich aus generatePosterAndAddToCart herausgeloest (kein Wert geaendert),
	   damit der Bearbeiten-Modus ein Gegenstueck zu konfigurationAnwenden() hat und der
	   Round-Trip „anwenden -> sammeln" pruefbar wird.
	   Hinweis: window.buildConfigurationJSON() weiter oben ist der Vorschau-Pfad und weicht in
	   Details ab (kein Top-Level `border`, kein baseStyleForCustom). Die beiden zusammenzulegen
	   ist eine eigene Aufgabe — hier bleibt der Warenkorb-Pfad die Wahrheit. */
	window.backendConfigSammeln = function () {
		// Collect all configuration details
		// Get the actual Mapbox style URL from mapStyles mapping
		const styleUrl = mapStyles[currentStyle] || currentStyle;

		// Detect current shape from UI - use data-layout attribute for backend compatibility
		const selectedShapeText = $('.design__info .elem__picker:first ul li a.current').attr('data-layout') || $('.design__info .elem__picker:first ul li a.current').text().toLowerCase().trim();

		// Map frontend layout text to backend shape format
		let shapeType = 'square'; // Default
		if (selectedShapeText === 'circle') {
			shapeType = 'circle';
		} else if (selectedShapeText === 'heart') {
			shapeType = 'heart';
		} else if (selectedShapeText === 'square') {
			shapeType = 'square';
		}


		// Detect current font from UI (same pattern as shape detection)
		const selectedFontElement = $('.font__picker .font-options li a.current, .font__picker .font-options-grid li a.current');
		const detectedFont = selectedFontElement.attr('data-font') || currentFont || 'Poppins';

		const config = {
			layout: {
				type: isTripleMapLayout ? 'triple' : (isDoubleMapLayout ? 'double' : 'single'),
				shape: shapeType,
				layoutSelected: selectedShapeText
			},
			style: styleUrl, // Send actual Mapbox URL (e.g., mapbox://styles/mapbox/streets-v12)
		styleName: currentStyle, // Send style name (minimal, beachglass, etc.) for backend rendering
			customColors: currentStyle === 'custom' ? customColors : null,
				baseStyleForCustom: currentStyle === 'custom' ? baseStyleForCustom : null,
			maps: [],
			frame: {
				enabled: false // You can add frame detection if needed
			},
			border: currentBorder, // 'with' or 'without'
			print: {
				width: 80, // Will be updated with selected size below
				height: 60,
				dpi: 300, // High-quality 300 DPI for professional prints
				orientation: resizeType || 'landscape',
				format: 'PNG'
			},
			qualityPreset: 'ultra', // Force maximum quality for customer orders
			// UI configuration for backend to replicate exact frontend state
			ui: {
				shape: selectedShapeText, // 'square', 'circle', 'heart', 'valentine', 'with photo'
				font: detectedFont, // Font name to trigger selection
				layoutType: isTripleMapLayout ? 'triple' : (isDoubleMapLayout ? 'double' : 'single'),
				border: currentBorder // 'with' or 'without'
			}
		};

		// Capture uploaded photo if "With Photo" or "Valentine" frame is selected
		// Try DOM first, then fallback to global variable
		const photoPreviewImg = document.querySelector('.photo-preview img');

		// Priority: S3 URL > DOM base64 > global base64 variable
		if (uploadedPhotoUrl) {
			// Use S3 URL (preferred)
			config.uploadedPhotoUrl = uploadedPhotoUrl;
			config.uploadedPhoto = null; // Clear base64 field
		} else if (photoPreviewImg && photoPreviewImg.src && photoPreviewImg.src.startsWith('data:image')) {
			config.uploadedPhoto = photoPreviewImg.src; // Base64 data URL from DOM
		} else if (uploadedPhotoData) {
			// Legacy fallback: base64 (deprecated)
			config.uploadedPhoto = uploadedPhotoData;
		} else {
			config.uploadedPhoto = null;
			config.uploadedPhotoUrl = null;
		}

		// Get selected size
		const selectedSize = $('.elem__picker .size__picker a.current .head p').eq(0).text().trim();

		if (selectedSize) {
			// Use paper sizes parser to handle both standard sizes (A4, Letter) and custom dimensions
			const parsedSize = typeof parsePaperSize !== 'undefined'
				? parsePaperSize(selectedSize, resizeType)
				: null;

			if (parsedSize) {
				config.print.width = parsedSize.widthCm;
				config.print.height = parsedSize.heightCm;
			} else {
				// Fallback to manual parsing for custom dimensions
				const sizeMatch = selectedSize.match(/(\d+)\s*(?:cm)?\s*[xX×]\s*(\d+)\s*(?:cm)?/i);
				if (sizeMatch) {
					const num1 = parseInt(sizeMatch[1]);
					const num2 = parseInt(sizeMatch[2]);
					config.print.width = num1;
					config.print.height = num2;
				} else {
				}
			}

			// Override DPI for specific sizes to stay within pixel limits
			// Check both portrait and landscape orientations
			const sizeSet = new Set([config.print.width, config.print.height]);
			if (sizeSet.has(60) && sizeSet.has(80)) {
				config.print.dpi = 250;
			} else if (sizeSet.has(70) && sizeSet.has(100)) {
				config.print.dpi = 200;  // 70x100cm: ~43 megapixels
			} else if (sizeSet.has(75) && sizeSet.has(100)) {
				config.print.dpi = 220;
			}
		}

		// Collect map data based on layout type
		if (isTripleMapLayout) {
			// Triple map layout — Marker aus mapMarkers['triple-1/2/3'] via collectMarkers
			const maps = [
				{ map: map1Triple, titleId: 'triple-large-text-1', subtitleId: 'triple-small-text-1', markerId: 'triple-1' },
				{ map: map2Triple, titleId: 'triple-large-text-2', subtitleId: 'triple-small-text-2', markerId: 'triple-2' },
				{ map: map3Triple, titleId: 'triple-large-text-3', subtitleId: 'triple-small-text-3', markerId: 'triple-3' }
			];

			maps.forEach((mapData) => {
				if (mapData.map) {
					const center = mapData.map.getCenter();
					const container = mapData.map.getContainer();
					const bounds = mapData.map.getBounds();
					const mapConfig = {
						center: [center.lng, center.lat],
						zoom: mapData.map.getZoom(),
						bounds: {
							ne: [bounds.getNorthEast().lng, bounds.getNorthEast().lat],
							sw: [bounds.getSouthWest().lng, bounds.getSouthWest().lat]
						},
						containerWidth: container ? container.offsetWidth : 640,
						containerHeight: container ? container.offsetHeight : 640,
						markers: collectMarkers(mapData.markerId),
						title: {
							enabled: true,
							largeText: document.getElementById(mapData.titleId)?.value || '',
							smallText: document.getElementById(mapData.subtitleId)?.value || '',
							font: detectedFont
						}
					};

					// Add marker if exists
					config.maps.push(mapConfig);
				}
			});

		// Add main title for triple map layout
		config.mainTitle = document.getElementById('triple-map-main-title')?.value || '';
		} else if (isDoubleMapLayout) {
			// Double map layout — Marker aus mapMarkers['double-1/2'] via collectMarkers
			const maps = [
				{ map: map1, titleId: 'double-large-text-1', subtitleId: 'double-small-text-1', markerId: 'double-1' },
				{ map: map2, titleId: 'double-large-text-2', subtitleId: 'double-small-text-2', markerId: 'double-2' }
			];

			maps.forEach((mapData) => {
				if (mapData.map) {
					const center = mapData.map.getCenter();
					const container = mapData.map.getContainer();
					const bounds = mapData.map.getBounds();
					const mapConfig = {
						center: [center.lng, center.lat],
						zoom: mapData.map.getZoom(),
						bounds: {
							ne: [bounds.getNorthEast().lng, bounds.getNorthEast().lat],
							sw: [bounds.getSouthWest().lng, bounds.getSouthWest().lat]
						},
						containerWidth: container ? container.offsetWidth : 640,
						containerHeight: container ? container.offsetHeight : 640,
						markers: collectMarkers(mapData.markerId),
						title: {
							enabled: true,
							largeText: document.getElementById(mapData.titleId)?.value || '',
							smallText: document.getElementById(mapData.subtitleId)?.value || '',
							font: detectedFont
						}
					};

					// Add marker if exists
					config.maps.push(mapConfig);
				}
			});

		// Add main title for double map layout
		config.mainTitle = document.getElementById('double-main-title')?.value || '';
		} else {
			// Single map layout
			if (map) {
				const center = map.getCenter();
				const bounds = map.getBounds();

				// Get text from textarea inputs to preserve line breaks (\n)
				// Using textareas ensures newline characters are captured correctly
				const titleInput = document.getElementById('map-title-input');
				const subtitleInput = document.getElementById('map-subtitle-input');

				// Fallback to generic selectors if IDs not found
				const titleTextareas = document.querySelectorAll('.map__title .content textarea');

				const largeText = titleInput?.value || titleTextareas[0]?.value || '';
				const smallText = subtitleInput?.value || titleTextareas[1]?.value || '';

				// Get actual container dimensions for accurate zoom calculation
				const singleMapContainer = document.querySelector('#map') || document.querySelector('.mapboxgl-map');
				const actualContainerWidth = singleMapContainer ? singleMapContainer.offsetWidth : 640;
				const actualContainerHeight = singleMapContainer ? singleMapContainer.offsetHeight : 640;

				const mapConfig = {
					center: [center.lng, center.lat],
					zoom: map.getZoom(),
					bounds: {
						ne: [bounds.getNorthEast().lng, bounds.getNorthEast().lat],
						sw: [bounds.getSouthWest().lng, bounds.getSouthWest().lat]
					},
					containerWidth: actualContainerWidth, // Actual frontend container width
					containerHeight: actualContainerHeight, // Actual frontend container height
					markers: collectMarkers('single'),  // PROJ-25: inkl. size (fixt Alt-Bug: size fehlte im Druck)
					title: {
						enabled: true,
						largeText: largeText,
						smallText: smallText,
						font: detectedFont
					}
				};

				config.maps.push(mapConfig);
			}
		}


		// Use the same config structure as preview for consistency
		return {
			...config,
			layoutSelected: config.layout.layoutSelected,
			resizeType: $('ul.type__switcher li a.current').data('type').toLowerCase() || 'portrait'
		};
	};

	window.generatePosterAndAddToCart = async function(event) {
		event.preventDefault();

		/* PROJ-99 (I1): Solange cart-edit.js den gespeicherten Zustand laedt und anwendet, ist
		   der Knopf gesperrt. `pointer-events: none` haelt echte Klicks auf, aber nicht jeden
		   programmatischen — deshalb hier zusaetzlich die Flagge des Helfers abfragen. Ohne die
		   Sperre legte ein Klick in diesem Fenster den DEFAULT-Stand ein, und abschliessen()
		   raeumte danach die Zeile mit dem Kundenmotiv weg. */
		if (window.DLCartEdit && window.DLCartEdit.istGesperrt()) return;

		// Show loading indicator
		const cartBtn = event.target;
		const originalText = cartBtn.textContent;
		cartBtn.textContent = 'Wird vorbereitet...';
		cartBtn.style.pointerEvents = 'none';

		/* PROJ-99: Sobald der Bearbeiten-Abschluss gelaufen ist, gehoert der Knopf cart-edit.js.
		   Ohne dieses Merker-Flag setzt das finally unten `originalText` zurueck — und der ist im
		   Bearbeiten-Modus schon „Änderung übernehmen". Nach einem gescheiterten Abschluss stuende
		   dort also weiter „Änderung übernehmen", obwohl DLCartEdit bereits null ist: der naechste
		   Klick haette still eine dritte Zeile angelegt. */
		let bearbeitenAbschlussGelaufen = false;

		try {
			// Generate unique job ID for this render
			const jobId = generateUUID();

			// PROJ-99: Zustand einsammeln (Karte, Stil, Layout, Groesse, Titel, Foto, Marker).
			// Dieselbe Funktion nutzt der Bearbeiten-Modus als Gegenstueck zu konfigurationAnwenden().
			const backendConfig = backendConfigSammeln();
			// `config` war frueher das lokale Zwischenobjekt; backendConfig ist seine flache Kopie
			// (gleiche maps-/layout-/print-Referenzen), alle folgenden Lesezugriffe stimmen damit.
			const config = backendConfig;
			const selectedShapeText = backendConfig.layout.layoutSelected;
			const detectedFont = backendConfig.ui.font;
			const selectedSize = $('.elem__picker .size__picker a.current .head p').eq(0).text().trim();


			// Collect user selections for Shopify cart line item properties
			const selectedLayout = selectedShapeText; // e.g., 'square', 'circle', 'heart'
			const selectedStyle = currentStyle.replace('mapbox-',''); // e.g., 'minimal', 'beachglass', etc.
			const selectedFont = detectedFont;

			// Get print layout info
			const layoutType = config.layout.type; // 'single', 'double', 'triple'
			const orientation = config.print.orientation; // 'portrait', 'landscape'

			// Get selected product type (selectedSize already declared above)
			const selectedProductType = $('.tab__switcher ul li a.current').text().trim();

			// Create image URL using new API endpoint (redirects to actual image when ready)
			const imageUrl = `${API_BASE_URL}/api/v1/data/${jobId}/`;

			// Cart-Vorschau (PROJ-72, 08.08.): neuer Standard wie alle Editoren —
			// Sofort-Schnappschuss des KOMPLETTEN sichtbaren Posters (Karte +
			// Titel + Rahmen, nicht mehr nur der Karten-Canvas via S3) in
			// sessionStorage, plus persistente Server-Miniatur aus dem fertigen
			// Render (blanket_renders/<job>_cartpreview.jpg). Fail-soft.
			const previewImageUrl = `${API_BASE_URL}/media/blanket_renders/${jobId}_cartpreview.jpg`;
			try {
				cartBtn.textContent = 'Vorschau wird erstellt...';
				const posterEl = document.querySelector('.canvas__wrapper .inn') || document.querySelector('.canvas__wrapper');
				if (window.kaSofortVorschau && posterEl) {
					await window.kaSofortVorschau(posterEl, jobId);
				}
			} catch (e) {
				console.warn('Cart preview snapshot failed:', e);
				// Non-fatal — der Warenkorb faellt auf die Server-Miniatur zurueck
			}

			// Check if there's an uploaded photo
			const hasPhoto = config.uploadedPhoto ? 'Yes' : 'No';

			// Get selected frame color (only relevant for framed poster)
			const frameColorEl = document.querySelector('.frame-picker ul li a.current');
			const selectedFrameColor = frameColorEl ? (frameColorEl.getAttribute('data-frame-color') || '') : '';

			// Prepare line item properties for Shopify cart
			const properties = {
				'_Selected Layout': selectedLayout,
				'_Style': selectedStyle,
				'_Font': selectedFont,
				'_Print Layout': `${layoutType} - ${orientation}`,
				'_Product Type': selectedProductType,
				'_Size': selectedSize,
				'_Has Photo': hasPhoto,
				'_print_image_url': imageUrl,
				'_preview_image_url': previewImageUrl,
				'_job_id': jobId,
				// PROJ-99: Adresse dieser Editor-Seite, damit die Warenkorbzeile spaeter einen
				// „Bearbeiten"-Knopf zeigen kann. Nur der Pfad, ohne Query — der Bearbeiten-Modus
				// haengt seinen eigenen ?edit=<Zeilenschluessel> an, und Preset-/Kampagnen-
				// Parameter der Erstbestellung wuerden den geladenen Zustand ueberschreiben.
				'_editor_url': window.location.pathname
			};

			// Add frame color if framed poster is selected
			if (selectedFrameColor && selectedProductType.includes('Holzrahmen')) {
				properties['_Frame Color'] = selectedFrameColor;
			}

			// Add place name from first map
			if (config.maps.length > 0 && config.maps[0].title) {
				properties['_PLACE'] = config.maps[0].title.largeText || '';
			}

			// Add main title for double/triple layouts
			if (config.mainTitle) {
				properties['_Main Title'] = config.mainTitle;
			}

			// Add individual map titles and subtitles based on layout type
			if (layoutType === 'single' && config.maps.length > 0) {
				properties['_Map Title'] = config.maps[0].title?.largeText || '';
				properties['_Sub Title'] = config.maps[0].title?.smallText || '';
			} else if (layoutType === 'double' && config.maps.length >= 2) {
				properties['_Map 1 Title'] = config.maps[0].title?.largeText || '';
				properties['_Map 1 Subtitle'] = config.maps[0].title?.smallText || '';
				properties['_Map 2 Title'] = config.maps[1].title?.largeText || '';
				properties['_Map 2 Subtitle'] = config.maps[1].title?.smallText || '';
			} else if (layoutType === 'triple' && config.maps.length >= 3) {
				properties['_Map 1 Title'] = config.maps[0].title?.largeText || '';
				properties['_Map 1 Subtitle'] = config.maps[0].title?.smallText || '';
				properties['_Map 2 Title'] = config.maps[1].title?.largeText || '';
				properties['_Map 2 Subtitle'] = config.maps[1].title?.smallText || '';
				properties['_Map 3 Title'] = config.maps[2].title?.largeText || '';
				properties['_Map 3 Subtitle'] = config.maps[2].title?.smallText || '';
			}


			// Add jobId to backend config
			backendConfig.jobId = jobId;

			// Submit render job to backend API (async - will be processed in background)
			cartBtn.textContent = 'Bestellung wird übermittelt...';
			const submitResponse = await fetch(`${API_BASE_URL}/api/v1/render/`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(backendConfig)
			});

			if (!submitResponse.ok) {
				let errorMessage = 'Render-Auftrag konnte nicht gesendet werden';
				try {
					const error = await submitResponse.json();
					errorMessage = error.error || error.message || errorMessage;
				} catch (e) {
					errorMessage = `HTTP ${submitResponse.status}: ${submitResponse.statusText}`;
				}
				throw new Error(errorMessage);
			}

			const submitResult = await submitResponse.json();

			// Add to Shopify cart
			cartBtn.textContent = 'Wird zum Warenkorb hinzugefügt...';

			// Get product variant ID from the page/form
			const variantId = document.querySelector('[name="id"]')?.value ||
			                  window.currentVariantId ||
			                  document.querySelector('[data-product-variant-id]')?.dataset.productVariantId ||
			                  window.shopifyProductVariantId;

			if (!variantId) {
				throw new Error('Produktvariante nicht gefunden. Bitte wähle eine Variante aus.');
			}

			// Build Shopify cart add request
			const cartData = {
				items: [{
					id: variantId,
					quantity: 1,
					properties: properties
				}]
			};


			// Add to cart using Shopify Ajax API
			const cartResponse = await fetch((window.Shopify.routes.root || '/') + 'cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(cartData)
			});

			if (!cartResponse.ok) {
				let errorMsg = 'Artikel konnte nicht zum Warenkorb hinzugefügt werden';
				try {
					const errorData = await cartResponse.json();
					errorMsg = errorData.description || errorData.message || errorMsg;
				} catch (e) {
					errorMsg = await cartResponse.text();
				}
				throw new Error(errorMsg);
			}

			const cartResult = await cartResponse.json();

			// GTM dataLayer AddToCart Event
			if (window.DLTrack && window.DLTrack.addToCart) {
				window.DLTrack.addToCart(cartResult);
			}

			/* Dem Theme den VOLLEN Warenkorb melden (assets/cart-melden.js): die Antwort von
			   add.js allein liess Prestige in cart:change auflaufen (fehlende sections/items).
			   Ohne den Helfer bleibt es beim alten cart:refresh. */
			if (window.DLCartMelden) {
				window.DLCartMelden.nachAdd();
			} else {
				document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
			}

			// PROJ-99 Bearbeiten-Modus: die NEUE Zeile liegt jetzt im Warenkorb — erst danach
			// darf die alte weg (sonst waere der Warenkorb im Fehlerfall leer). abschliessen()
			// entfernt sie, beendet den Modus (Knopf wieder „In den Warenkorb", Adresse ohne
			// edit) und oeffnet den Drawer — nie die grosse Warenkorb-Seite (Dominik 12.09.).
			if (window.DLCartEdit && window.DLCartEdit.familie === 'citymap') {
				bearbeitenAbschlussGelaufen = true;
				cartBtn.textContent = 'Änderung wird übernommen...';
				/* PROJ-99 (C1): Die Antwort von /cart/add.js geht mit — nennt sie den Schluessel
				   der ALTEN Zeile, hat Shopify zusammengefuehrt und die Zeile darf nur gekuerzt,
				   nicht entfernt werden. Bei der Stadtkarte passiert das nie (jede neue Zeile
				   traegt eine frische Job-ID), der Helfer bekommt das Signal trotzdem: er ist
				   fuer alle zwoelf Editoren derselbe. */
				const uebernommen = await window.DLCartEdit.abschliessen(cartResult);
				if (uebernommen) {
					/* Der Helfer hat den Knopf schon auf seinen Originaltext gesetzt und
					   freigegeben. Kurze Bestaetigung wie beim normalen Einlegen, dann zurueck
					   auf den Originaltext (den der Helfer am Knopf hinterlegt hat). */
					const originaltextNachBearbeiten = cartBtn.dataset.dlOriginaltext || 'In den Warenkorb';
					cartBtn.textContent = '✓ Änderung übernommen!';
					setTimeout(() => {
						cartBtn.textContent = originaltextNachBearbeiten;
						cartBtn.style.pointerEvents = 'auto';
					}, 2000);
				}
				return;
			}

			// Open the cart drawer by finding and calling its show method
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer && typeof cartDrawer.show === 'function') {
				cartDrawer.show();
			}

			// Show success message
			cartBtn.textContent = '✓ Zum Warenkorb hinzugefügt!';

			setTimeout(() => {
				cartBtn.textContent = originalText;
				cartBtn.style.pointerEvents = 'auto';
			}, 2000);

			return; // Success!

		} catch (error) {

			// Provide more helpful error messages
			let errorMessage = error.message;
			if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
				errorMessage = 'Verbindung zum Server fehlgeschlagen. Bitte prüfe deine Internetverbindung und versuche es erneut.';
			}

			showToast('Fehler: ' + errorMessage);
		} finally {
			/* Restore button — ausser der Bearbeiten-Abschluss ist gelaufen. Dann hat entweder
			   der Seitenwechsel in den Warenkorb stattgefunden (Erfolg) oder cart-edit.js hat den
			   Knopf schon selbst freigegeben und auf seinen Originaltext zurueckgesetzt
			   (Fehlschlag). Beides duerfte `originalText` hier nicht ueberschreiben.

			   Gewaehltes Verhalten nach einem Fehlschlag: der Bearbeiten-Modus ist beendet, der
			   Knopf heisst wieder „In den Warenkorb" und legt bei einem weiteren Klick auch
			   genau das an — eine normale, zusaetzliche Zeile. Text und Wirkung passen damit
			   zusammen; der Hinweis sagt dem Kunden, dass die alte Version noch im Warenkorb
			   liegt. Die Alternative (Knopf sperren) wuerde den Editor einfrieren. */
			if (!bearbeitenAbschlussGelaufen) {
				cartBtn.textContent = originalText;
				cartBtn.style.pointerEvents = 'auto';
			}
		}
	};

	// Setup variant change listener
	document.addEventListener('variant:change', function(event) {
		if (!event.detail || !event.detail.variant) return;

		const variant = event.detail.variant;

		// Update price display
		const priceElement = document.querySelector('.variant-price');
		if (priceElement && variant.price) {
			let currencySymbol = '€';
			if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
				const currencySymbols = { 'EUR': '€', 'USD': '$', 'GBP': '£', 'CHF': 'CHF ' };
				currencySymbol = currencySymbols[window.Shopify.currency.active] || '€';
			}

			let amount;
			if (window.Shopify && window.Shopify.formatMoney) {
				amount = Shopify.formatMoney(variant.price, '{{amount_with_comma_separator}}');
			} else {
				amount = (variant.price / 100).toFixed(2).replace('.', ',');
			}

			// V9.96.5: Symbol HINTEN statt vorne (Euro-Format)
			priceElement.textContent = amount + ' ' + currencySymbol;
			priceElement.setAttribute('data-price', variant.price);
		}

		// Update hidden variant ID input
		let variantIdInput = document.querySelector('input[name="id"]');
		if (!variantIdInput) {
			const productForm = document.querySelector('form[action*="/cart/add"]');
			if (productForm) {
				variantIdInput = document.createElement('input');
				variantIdInput.type = 'hidden';
				variantIdInput.name = 'id';
				productForm.appendChild(variantIdInput);
			}
		}

		if (variantIdInput && variant.id) {
			variantIdInput.value = variant.id;
			variantIdInput.setAttribute('data-product-variant-id', variant.id);
			window.currentVariantId = variant.id;
		}
	});


	/* ==========================================================================================
	   PROJ-99 — Bearbeiten-Modus starten
	   ==========================================================================================
	   assets/cart-edit.js hat den Warenkorb schon gelesen (bzw. tut es gerade) und stellt den
	   Zustand ueber DLCartEdit.bereit bereit. Hier wird er auf den Editor angewendet, der Knopf
	   umbenannt — mehr nicht. Das Ersetzen selbst passiert erst beim Klick auf den Knopf, im
	   normalen Einlege-Pfad (siehe generatePosterAndAddToCart).

	   Kein ?edit= -> window.DLCartEdit ist null -> dieser Block tut nichts, der Editor verhaelt
	   sich exakt wie vorher. */
	(function bearbeitenModusStarten() {
		const bearbeiten = window.DLCartEdit;
		if (!bearbeiten) return;

		/* Einziger fest verdrahteter Text hier: die Meldung fuer eine unvollstaendige oder alte
		   Konfiguration (kein Shop-Text mit Theme-Einstellung). Die Meldung fuer eine Zeile aus
		   einer FREMDEN Familie steht seit der Final-Fix-Welle (I4) im Helfer — sie ist
		   wortgleich mit der der Schmuck-Editoren und soll es bleiben. */
		const HINWEIS_TEILWEISE = 'Einige Angaben konnten nicht übernommen werden.';

		/* PROJ-99 (I1): Knopf SOFORT sperren — vor dem Warten auf `bereit` und erst recht vor
		   konfigurationAnwenden(), das bis zu 12 s auf Karte, Stil und Schrift pollt. Bis dahin
		   zeigt der Editor den Default-Stand; ein Klick darauf legte genau den in den Warenkorb
		   und abschliessen() loeschte danach das Kundenmotiv. Freigegeben wird unten
		   (knopfAnpassen nach dem Anwenden) oder vom Helfer (knopfFreigeben, wenn der Modus
		   abbricht). */
		bearbeiten.knopfSperren(document.querySelector('.cart-btn'));

		bearbeiten.bereit.then(async function (config) {
			/* Der Helfer hat den Modus schon abgeschaltet (Zeile weg, Config nicht ladbar) und
			   seinen Hinweis gezeigt — hier bleibt nichts zu tun. */
			if (!config) return;

			if (bearbeiten.familie !== 'citymap') {
				/* Der Bearbeiten-Link zeigt auf diese Seite, die Zeile gehoert aber zu einer
				   anderen Editor-Familie. Lieber gar nicht anwenden als ein fremdes Motiv
				   ueberschreiben. */
				console.warn('[PROJ-99] Warenkorbzeile gehoert zur Familie "' + bearbeiten.familie + '", nicht zu citymap.');
				bearbeiten.hinweis(bearbeiten.HINWEIS_ANDERES_PRODUKT);
				/* I1: erst den Knopf zurueckgeben, dann den Modus abschalten — danach ist der
				   Helfer ueber window.DLCartEdit nicht mehr erreichbar. */
				bearbeiten.knopfFreigeben();
				window.DLCartEdit = null;
				return;
			}

			try {
				/* Produktart zuerst: sie filtert die verfuegbaren Groessen, danach erst greift
				   die Groessen-Kachel aus der Config. */
				const ausZeile = window.zeilenAngabenAnwenden(bearbeiten.line && bearbeiten.line.properties);
				const ausConfig = await window.konfigurationAnwenden(config);

				const fehlend = ausZeile.fehlend.concat(ausConfig.fehlend);
				if (fehlend.length) {
					console.warn('[PROJ-99] Nicht uebernommen:', fehlend.join(', '));
					bearbeiten.hinweis(HINWEIS_TEILWEISE);
				}

				bearbeiten.knopfAnpassen(document.querySelector('.cart-btn'));
				window.__dlBearbeitenErgebnis = { ausZeile: ausZeile, ausConfig: ausConfig };
			} catch (e) {
				/* Ein Fehler beim Anwenden darf den Editor nicht lahmlegen — er bleibt
				   bedienbar, nur eben mit dem, was schon gesetzt wurde. */
				console.error('[PROJ-99] Bearbeiten-Modus konnte nicht vollstaendig hergestellt werden:', e);
				bearbeiten.hinweis(HINWEIS_TEILWEISE);
				bearbeiten.knopfAnpassen(document.querySelector('.cart-btn'));
			}
		});
	})();
});

// ============================================
// Preview Tab Functions
// ============================================


/**
 * Generate preview thumbnail from backend
 * Uses dedicated /api/v1/preview/ endpoint with 50 DPI synchronous rendering
 */
async function generatePreviewThumbnail() {

	// Show loading state
	$('#preview-loading').show();
	$('#preview-thumbnail').hide();
	$('#preview-error').show().text('').hide();

	try {
		// Get current configuration
		const config = buildConfigurationJSON();

		// Override with preview DPI (72 for screen-quality preview)
		const previewConfig = {
			...config,
			print: {
				...config.print,
				dpi: 72
			}
		};

		// Recalculate pixel dimensions with preview DPI
		const widthInches = previewConfig.print.width / 2.54;
		const heightInches = previewConfig.print.height / 2.54;
		previewConfig.print.width_px = Math.floor(widthInches * 72);
		previewConfig.print.height_px = Math.floor(heightInches * 72);


		// Call dedicated preview endpoint
		const response = await fetch(`${API_BASE_URL}/api/v1/preview/`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(previewConfig)
		});

		if (!response.ok) {
			const errorData = await response.json().catch(() => null);
			throw new Error(errorData?.error || `Server returned ${response.status}`);
		}

		const result = await response.json();

		if (result.success && result.imageUrl) {
			// Image is ready immediately (synchronous rendering)
			$('#preview-loading').hide();
			$('#preview-thumbnail').attr('src', USE_LOCAL_SERVER ? result.imageUrl.replace(PRODUCTION_SERVER_URL, LOCAL_SERVER_URL):result.imageUrl + '?t=' + Date.now()).show();
			if (result.renderTime) {
			}
		} else {
			throw new Error(result.error || 'Vorschau konnte nicht erstellt werden');
		}

	} catch (error) {
		$('#preview-loading').hide();
		$('#preview-error').text('Vorschau konnte nicht erstellt werden: ' + error.message).show();
	}
}

/**
 * Refresh preview (called by button)
 */
function refreshPreview() {
	generatePreviewThumbnail();
}

/**
 * Show the print preview modal with server-rendered image
 * Called by "Druckvorschau anzeigen" button
 */
window.showPrintPreviewModal = async function(event) {
	if (event) event.preventDefault();

	const modal = document.getElementById('print-preview-modal');
	const spinner = modal.querySelector('.print-preview-modal__spinner');
	const image = modal.querySelector('.print-preview-modal__image');
	const errorEl = modal.querySelector('.print-preview-modal__error');
	const cartBtn = modal.querySelector('.print-preview-modal__btn-cart');

	// Reset state
	spinner.style.display = 'block';
	image.style.display = 'none';
	errorEl.style.display = 'none';
	cartBtn.style.pointerEvents = 'auto';
	cartBtn.textContent = cartBtn.dataset.originalText || cartBtn.textContent;

	// Show modal in top-layer (fixes iOS WebGL z-index)
	modal.showModal();
	document.body.style.overflow = 'hidden';

	try {
		// Build config and override with preview DPI
		const config = buildConfigurationJSON();
		const previewConfig = {
			...config,
			print: {
				...config.print,
				dpi: 72
			}
		};

		// Recalculate pixel dimensions at 72 DPI
		const widthInches = previewConfig.print.width / 2.54;
		const heightInches = previewConfig.print.height / 2.54;
		previewConfig.print.width_px = Math.floor(widthInches * 72);
		previewConfig.print.height_px = Math.floor(heightInches * 72);

		// Call preview endpoint
		const response = await fetch(`${API_BASE_URL}/api/v1/preview/`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(previewConfig)
		});

		if (!response.ok) {
			const errorData = await response.json().catch(() => null);
			throw new Error(errorData?.error || `Server returned ${response.status}`);
		}

		const result = await response.json();

		if (result.success && result.imageUrl) {
			const imageUrl = USE_LOCAL_SERVER
				? result.imageUrl.replace(PRODUCTION_SERVER_URL, LOCAL_SERVER_URL)
				: result.imageUrl + '?t=' + Date.now();

			// Preload image before showing
			const img = new Image();
			img.onload = function() {
				spinner.style.display = 'none';
				image.src = imageUrl;
				image.style.display = 'block';
			};
			img.onerror = function() {
				spinner.style.display = 'none';
				errorEl.style.display = 'block';
				errorEl.textContent = 'Bild konnte nicht geladen werden.';
			};
			img.src = imageUrl;

			// Store preview URL for cart (so it shows in cart as item image)
			window.citymapPreviewImageUrl = imageUrl;
		} else {
			throw new Error(result.error || 'Vorschau konnte nicht erstellt werden');
		}

	} catch (error) {
		spinner.style.display = 'none';
		errorEl.style.display = 'block';
		errorEl.textContent = 'Vorschau konnte nicht geladen werden: ' + error.message;
	}
};

/**
 * Close the print preview modal
 */
window.closePrintPreviewModal = function(event) {
	if (event) event.preventDefault();
	const modal = document.getElementById('print-preview-modal');
	modal.close();
	document.body.style.overflow = '';
};

/**
 * Confirm preview and add to cart (called from modal button)
 */
window.confirmAndAddToCart = async function(event) {
	event.preventDefault();

	// Close modal
	closePrintPreviewModal();

	// Trigger the original add-to-cart flow
	const cartBtn = document.querySelector('.cart-btn');
	if (cartBtn) {
		cartBtn.click();
	}
};

// Close modal on backdrop click
document.addEventListener('click', function(e) {
	if (e.target.classList.contains('print-preview-modal__backdrop')) {
		closePrintPreviewModal();
	}
});

// Close modal on Escape key
document.addEventListener('keydown', function(e) {
	if (e.key === 'Escape') {
		const modal = document.getElementById('print-preview-modal');
		if (modal && modal.style.display === 'flex') {
			closePrintPreviewModal();
		}
	}
});


// ============================================
// Produkt-Typ-Konfiguration (PROJ-24: aus sections/citymap.liquid Inline-<script> verlagert)
// Liest window.productTypeConfig — wird im Section-Template als reiner Datenblock gesetzt.
// ============================================
  // Helper function to get type config by Shopify type name
  window.getTypeConfigByName = function(typeName) {
    for (let key in window.productTypeConfig) {
      if (window.productTypeConfig[key].mapping === typeName) {
        return { id: key, config: window.productTypeConfig[key] };
      }
    }
    return null;
  };

  // Helper function to calculate delivery date range
  window.calculateDeliveryDates = function(minDays, maxDays) {
    const today = new Date();
    const startDate = new Date(today);
    startDate.setDate(today.getDate() + minDays);
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + maxDays);

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const startMonth = months[startDate.getMonth()];
    const endMonth = months[endDate.getMonth()];
    const startDay = startDate.getDate();
    const endDay = endDate.getDate();

    if (startMonth === endMonth) {
      return startMonth + ' ' + startDay + '-' + endDay;
    } else {
      return startMonth + ' ' + startDay + '-' + endMonth + ' ' + endDay;
    }
  };

  // Update product type information (delivery dates, descriptions, frame picker)
  window.updateProductTypeInfo = function(typeId) {
    const config = window.productTypeConfig['type' + typeId];
    if (!config) {
      console.warn('No configuration found for type', typeId);
      return;
    }

    // Update delivery dates for this type
    const deliveryDateStr = window.calculateDeliveryDates(config.deliveryMin, config.deliveryMax);
    const $deliveryElements = $('.delivery-date[data-type-id="' + typeId + '"], #preview-delivery');
    $deliveryElements.text(deliveryDateStr);

    // Update product descriptions for this type
    const $descriptionList = $('.product-description[data-type-id="' + typeId + '"]');
    $descriptionList.empty();

    // SVG checkmark for list items (except first type which has no checkmarks)
    const checkmark = '<svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3.83343 6.34989L9.19543 0.987305L10.0208 1.81214L3.83343 7.99956L0.121094 4.28722L0.945927 3.46239L3.83343 6.34989Z" fill="black"></path></svg> ';

    config.descriptions.forEach(function(desc, index) {
      if (desc) {
        const $li = $('<li></li>');
        if (typeId > 1) {
          $li.html(checkmark + desc);
        } else {
          $li.text(desc);
        }
        $descriptionList.append($li);
      }
    });

    // Show/hide frame picker based on configuration
    const $framePicker = $('.frame-picker[data-type-id="' + typeId + '"]');
    if (config.showFramePicker) {
      $framePicker.show();
    } else {
      $framePicker.hide();
    }
  };

  // Initialize product type info on page load
  $(document).ready(function() {
    // Initialize all product types
    for (let i = 1; i <= 4; i++) {
      window.updateProductTypeInfo(i);
    }

    // Update frame visibility based on initial product type
    if (typeof updateFrameImage === 'function') {
      updateFrameImage();
    }
  });
